export const PersonIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.416 11.3333C31.416 16.5363 27.2023 20.75 21.9993 20.75C16.7964 20.75 12.5827 16.5363 12.5827 11.3333C12.5827 6.13035 16.7964 1.91666 21.9993 1.91666C27.2023 1.91666 31.416 6.13035 31.416 11.3333ZM1.91602 38C1.91602 36.6858 2.56444 35.4421 3.84588 34.2594C5.13582 33.0689 6.98214 32.0264 9.12752 31.167C13.4203 29.4473 18.5956 28.5833 21.9993 28.5833C25.4031 28.5833 30.5784 29.4473 34.8712 31.167C37.0166 32.0264 38.8629 33.0689 40.1528 34.2594C41.4343 35.4421 42.0827 36.6858 42.0827 38V42.0833H1.91602V38Z"
        stroke="black"
        strokeWidth="2.5"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg
      style={{ border: 0 }}
      width="20"
      height="20"
      viewBox="0 0 352 277"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75.4286 176.286C75.4286 169.345 72.9732 163.42 68.0625 158.509C63.1518 153.598 57.2262 151.143 50.2857 151.143C43.3452 151.143 37.4196 153.598 32.5089 158.509C27.5982 163.42 25.1429 169.345 25.1429 176.286C25.1429 183.226 27.5982 189.152 32.5089 194.062C37.4196 198.973 43.3452 201.428 50.2857 201.428C57.2262 201.428 63.1518 198.973 68.0625 194.062C72.9732 189.152 75.4286 183.226 75.4286 176.286ZM113.143 88.2856C113.143 81.3452 110.687 75.4196 105.777 70.5089C100.866 65.5981 94.9405 63.1428 88 63.1428C81.0595 63.1428 75.1339 65.5981 70.2232 70.5089C65.3125 75.4196 62.8571 81.3452 62.8571 88.2856C62.8571 95.2261 65.3125 101.152 70.2232 106.062C75.1339 110.973 81.0595 113.428 88 113.428C94.9405 113.428 100.866 110.973 105.777 106.062C110.687 101.152 113.143 95.2261 113.143 88.2856ZM197.214 182.768L217.054 107.732C217.839 104.327 217.348 101.152 215.58 98.2053C213.812 95.2588 211.292 93.3273 208.018 92.4106C204.744 91.494 201.601 91.9196 198.589 93.6874C195.577 95.4553 193.613 98.0416 192.696 101.446L172.857 176.482C165 177.137 157.994 179.985 151.839 185.027C145.685 190.068 141.56 196.518 139.464 204.375C136.845 214.458 138.155 224.018 143.393 233.053C148.631 242.089 156.292 247.917 166.375 250.536C176.458 253.155 186.018 251.845 195.054 246.607C204.089 241.369 209.917 233.708 212.536 223.625C214.631 215.768 214.238 208.107 211.357 200.643C208.476 193.178 203.762 187.22 197.214 182.768ZM326.857 176.286C326.857 169.345 324.402 163.42 319.491 158.509C314.58 153.598 308.655 151.143 301.714 151.143C294.774 151.143 288.848 153.598 283.937 158.509C279.027 163.42 276.571 169.345 276.571 176.286C276.571 183.226 279.027 189.152 283.937 194.062C288.848 198.973 294.774 201.428 301.714 201.428C308.655 201.428 314.58 198.973 319.491 194.062C324.402 189.152 326.857 183.226 326.857 176.286ZM201.143 50.5714C201.143 43.6309 198.687 37.7053 193.777 32.7946C188.866 27.8839 182.94 25.4285 176 25.4285C169.06 25.4285 163.134 27.8839 158.223 32.7946C153.312 37.7053 150.857 43.6309 150.857 50.5714C150.857 57.5118 153.312 63.4374 158.223 68.3481C163.134 73.2589 169.06 75.7142 176 75.7142C182.94 75.7142 188.866 73.2589 193.777 68.3481C198.687 63.4374 201.143 57.5118 201.143 50.5714ZM289.143 88.2856C289.143 81.3452 286.687 75.4196 281.777 70.5089C276.866 65.5981 270.94 63.1428 264 63.1428C257.06 63.1428 251.134 65.5981 246.223 70.5089C241.312 75.4196 238.857 81.3452 238.857 88.2856C238.857 95.2261 241.312 101.152 246.223 106.062C251.134 110.973 257.06 113.428 264 113.428C270.94 113.428 276.866 110.973 281.777 106.062C286.687 101.152 289.143 95.2261 289.143 88.2856ZM352 176.286C352 210.464 342.768 242.089 324.304 271.161C321.815 274.958 318.28 276.857 313.696 276.857H38.3036C33.7202 276.857 30.1845 274.958 27.6964 271.161C9.23214 242.22 0 210.595 0 176.286C0 152.452 4.64881 129.667 13.9464 107.928C23.244 86.1904 35.75 67.4642 51.4643 51.7499C67.1786 36.0356 85.9048 23.5297 107.643 14.2321C129.381 4.93445 152.167 0.285645 176 0.285645C199.833 0.285645 222.619 4.93445 244.357 14.2321C266.095 23.5297 284.821 36.0356 300.536 51.7499C316.25 67.4642 328.756 86.1904 338.054 107.928C347.351 129.667 352 152.452 352 176.286Z"
        fill="black"
      />
    </svg>
  );
};

export const CalanderIcon = () => {
  return (
    <svg
      style={{ border: 0 }}
      width="20"
      height="20"
      viewBox="0 0 249 285"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 258.281C0 273.032 11.9498 285 26.6786 285H222.321C237.05 285 249 273.032 249 258.281V106.875H0V258.281ZM177.857 149.18C177.857 145.506 180.858 142.5 184.527 142.5H206.759C210.427 142.5 213.429 145.506 213.429 149.18V171.445C213.429 175.119 210.427 178.125 206.759 178.125H184.527C180.858 178.125 177.857 175.119 177.857 171.445V149.18ZM177.857 220.43C177.857 216.756 180.858 213.75 184.527 213.75H206.759C210.427 213.75 213.429 216.756 213.429 220.43V242.695C213.429 246.369 210.427 249.375 206.759 249.375H184.527C180.858 249.375 177.857 246.369 177.857 242.695V220.43ZM106.714 149.18C106.714 145.506 109.716 142.5 113.384 142.5H135.616C139.284 142.5 142.286 145.506 142.286 149.18V171.445C142.286 175.119 139.284 178.125 135.616 178.125H113.384C109.716 178.125 106.714 175.119 106.714 171.445V149.18ZM106.714 220.43C106.714 216.756 109.716 213.75 113.384 213.75H135.616C139.284 213.75 142.286 216.756 142.286 220.43V242.695C142.286 246.369 139.284 249.375 135.616 249.375H113.384C109.716 249.375 106.714 246.369 106.714 242.695V220.43ZM35.5714 149.18C35.5714 145.506 38.5728 142.5 42.2411 142.5H64.4732C68.1415 142.5 71.1429 145.506 71.1429 149.18V171.445C71.1429 175.119 68.1415 178.125 64.4732 178.125H42.2411C38.5728 178.125 35.5714 175.119 35.5714 171.445V149.18ZM35.5714 220.43C35.5714 216.756 38.5728 213.75 42.2411 213.75H64.4732C68.1415 213.75 71.1429 216.756 71.1429 220.43V242.695C71.1429 246.369 68.1415 249.375 64.4732 249.375H42.2411C38.5728 249.375 35.5714 246.369 35.5714 242.695V220.43ZM222.321 35.625H195.643V8.90625C195.643 4.00781 191.641 0 186.75 0H168.964C164.073 0 160.071 4.00781 160.071 8.90625V35.625H88.9286V8.90625C88.9286 4.00781 84.9268 0 80.0357 0H62.25C57.3589 0 53.3571 4.00781 53.3571 8.90625V35.625H26.6786C11.9498 35.625 0 47.5928 0 62.3438V89.0625H249V62.3438C249 47.5928 237.05 35.625 222.321 35.625Z"
        fill="black"
      />
    </svg>
  );
};

export const PersonFillIcon = () => {
  return (
    <svg
      style={{ border: 0 }}
      width="20"
      height="20"
      viewBox="0 0 274 274"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M137 154.125C179.545 154.125 214.062 119.607 214.062 77.0625C214.062 34.5176 179.545 0 137 0C94.4551 0 59.9375 34.5176 59.9375 77.0625C59.9375 119.607 94.4551 154.125 137 154.125ZM205.5 171.25H176.013C164.132 176.709 150.914 179.812 137 179.812C123.086 179.812 109.921 176.709 97.9871 171.25H68.5C30.6645 171.25 0 201.914 0 239.75V248.312C0 262.494 11.5059 274 25.6875 274H248.312C262.494 274 274 262.494 274 248.312V239.75C274 201.914 243.336 171.25 205.5 171.25Z"
        fill="black"
      />
    </svg>
  );
};

export const OptionsIcon = () => {
  return (
    <svg
      style={{ border: 0 }}
      width="20"
      height="20"
      viewBox="0 0 289 225"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8333 32.7084C25.6468 32.7084 32.7917 25.5636 32.7917 16.7501C32.7917 7.93661 25.6468 0.791748 16.8333 0.791748C8.01986 0.791748 0.875 7.93661 0.875 16.7501C0.875 25.5636 8.01986 32.7084 16.8333 32.7084ZM16.8333 128.458C25.6468 128.458 32.7917 121.314 32.7917 112.5C32.7917 103.686 25.6468 96.5418 16.8333 96.5418C8.01986 96.5418 0.875 103.686 0.875 112.5C0.875 121.314 8.01986 128.458 16.8333 128.458ZM32.7917 208.25C32.7917 217.064 25.6468 224.208 16.8333 224.208C8.01986 224.208 0.875 217.064 0.875 208.25C0.875 199.436 8.01986 192.292 16.8333 192.292C25.6468 192.292 32.7917 199.436 32.7917 208.25ZM80.6667 0.791748C71.8532 0.791748 64.7083 7.93661 64.7083 16.7501C64.7083 25.5636 71.8532 32.7084 80.6667 32.7084H272.167C280.98 32.7084 288.125 25.5636 288.125 16.7501C288.125 7.93661 280.98 0.791748 272.167 0.791748H80.6667ZM64.7083 112.5C64.7083 103.686 71.8532 96.5418 80.6667 96.5418H272.167C280.98 96.5418 288.125 103.686 288.125 112.5C288.125 121.314 280.98 128.458 272.167 128.458H80.6667C71.8532 128.458 64.7083 121.314 64.7083 112.5ZM80.6667 192.292C71.8532 192.292 64.7083 199.436 64.7083 208.25C64.7083 217.064 71.8532 224.208 80.6667 224.208H272.167C280.98 224.208 288.125 217.064 288.125 208.25C288.125 199.436 280.98 192.292 272.167 192.292H80.6667Z"
        fill="black"
      />
    </svg>
  );
};

export const InviteIcon = () => {
  return (
    <svg
      style={{ border: 0 }}
      width="20"
      height="20"
      viewBox="0 0 290 248"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M256.504 170.406V137.535H289.375V110.465H256.504V77.5938H229.434V110.465H196.562V137.535H229.434V170.406H256.504Z"
        fill="black"
      />
      <path
        d="M248.125 247.75C248.125 247.75 248.125 230.734 246.707 221.84C245.547 214.814 235.814 205.533 194.436 190.322C153.701 175.369 156.215 182.652 156.215 155.131C156.215 137.277 165.303 147.654 171.104 113.752C173.359 100.41 175.164 109.305 180.062 87.9062C182.641 76.6914 178.322 75.8535 178.838 70.5039C179.354 65.1543 179.869 60.3848 180.836 49.4277C181.996 35.8926 169.428 0.25 124.375 0.25C79.3223 0.25 66.7539 35.8926 67.9785 49.4922C68.9453 60.3848 69.4609 65.2188 69.9766 70.5684C70.4922 75.918 66.1738 76.7559 68.752 87.9707C73.6504 109.305 75.4551 100.41 77.7109 113.816C83.5117 147.719 92.5996 137.342 92.5996 155.195C92.5996 182.781 95.1133 175.498 54.3789 190.387C13 205.533 3.20312 214.879 2.10742 221.904C0.625 230.734 0.625 247.75 0.625 247.75H248.125Z"
        fill="black"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      style={{ marginLeft: "35px" }}
      width="15"
      height="15"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.793 8.68311H13.7617V1.65186C13.7617 0.789062 13.062 0.0893555 12.1992 0.0893555H10.6367C9.77393 0.0893555 9.07422 0.789062 9.07422 1.65186V8.68311H2.04297C1.18018 8.68311 0.480469 9.38281 0.480469 10.2456V11.8081C0.480469 12.6709 1.18018 13.3706 2.04297 13.3706H9.07422V20.4019C9.07422 21.2646 9.77393 21.9644 10.6367 21.9644H12.1992C13.062 21.9644 13.7617 21.2646 13.7617 20.4019V13.3706H20.793C21.6558 13.3706 22.3555 12.6709 22.3555 11.8081V10.2456C22.3555 9.38281 21.6558 8.68311 20.793 8.68311Z"
        fill="#787878"
      />
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 26 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5875 5.98292L4.58529 12.5736V19.6869C4.58529 19.8711 4.65845 20.0477 4.78868 20.178C4.91892 20.3082 5.09555 20.3814 5.27973 20.3814L10.1434 20.3688C10.327 20.3679 10.5028 20.2943 10.6322 20.1642C10.7617 20.034 10.8344 19.8579 10.8344 19.6743V15.5203C10.8344 15.3361 10.9076 15.1594 11.0378 15.0292C11.168 14.899 11.3447 14.8258 11.5289 14.8258H14.3066C14.4908 14.8258 14.6675 14.899 14.7977 15.0292C14.9279 15.1594 15.0011 15.3361 15.0011 15.5203V19.6713C15.0008 19.7627 15.0185 19.8532 15.0533 19.9377C15.0881 20.0222 15.1392 20.099 15.2037 20.1637C15.2682 20.2285 15.3449 20.2798 15.4293 20.3148C15.5137 20.3499 15.6042 20.3679 15.6955 20.3679L20.5575 20.3814C20.7417 20.3814 20.9183 20.3082 21.0486 20.178C21.1788 20.0477 21.252 19.8711 21.252 19.6869V12.5689L13.2515 5.98292C13.1575 5.90711 13.0403 5.86577 12.9195 5.86577C12.7987 5.86577 12.6815 5.90711 12.5875 5.98292V5.98292ZM25.2276 10.4625L21.5992 7.47164V1.45992C21.5992 1.32179 21.5443 1.18931 21.4466 1.09164C21.349 0.99396 21.2165 0.939087 21.0783 0.939087H18.6478C18.5097 0.939087 18.3772 0.99396 18.2795 1.09164C18.1818 1.18931 18.127 1.32179 18.127 1.45992V4.6114L14.2411 1.41435C13.8682 1.10748 13.4003 0.9397 12.9173 0.9397C12.4344 0.9397 11.9664 1.10748 11.5935 1.41435L0.606987 10.4625C0.554247 10.5061 0.510614 10.5597 0.478579 10.6201C0.446544 10.6806 0.426736 10.7468 0.420287 10.8149C0.413838 10.883 0.420874 10.9517 0.440994 11.0171C0.461113 11.0825 0.493921 11.1433 0.537543 11.196L1.64431 12.5415C1.68782 12.5944 1.74133 12.6382 1.80178 12.6704C1.86223 12.7026 1.92844 12.7225 1.99661 12.7291C2.06478 12.7357 2.13358 12.7288 2.19907 12.7087C2.26456 12.6886 2.32545 12.6559 2.37825 12.6123L12.5875 4.20341C12.6815 4.1276 12.7987 4.08625 12.9195 4.08625C13.0403 4.08625 13.1575 4.1276 13.2515 4.20341L23.4612 12.6123C23.5139 12.6559 23.5747 12.6887 23.6401 12.7088C23.7055 12.7289 23.7742 12.736 23.8423 12.7295C23.9104 12.7231 23.9766 12.7033 24.0371 12.6712C24.0975 12.6392 24.1511 12.5956 24.1947 12.5428L25.3014 11.1973C25.345 11.1443 25.3777 11.0832 25.3976 11.0175C25.4174 10.9518 25.4241 10.8829 25.4173 10.8146C25.4104 10.7463 25.3901 10.6801 25.3576 10.6196C25.3251 10.5592 25.2809 10.5058 25.2276 10.4625V10.4625Z"
        fill="black"
      />
    </svg>
  );
};

export const PatientInfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2vw"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -144) translate(42 144)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g fill="#59709B" fill-rule="nonzero">
              <path
                d="M7.702 7.102c1.689 0 3.069 1.322 3.162 2.987l.005.18v1.284c0 .331-.268.6-.6.6-.298 0-.545-.218-.592-.503l-.008-.097v-1.284c0-1.037-.802-1.887-1.82-1.962l-.147-.005H2.567c-1.037 0-1.887.802-1.962 1.82L.6 10.27v1.284c0 .331-.269.6-.6.6-.298 0-.546-.218-.592-.503l-.008-.097v-1.284C-.6 8.58.722 7.2 2.388 7.107l.18-.005h5.134zM5.135-.6C3.385-.6 1.967.818 1.967 2.567c0 1.75 1.418 3.168 3.168 3.168 1.749 0 3.167-1.418 3.167-3.168C8.302.818 6.884-.6 5.135-.6zm0 1.2c1.086 0 1.967.88 1.967 1.967 0 1.087-.88 1.968-1.967 1.968-1.087 0-1.968-.881-1.968-1.968C3.167 1.481 4.048.6 5.135.6z"
                transform="translate(8 7)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DscIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2vw"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -216) translate(42 216)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g stroke="#59709B" strokeWidth=".89">
              <g>
                <path
                  d="M7.262 2.136h2.136c.236 0 .428.191.428.427v10.253c0 .236-.192.427-.428.427H.854c-.236 0-.427-.191-.427-.427V2.563c0-.236.191-.427.427-.427H2.99"
                  transform="translate(8 6)"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5.98 1.282c0-.472-.382-.855-.854-.855-.471 0-.854.383-.854.855H2.99V2.99h4.272V1.282H5.981z"
                  transform="translate(8 6)"
                />
              </g>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.427 7.262L2.136 7.262 3.418 8.971 5.126 5.411 6.835 9.968 8.117 7.262 9.826 7.262"
                transform="translate(8 6)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const TestIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2vw"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -288) translate(42 288)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g
              fill="#59709B"
              fill-rule="nonzero"
              stroke="#59709B"
              strokeWidth=".5"
            >
              <path
                d="M11.91 11.552H1.466c-.417 0-.79-.215-1-.575-.208-.36-.21-.791-.003-1.153L4.56 3.415V.76c0-.168.136-.304.304-.304h3.648c.168 0 .304.136.304.304v2.655l4.097 6.41c.206.36.205.791-.005 1.152-.209.36-.582.575-.998.575zM5.168 1.064v2.432c0 .053-.013.105-.04.15l-4.136 6.48c-.098.17-.098.375.001.545.099.17.276.273.473.273H11.91c.197 0 .374-.102.473-.272.099-.17.1-.375.002-.546l-4.137-6.48c-.027-.045-.04-.097-.04-.15V1.064h-3.04z"
                transform="translate(6 7)"
              />
              <path
                d="M4.256.38c-.167 0-.304.137-.304.304 0 .167.137.304.304.304H9.12c.167 0 .304-.137.304-.304 0-.167-.137-.304-.304-.304H4.256zM10.336 6.688H3.04c-.168 0-.304-.136-.304-.304 0-.168.136-.304.304-.304h7.296c.168 0 .304.136.304.304 0 .168-.136.304-.304.304z"
                transform="translate(6 7)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const NotesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2vw"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -360) translate(42 360)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g fill="#59709B" fill-rule="nonzero" stroke="#59709B">
              <path
                strokeWidth=".5"
                d="M14.111.609c-.006-.067-.038-.129-.09-.172-.05-.043-.117-.066-.183-.057l-8.5.757L2.237.634c-.134-.023-.263.068-.288.204L.004 11.548c-.012.066.004.135.042.19.04.056.099.093.166.103l2.74.445 5.912.958 3.012.487c.013.002.027.004.04.004.12 0 .226-.086.248-.207l.146-.806 2.582-.249c.138-.013.239-.135.227-.272L14.111.609zm-.48.295l.139 1.599-6.416-1.04L13.63.904zm-1.919 12.29L.546 11.384 2.4 1.172l11.166 1.81-1.854 10.213zm.691-.987l1.494-8.231.698 8.02-2.192.21z"
                transform="rotate(-10 51.005 -23.79)"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.045 4.591L10.281 5.691M3.611 7.055L7.483 7.738"
                transform="rotate(-10 51.005 -23.79)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BodyChartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -432) translate(42 432)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g
              fill="#59709B"
              fill-rule="nonzero"
              stroke="#59709B"
              strokeWidth=".35"
            >
              <path
                d="M3.811 4.808c1.147 0 2.08-.933 2.08-2.079C5.89 1.583 4.957.65 3.81.65c-1.146 0-2.079.933-2.079 2.079 0 1.146.933 2.079 2.08 2.079zm0-3.465c.765 0 1.386.622 1.386 1.386 0 .764-.621 1.386-1.386 1.386-.764 0-1.386-.622-1.386-1.386 0-.765.622-1.386 1.386-1.386zM7.04 8.135C6.907 6.98 5.995 6.107 4.917 6.107H2.705c-1.077 0-1.99.872-2.122 2.027L.009 10.78c-.045.396.077.789.335 1.078.237.265.556.41.899.41l.49 6.551c.014.181.164.322.346.322h3.465c.182 0 .332-.14.345-.321l.484-6.551h.007c.343 0 .662-.146.898-.41.258-.29.38-.682.335-1.08L7.04 8.136zm-.277 3.261c-.104.115-.239.18-.382.18h-.329c-.181 0-.332.14-.346.32l-.483 6.551h-2.82l-.484-6.552c-.014-.18-.164-.32-.346-.32h-.329c-.143 0-.278-.064-.382-.18-.126-.14-.185-.337-.162-.538l.573-2.644c.092-.806.709-1.413 1.434-1.413h2.212c.725 0 1.341.607 1.433 1.413l.574 2.644c.024.202-.036.397-.163.54z"
                transform="translate(10 3)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const InviteIcon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2vw"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -528) translate(42 528)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g fill="#59709B" fill-rule="nonzero">
              <g>
                <path
                  d="M7.373 6.773c1.628 0 2.96 1.273 3.052 2.878l.005.18v1.228c0 .332-.268.6-.6.6-.298 0-.545-.217-.592-.502l-.008-.098V9.83c0-.977-.754-1.778-1.712-1.852l-.145-.005H2.458c-.977 0-1.778.754-1.852 1.712L.6 9.83v1.23c0 .33-.269.6-.6.6-.298 0-.546-.218-.592-.503l-.008-.098V9.83c0-1.628 1.273-2.959 2.878-3.052l.18-.005h4.915zM4.915-.6C3.227-.6 1.858.769 1.858 2.458c0 1.688 1.369 3.057 3.057 3.057 1.689 0 3.058-1.369 3.058-3.057C7.973.768 6.603-.6 4.915-.6zm0 1.2c1.026 0 1.858.832 1.858 1.858 0 1.026-.832 1.857-1.858 1.857-1.026 0-1.857-.831-1.857-1.857S3.889.6 4.915.6z"
                  transform="translate(6 6) translate(0 1.92)"
                />
              </g>
              <g>
                <path
                  d="M2.523-.6c.298 0 .546.218.592.503L3.123 0v5.046c0 .331-.269.6-.6.6-.298 0-.546-.218-.592-.503l-.008-.097V0c0-.331.269-.6.6-.6z"
                  transform="translate(6 6) translate(10.56)"
                />
                <path
                  d="M5.046 1.923c.331 0 .6.269.6.6 0 .298-.218.546-.503.592l-.097.008H0c-.331 0-.6-.269-.6-.6 0-.298.218-.546.503-.592L0 1.923h5.046z"
                  transform="translate(6 6) translate(10.56)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export let ChatIcon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -600) translate(42 600)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g
              fill="#59709B"
              fill-rule="nonzero"
              stroke="#59709B"
              strokeWidth=".1"
            >
              <path
                d="M7.6 3.2H2.8c-.22 0-.4-.18-.4-.4 0-.22.18-.4.4-.4h4.8c.22 0 .4.18.4.4 0 .22-.18.4-.4.4zM6 5.6H2.8c-.22 0-.4-.18-.4-.4 0-.22.18-.4.4-.4H6c.22 0 .4.18.4.4 0 .22-.18.4-.4.4z"
                transform="translate(7 7)"
              />
              <g>
                <path
                  d="M.4 10c-.22 0-.4-.18-.4-.4v-8C0 .716.716 0 1.6 0h7.2c.884 0 1.6.716 1.6 1.6v4.8c0 .884-.716 1.6-1.6 1.6H2.945L.656 9.907C.584 9.967.494 10 .4 10zM1.6.8c-.442 0-.8.358-.8.8v7.146l1.744-1.453c.072-.06.162-.093.256-.093h6c.442 0 .8-.358.8-.8V1.6c0-.442-.358-.8-.8-.8H1.6z"
                  transform="translate(7 7)"
                />
                <path
                  d="M12.4 12.8c-.09 0-.179-.03-.25-.087L10.26 11.2H4.8c-.884 0-1.6-.716-1.6-1.6v-.4c0-.22.18-.4.4-.4.22 0 .4.18.4.4v.4c0 .442.358.8.8.8h5.6c.091 0 .18.03.25.087l1.35 1.08V4.8c0-.442-.358-.8-.8-.8-.22 0-.4-.18-.4-.4 0-.22.18-.4.4-.4.884 0 1.6.716 1.6 1.6v7.6c0 .22-.18.4-.4.4z"
                  transform="translate(7 7)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RecordIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -696) translate(42 696)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g
              fill="#59709B"
              fill-rule="nonzero"
              stroke="#59709B"
              strokeWidth=".5"
            >
              <path
                d="M10.36 13.44H3.08C1.382 13.44 0 12.058 0 10.36V3.08C0 1.382 1.382 0 3.08 0h7.28c1.698 0 3.08 1.382 3.08 3.08v7.28c0 1.698-1.382 3.08-3.08 3.08zM3.08.56C1.69.56.56 1.69.56 3.08v7.28c0 1.39 1.13 2.52 2.52 2.52h7.28c1.39 0 2.52-1.13 2.52-2.52V3.08c0-1.39-1.13-2.52-2.52-2.52H3.08z"
                transform="translate(7 6)"
              />
              <path
                d="M6.72 9.52c-1.544 0-2.8-1.256-2.8-2.8 0-1.544 1.256-2.8 2.8-2.8 1.544 0 2.8 1.256 2.8 2.8 0 1.544-1.256 2.8-2.8 2.8zm0-5.04c-1.235 0-2.24 1.005-2.24 2.24 0 1.235 1.005 2.24 2.24 2.24 1.235 0 2.24-1.005 2.24-2.24 0-1.235-1.005-2.24-2.24-2.24z"
                transform="translate(7 6)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SnapIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -768) translate(42 768)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g
              fill="#59709B"
              fill-rule="nonzero"
              stroke="#59709B"
              strokeWidth=".25"
            >
              <path
                d="M13.586 12.934H2.57c-1.248 0-2.203-1.021-2.203-2.357V4.294c0-1.335.955-2.356 2.203-2.356h3.011l.588-.864c.22-.393.66-.707 1.102-.707h1.615c.514 0 .955.314 1.175.786l.514.785h3.011c1.249 0 2.204 1.021 2.204 2.356v6.283c0 1.336-.955 2.357-2.204 2.357zM1.102 4.294v6.283c0 .864.66 1.571 1.468 1.571h11.016c.808 0 1.47-.707 1.47-1.57V4.293c0-.864-.662-1.57-1.47-1.57h-3.231c-.147 0-.22-.08-.294-.158l-.66-1.02c-.148-.236-.294-.393-.515-.393H7.271c-.22 0-.368.157-.515.314l-.66 1.1c-.074.078-.147.156-.294.156H2.57c-.807 0-1.468.707-1.468 1.571z"
                transform="translate(5 6)"
              />
              <path
                d="M8.078 10.363c-1.632 0-2.937-1.305-2.937-2.937s1.305-2.938 2.937-2.938 2.938 1.306 2.938 2.938c0 1.632-1.306 2.937-2.938 2.937zm0-5.222c-1.24 0-2.284 1.044-2.284 2.285 0 1.24 1.044 2.284 2.284 2.284 1.24 0 2.285-1.044 2.285-2.284 0-1.24-1.044-2.285-2.285-2.285z"
                transform="translate(5 6)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ScreenCastIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 26 26"
      style={{ margin: "10px 0px" }}
    >
      <g fill="none" fill-rule="evenodd">
        <g>
          <g transform="translate(-42 -840) translate(42 840)">
            <rect width="26" height="26" fill="#EDF2F8" opacity=".8" rx="6" />
            <g>
              <g stroke="#59709B" strokeLinecap="round" strokeWidth="1.04">
                <path
                  strokeLinejoin="round"
                  d="M12.96 7.949L12.96 10.08M1.44 10.08V.96c0-.265.215-.48.48-.48H8.8"
                  transform="translate(5 6) translate(0 2.4)"
                />
                <path
                  d="M0.48 10.08L13.92 10.08"
                  transform="translate(5 6) translate(0 2.4)"
                />
              </g>
              <g fill="#59709B" fill-rule="nonzero">
                <path
                  d="M.4 9.6c-.115 0-.225-.048-.302-.134C.021 9.38-.014 9.265 0 9.15l.208-1.636c.35-2.77 2.608-4.905 5.392-5.1V.4c0-.162.097-.308.247-.37s.322-.028.436.087l4 4c.156.156.156.41 0 .565l-4 4c-.114.115-.286.15-.436.088-.15-.062-.247-.208-.247-.37v-2h-.186c-1.739-.006-3.356.89-4.272 2.367l-.4.645C.668 9.53.539 9.601.4 9.6zm6-8.234V2.8c0 .22-.18.4-.4.4-2.54.003-4.68 1.894-4.998 4.414C2.108 6.33 3.719 5.594 5.414 5.6H6c.22 0 .4.18.4.4v1.434L9.434 4.4 6.4 1.366z"
                  transform="translate(5 6) translate(8)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MuteIcon = ({ color }) => {
  let fill = color ? color : "#59709B";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 29 34"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill={fill}>
          <g>
            <g>
              <g>
                <path
                  fill-rule="nonzero"
                  stroke="#59709B"
                  strokeWidth=".25"
                  d="M7.195 14.83l2.1 2.027.003.132c.11 2.22 1.944 3.986 4.19 3.986l.07-.002 1.86 1.798c-.608.196-1.256.302-1.93.302-3.475 0-6.293-2.818-6.293-6.293v-1.95zM13.488.486c3.476 0 6.293 2.817 6.293 6.293v10c0 .483-.054.953-.157 1.404l-1.94-1.873V6.779c0-2.317-1.879-4.196-4.196-4.196-2.317 0-4.195 1.879-4.195 4.196v1.427l-2.072-2C7.51 3 10.206.487 13.488.487z"
                  transform="translate(-707 -866) translate(581 843) translate(101) translate(25.7 23)"
                />
                <path
                  fill-rule="nonzero"
                  stroke="#59709B"
                  strokeWidth=".25"
                  d="M4.049 12.584c.58 0 1.049.47 1.049 1.05v3.146c0 4.634 3.756 8.39 8.39 8.39 1.283 0 2.498-.287 3.585-.802l1.587 1.533c-1.526.868-3.291 1.365-5.172 1.367C7.698 27.26 3.007 22.569 3 16.78v-3.147c0-.58.47-1.049 1.049-1.049zm18.879 0c.58 0 1.049.47 1.049 1.05v3.146c-.002 1.644-.382 3.2-1.058 4.585l-1.606-1.55c.366-.941.566-1.965.566-3.035v-3.147c0-.58.47-1.049 1.049-1.049z"
                  transform="translate(-707 -866) translate(581 843) translate(101) translate(25.7 23)"
                />
                <path
                  fill-rule="nonzero"
                  d="M13.488 33.56c-.579 0-1.048-.469-1.048-1.048V26.22c0-.58.47-1.049 1.048-1.049.58 0 1.05.47 1.05 1.05v6.292c0 .58-.47 1.049-1.05 1.049z"
                  transform="translate(-707 -866) translate(581 843) translate(101) translate(25.7 23)"
                />
                <path
                  d="M14.029.135l.123-.012c.658-.062 1.243.422 1.305 1.081.003.037.005.075.005.112v31.691c0 .676-.514 1.241-1.187 1.305l-.123.011c-.66.063-1.244-.421-1.306-1.08-.003-.037-.005-.075-.005-.112V1.44c0-.676.514-1.242 1.188-1.305z"
                  transform="translate(-707 -866) translate(581 843) translate(101) translate(25.7 23) rotate(-46 14.152 17.223)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const IframeIcon = ({ status }) => {
  let color = status ? "#59709B" : "white";

  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 125 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M117.188 23.4375H7.8125V85.9961H117.188V23.4375Z"
        stroke={color}
        strokeWidth="6"
        stroke-miterlimit="10"
      />
      <path
        d="M62.5 101.562V85.9961"
        stroke={color}
        strokeWidth="6"
        stroke-miterlimit="10"
      />
      <path
        d="M42.9688 101.562H81.9922"
        stroke={color}
        strokeWidth="6"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export const NoVedioIcon = ({ color }) => {
  let fill = color ? color : "#59709B";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 36 29"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill={fill}>
          <g>
            <g>
              <g>
                <path
                  fill-rule="nonzero"
                  d="M32.863 6.84l-9.35 6.678c-.639.457-.639 1.407 0 1.863l9.35 6.678c.757.542 1.81 0 1.81-.931V7.772c0-.931-1.053-1.473-1.81-.932zm-.48 3.156v8.907l-6.235-4.453 6.235-4.454z"
                  transform="translate(-804 -869) translate(581 843) translate(202) translate(21.671 26.184)"
                />
                <path
                  fill-rule="nonzero"
                  d="M3.04 7.219L5.289 9.39v11.738c0 .796.61 1.45 1.388 1.52l.139.006h12.207l2.37 2.289H6.816c-2.042 0-3.709-1.602-3.811-3.619L3 21.128V7.772c0-.188.014-.373.04-.553zm18.468-3.263c2.107 0 3.816 1.708 3.816 3.816l-.001 11.799-2.289-2.21v-9.59c0-.795-.61-1.45-1.387-1.52l-.14-.006h-9.984l-2.371-2.29z"
                  transform="translate(-804 -869) translate(581 843) translate(202) translate(21.671 26.184)"
                />
                <path
                  d="M14.944-3.857l.13-.012c.698-.066 1.318.447 1.384 1.145.003.04.005.08.005.12v33.591c0 .717-.545 1.316-1.259 1.384l-.13.012c-.698.066-1.318-.447-1.384-1.145-.003-.04-.005-.08-.005-.12V-2.474c0-.716.545-1.316 1.259-1.383z"
                  transform="translate(-804 -869) translate(581 843) translate(202) translate(21.671 26.184) rotate(-46 15.074 14.257)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EndCallIcon = ({ color }) => {
  let fill = color ? color : "#fff";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 35 14"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill={fill} fill-rule="nonzero">
          <g>
            <g>
              <path
                d="M17.28.817c6.104 0 11.91 2.315 16.344 6.518.315.313.486.725.486 1.175 0 .448-.17.862-.48 1.17l-3.422 3.423c-.31.31-.722.48-1.17.48-.369 0-.737-.129-1.03-.357l-.49-.425-.598-.501-1.182-.978-.513-.437-.347-.308-.312-.288-.276-.267-.124-.125-.218-.23-.178-.205c-.183-.221-.28-.383-.28-.47V4.865l-.33-.09c-.907-.25-1.83-.395-2.97-.473l-.644-.036-.695-.024c-.12-.004-.243-.006-.369-.008l-.784-.01h-.418l-.885.005c-2.122.028-3.58.169-4.992.549l-.333.09v4.126c0 .013-.008.033-.022.06l-.066.097c-.015.02-.03.04-.049.062l-.127.15-.262.28-.34.343-.414.394-.312.288-.506.45-1.956 1.689-.345.305c-.583.58-1.72.578-2.321-.022L.929 9.667C.626 9.382.45 8.957.45 8.51c0-.448.17-.86.48-1.17C5.37 3.134 11.173.817 17.28.817z"
                transform="translate(-603 -876) translate(581 843) translate(22 33)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CallOptions = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 183 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.25 0.75C10.7375 0.75 0.5 10.9875 0.5 23.5C0.5 36.0125 10.7375 46.25 23.25 46.25C35.7625 46.25 46 36.0125 46 23.5C46 10.9875 35.7625 0.75 23.25 0.75ZM159.75 0.75C147.237 0.75 137 10.9875 137 23.5C137 36.0125 147.237 46.25 159.75 46.25C172.263 46.25 182.5 36.0125 182.5 23.5C182.5 10.9875 172.263 0.75 159.75 0.75ZM91.5 0.75C78.9875 0.75 68.75 10.9875 68.75 23.5C68.75 36.0125 78.9875 46.25 91.5 46.25C104.013 46.25 114.25 36.0125 114.25 23.5C114.25 10.9875 104.013 0.75 91.5 0.75Z"
        fill="#59709B"
      />
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: 10, marginLeft: 10 }}
      width="10"
      height="10"
      viewBox="0 0 55.934 31.744"
    >
      <path
        id="XMLID_225_"
        d="M52,75.7a2.4,2.4,0,0,0-3.388,0L26.35,97.961,4.09,75.7A2.4,2.4,0,0,0,.7,79.089l23.954,23.954a2.4,2.4,0,0,0,3.387,0L52,79.089A2.4,2.4,0,0,0,52,75.7Z"
        transform="translate(1.736 -73.5)"
        stroke="#000"
        strokeWidth="3"
      />
    </svg>
  );
};

export const RightArrowIconOriginal = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight: 10, marginLeft: 10, transform: "rotate(-90deg)" }}
      width="10"
      height="10"
      viewBox="0 0 55.934 31.744"
    >
      <path
        id="XMLID_225_"
        d="M52,75.7a2.4,2.4,0,0,0-3.388,0L26.35,97.961,4.09,75.7A2.4,2.4,0,0,0,.7,79.089l23.954,23.954a2.4,2.4,0,0,0,3.387,0L52,79.089A2.4,2.4,0,0,0,52,75.7Z"
        transform="translate(1.736 -73.5)"
        stroke="#000"
        strokeWidth="3"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      style={{ marginRight: ".8rem" }}
      width="11"
      height="11"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="white" />
    </svg>
  );
};

export const NoDataIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.5"
        y="4.5"
        width="15.5217"
        height="15.5217"
        rx="2.5"
        fill="white"
        stroke="#0A8CE0"
      />
      <path
        d="M14.1884 1H3.31998C2.93904 1 2.56438 1.09708 2.23137 1.28209V1.28209C1.72061 1.56585 1.34083 2.03782 1.17293 2.59747L1.11533 2.78947C1.03885 3.0444 1 3.30913 1 3.57528V13.6087"
        stroke="#59709B"
      />
    </svg>
  );
};

export const ArrowLeft = () => {
  return (
    <svg
      style={{ marginRight: 5, marginTop: "-3px" }}
      width="12.5"
      height="12.5"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 9.1875H5.02687L12.3638 1.85062L10.5 0L0 10.5L10.5 21L12.3506 19.1494L5.02687 11.8125H21V9.1875Z"
        fill="black"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      style={{ marginRight: 10 }}
      width="13"
      height="13"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.98417 6.0675L9.08334 3.95917V12.75C9.08334 12.9931 9.17991 13.2263 9.35182 13.3982C9.52373 13.5701 9.75689 13.6667 10 13.6667C10.2431 13.6667 10.4763 13.5701 10.6482 13.3982C10.8201 13.2263 10.9167 12.9931 10.9167 12.75V3.95917L13.0158 6.0675C13.1011 6.15342 13.2024 6.22161 13.3141 6.26815C13.4258 6.31469 13.5457 6.33865 13.6667 6.33865C13.7877 6.33865 13.9075 6.31469 14.0192 6.26815C14.1309 6.22161 14.2323 6.15342 14.3175 6.0675C14.4034 5.98229 14.4716 5.8809 14.5182 5.7692C14.5647 5.65749 14.5887 5.53768 14.5887 5.41667C14.5887 5.29566 14.5647 5.17584 14.5182 5.06414C14.4716 4.95244 14.4034 4.85105 14.3175 4.76583L10.6508 1.09917C10.5637 1.01571 10.4609 0.950296 10.3483 0.906668C10.1252 0.814985 9.87484 0.814985 9.65167 0.906668C9.53915 0.950296 9.43635 1.01571 9.34917 1.09917L5.6825 4.76583C5.59703 4.8513 5.52924 4.95277 5.48298 5.06444C5.43673 5.17611 5.41292 5.2958 5.41292 5.41667C5.41292 5.53754 5.43673 5.65723 5.48298 5.7689C5.52924 5.88057 5.59703 5.98203 5.6825 6.0675C5.76797 6.15297 5.86944 6.22077 5.98111 6.26702C6.09278 6.31328 6.21247 6.33709 6.33334 6.33709C6.45421 6.33709 6.57389 6.31328 6.68556 6.26702C6.79724 6.22077 6.8987 6.15297 6.98417 6.0675ZM18.25 10C18.0069 10 17.7737 10.0966 17.6018 10.2685C17.4299 10.4404 17.3333 10.6736 17.3333 10.9167V16.4167C17.3333 16.6598 17.2368 16.8929 17.0649 17.0649C16.8929 17.2368 16.6598 17.3333 16.4167 17.3333H3.58334C3.34022 17.3333 3.10706 17.2368 2.93515 17.0649C2.76325 16.8929 2.66667 16.6598 2.66667 16.4167V10.9167C2.66667 10.6736 2.57009 10.4404 2.39818 10.2685C2.22628 10.0966 1.99312 10 1.75 10C1.50689 10 1.27373 10.0966 1.10182 10.2685C0.929913 10.4404 0.833336 10.6736 0.833336 10.9167V16.4167C0.833336 17.146 1.12307 17.8455 1.63879 18.3612C2.15452 18.8769 2.85399 19.1667 3.58334 19.1667H16.4167C17.146 19.1667 17.8455 18.8769 18.3612 18.3612C18.8769 17.8455 19.1667 17.146 19.1667 16.4167V10.9167C19.1667 10.6736 19.0701 10.4404 18.8982 10.2685C18.7263 10.0966 18.4931 10 18.25 10Z"
        fill="white"
      />
    </svg>
  );
};

export const VolumeIcon = () => {
  return (
    <svg
      style={{ marginRight: 10 }}
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37087 0.924484L3.88264 2.79311C3.75596 2.86101 3.61445 2.89654 3.47072 2.89655H1.25169C1.02033 2.89656 0.798449 2.98847 0.634849 3.15206C0.47125 3.31566 0.379331 3.53753 0.379311 3.76889V8.23107C0.37932 8.46244 0.471234 8.68432 0.634835 8.84793C0.798436 9.01153 1.02032 9.10344 1.25169 9.10345H3.47072C3.61444 9.10346 3.75594 9.13897 3.88264 9.20683L7.37087 11.0755C7.50378 11.1467 7.65288 11.1823 7.80362 11.1787C7.95436 11.1751 8.10159 11.1325 8.23096 11.055C8.36032 10.9775 8.4674 10.8679 8.54175 10.7367C8.6161 10.6055 8.65518 10.4573 8.65517 10.3065V1.69344C8.65517 1.54266 8.61609 1.39446 8.54174 1.26329C8.46739 1.13211 8.36031 1.02245 8.23094 0.944993C8.10158 0.867538 7.95435 0.824936 7.80361 0.821341C7.65287 0.817747 7.50378 0.853283 7.37087 0.924484V0.924484ZM10.485 3.73505C10.4099 3.78727 10.3586 3.86716 10.3423 3.95718C10.326 4.04721 10.3461 4.14002 10.3982 4.21525C10.7629 4.73892 10.9585 5.3618 10.9585 6C10.9585 6.6382 10.7629 7.26108 10.3982 7.78475C10.3465 7.85997 10.3267 7.95259 10.3431 8.04235C10.3596 8.13211 10.4109 8.21171 10.4859 8.26372C10.5609 8.31573 10.6534 8.33592 10.7432 8.31987C10.8331 8.30381 10.9129 8.25283 10.9652 8.17807C11.4098 7.53877 11.6482 6.77871 11.6482 6C11.6482 5.22129 11.4098 4.46124 10.9652 3.82193C10.9128 3.74715 10.8329 3.69609 10.743 3.67982C10.6531 3.66356 10.5604 3.6834 10.485 3.73505V3.73505ZM14.5233 0.514415C14.4973 0.477357 14.4643 0.445784 14.426 0.421497C14.3878 0.397211 14.3452 0.380687 14.3006 0.37287C14.256 0.365052 14.2104 0.366094 14.1662 0.375936C14.122 0.385778 14.0802 0.404227 14.0431 0.430229C14.006 0.456232 13.9745 0.489279 13.9502 0.527484C13.9259 0.565689 13.9094 0.608303 13.9016 0.652894C13.8937 0.697485 13.8948 0.743178 13.9046 0.787366C13.9145 0.831554 13.9329 0.873371 13.9589 0.910429C15.0052 2.40138 15.5665 4.17857 15.5665 6C15.5665 7.82144 15.0052 9.59862 13.9589 11.0896C13.9329 11.1266 13.9145 11.1684 13.9046 11.2126C13.8948 11.2568 13.8937 11.3025 13.9016 11.3471C13.9094 11.3917 13.9259 11.4343 13.9502 11.4725C13.9745 11.5107 14.006 11.5438 14.0431 11.5698C14.0802 11.5958 14.122 11.6142 14.1662 11.6241C14.2104 11.6339 14.256 11.635 14.3006 11.6271C14.3452 11.6193 14.3878 11.6028 14.426 11.5785C14.4643 11.5542 14.4973 11.5226 14.5233 11.4856C15.6511 9.87867 16.2562 7.96319 16.2562 6C16.2562 4.03681 15.6511 2.12134 14.5233 0.514415ZM12.6328 1.83717C12.6068 1.79965 12.5736 1.76767 12.5351 1.74309C12.4967 1.7185 12.4537 1.70179 12.4087 1.69394C12.3638 1.68609 12.3177 1.68724 12.2732 1.69734C12.2286 1.70743 12.1866 1.72627 12.1494 1.75275C12.1122 1.77924 12.0806 1.81284 12.0565 1.85162C12.0324 1.8904 12.0163 1.93357 12.009 1.97864C12.0017 2.02371 12.0035 2.06977 12.0141 2.11416C12.0248 2.15855 12.0442 2.20038 12.0711 2.23723C12.8464 3.3388 13.2625 4.65297 13.2625 6.00002C13.2625 7.34708 12.8464 8.66124 12.0711 9.76282C12.0442 9.79966 12.0248 9.84149 12.0141 9.88588C12.0035 9.93027 12.0017 9.97634 12.009 10.0214C12.0163 10.0665 12.0324 10.1097 12.0565 10.1484C12.0806 10.1872 12.1122 10.2208 12.1494 10.2473C12.1866 10.2738 12.2286 10.2926 12.2732 10.3027C12.3177 10.3128 12.3638 10.314 12.4087 10.3061C12.4537 10.2983 12.4967 10.2815 12.5351 10.257C12.5736 10.2324 12.6068 10.2004 12.6328 10.1629C13.4913 8.9445 13.9522 7.49049 13.9522 6.00002C13.9522 4.50955 13.4913 3.05554 12.6328 1.83717Z"
        fill="black"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
        fill="#FB1E00"
      />
    </svg>
  );
};

export const QuestIcon = () => {
  return (
    <svg
      width="1.5vw"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.0021 15.8979C40.624 16.251 41.3603 16.3438 42.0503 16.1561C42.7404 15.9683 43.3282 15.5153 43.6855 14.8958C43.9811 14.3741 44.4416 13.9652 44.9946 13.7334C45.5477 13.5015 46.162 13.4597 46.7414 13.6146C47.3207 13.7695 47.8322 14.1123 48.1958 14.5893C48.5593 15.0662 48.7542 15.6503 48.7501 16.25C48.7501 16.9683 48.4647 17.6572 47.9568 18.1651C47.4489 18.673 46.76 18.9583 46.0417 18.9583C45.3234 18.9583 44.6345 19.2437 44.1266 19.7516C43.6187 20.2595 43.3334 20.9484 43.3334 21.6667C43.3334 22.385 43.6187 23.0738 44.1266 23.5817C44.6345 24.0897 45.3234 24.375 46.0417 24.375C47.4677 24.3741 48.8684 23.9979 50.103 23.2842C51.3375 22.5705 52.3625 21.5444 53.0749 20.3091C53.7873 19.0738 54.1621 17.6728 54.1615 16.2467C54.1609 14.8207 53.7851 13.42 53.0717 12.1852C52.3583 10.9505 51.3325 9.92528 50.0973 9.21257C48.8622 8.49986 47.4612 8.12477 46.0352 8.125C44.6092 8.12523 43.2084 8.50076 41.9734 9.21387C40.7385 9.92697 39.7131 10.9525 39 12.1875C38.821 12.4966 38.7048 12.8381 38.6583 13.1923C38.6118 13.5465 38.6357 13.9064 38.7289 14.2513C38.822 14.5961 38.9825 14.9192 39.201 15.2018C39.4195 15.4844 39.6918 15.721 40.0021 15.8979ZM51.648 35.2083C50.937 35.1161 50.2185 35.3094 49.6499 35.746C49.0813 36.1826 48.709 36.8269 48.6146 37.5375C48.0463 42.1286 45.8189 46.3534 42.352 49.4163C38.885 52.4791 34.4178 54.1687 29.7917 54.1667H14.6521L16.4126 52.4063C16.917 51.8988 17.2001 51.2124 17.2001 50.4969C17.2001 49.7814 16.917 49.0949 16.4126 48.5875C13.7718 45.9364 11.9746 42.563 11.2475 38.8924C10.5203 35.2218 10.8956 31.4181 12.3262 27.9604C13.7568 24.5027 16.1786 21.5457 19.2866 19.4618C22.3946 17.3779 26.0498 16.2604 29.7917 16.25C30.51 16.25 31.1989 15.9647 31.7068 15.4567C32.2147 14.9488 32.5001 14.26 32.5001 13.5417C32.5001 12.8234 32.2147 12.1345 31.7068 11.6266C31.1989 11.1187 30.51 10.8333 29.7917 10.8333C25.2126 10.8524 20.7314 12.1611 16.8616 14.6093C12.9918 17.0575 9.88989 20.5463 7.91127 24.676C5.93264 28.8056 5.15733 33.4091 5.67413 37.9591C6.19094 42.509 7.97898 46.8214 10.8334 50.4021L6.20214 54.9521C5.82633 55.3329 5.57176 55.8166 5.47054 56.342C5.36932 56.8674 5.42598 57.411 5.63339 57.9042C5.83656 58.3988 6.1816 58.8221 6.62501 59.121C7.06842 59.4198 7.59036 59.5807 8.12505 59.5833H29.7917C35.7269 59.5841 41.4585 57.4194 45.9112 53.4952C50.364 49.571 53.2319 44.157 53.9771 38.2687C54.0267 37.9147 54.0056 37.5543 53.9151 37.2083C53.8247 36.8624 53.6666 36.5379 53.4501 36.2533C53.2335 35.9688 52.9628 35.73 52.6535 35.5506C52.3442 35.3713 52.0025 35.2549 51.648 35.2083V35.2083ZM47.0709 27.2729C46.5778 27.0548 46.0309 26.9888 45.5 27.0833L45.0126 27.2458L44.5251 27.4896L44.1188 27.8417C43.8752 28.0912 43.6821 28.3855 43.5501 28.7083C43.3899 29.0462 43.3155 29.4182 43.3334 29.7917C43.3255 30.1529 43.39 30.512 43.523 30.8479C43.663 31.173 43.8655 31.4674 44.1188 31.7146C44.3719 31.9656 44.672 32.1642 45.002 32.299C45.3319 32.4337 45.6853 32.5021 46.0417 32.5C46.76 32.5 47.4489 32.2147 47.9568 31.7067C48.4647 31.1988 48.7501 30.51 48.7501 29.7917C48.7592 29.4364 48.685 29.0839 48.5334 28.7625C48.2424 28.1117 47.7217 27.591 47.0709 27.3V27.2729Z"
        fill="white"
      />
    </svg>
  );
};

export const TestIcon_V2 = ({ status }) => {
  let color = status ? "#8AB4F8" : "white";
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 581 699"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M559.675 577.493L376.036 233.518V58.868H394.205C402.249 58.868 408.752 52.3655 408.752 44.3211V14.9219C408.752 6.892 402.249 0.375 394.205 0.375H376.036H189.268H172.641C164.597 0.375 158.094 6.892 158.094 14.9219V44.3211C158.094 52.3655 164.597 58.868 172.641 58.868H189.268V233.532L20.2336 575.995C-22.9851 643.725 7.11237 698.625 87.4402 698.625H494.753C575.081 698.625 604.145 644.394 559.675 577.493ZM241.448 259.28L247.456 247.105V233.532V58.868H317.848V233.532V248.094L324.7 260.939L403.398 408.328H167.884L241.448 259.28Z"
        fill={color}
      />
    </svg>
  );
};


export const ScreenShare_V2 = ({ status }) => {
  let color = status ? "#8AB4F8" : "white";
  return (
    // <svg
    //   width="18"
    //   height="18"
    //   viewBox="0 0 581 699"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M559.675 577.493L376.036 233.518V58.868H394.205C402.249 58.868 408.752 52.3655 408.752 44.3211V14.9219C408.752 6.892 402.249 0.375 394.205 0.375H376.036H189.268H172.641C164.597 0.375 158.094 6.892 158.094 14.9219V44.3211C158.094 52.3655 164.597 58.868 172.641 58.868H189.268V233.532L20.2336 575.995C-22.9851 643.725 7.11237 698.625 87.4402 698.625H494.753C575.081 698.625 604.145 644.394 559.675 577.493ZM241.448 259.28L247.456 247.105V233.532V58.868H317.848V233.532V248.094L324.7 260.939L403.398 408.328H167.884L241.448 259.28Z"
    //     fill={color}
    //   />
    // </svg>
    <svg
      width="30"
      height="30"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
     
    >
      <path d="M23.75,4.99939 C24.9926,4.99939 26,6.00675 26,7.24939 L26,20.75 C26,21.9926 24.9926,23 23.75,23 L4.25,23 C3.00736,23 2,21.9927 2,20.75 L2,7.24939 C2,6.00675 3.00736,4.99939 4.25,4.99939 L23.75,4.99939 Z M23.75,6.49939 L4.25,6.49939 C3.83579,6.49939 3.5,6.83518 3.5,7.24939 L3.5,20.75 C3.5,21.1642 3.83579,21.5 4.25,21.5 L23.75,21.5 C24.1642,21.5 24.5,21.1642 24.5,20.75 L24.5,7.24939 C24.5,6.83518 24.1642,6.49939 23.75,6.49939 Z M13.9975,8.62102995 C14.1965,8.62102995 14.3874,8.69998 14.5281,8.8407 L17.7826,12.0952 C18.0755,12.3881 18.0755,12.863 17.7826,13.1559 C17.4897,13.4488 17.0148,13.4488 16.7219,13.1559 L14.7477,11.1817 L14.7477,18.6284 C14.7477,19.0426 14.412,19.3784 13.9977,19.3784 C13.5835,19.3784 13.2477,19.0426 13.2477,18.6284 L13.2477,11.1835 L11.2784,13.1555 C10.9858,13.4486 10.5109,13.4489 10.2178,13.1562 C9.92469,12.8636 9.92436,12.3887 10.217,12.0956 L13.467,8.84107 C13.6077,8.70025 13.7985,8.62102995 13.9975,8.62102995 Z" 
       fill={color} />
    </svg>
  );
};

export const PatientInfoIcon_V2 = ({ status }) => {
  let color = status ? "#8AB4F8" : "white";

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 683 758"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M645.055 720.1V644.3C645.055 604.093 629.065 565.533 600.601 537.103C572.137 508.672 533.532 492.7 493.278 492.7H189.722C149.468 492.7 110.863 508.672 82.399 537.103C53.9352 565.533 37.9443 604.093 37.9443 644.3L37.9443 720.1"
        stroke={color}
        strokeWidth="41"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M341.5 341.1C425.324 341.1 493.278 273.226 493.278 189.5C493.278 105.774 425.324 37.9 341.5 37.9C257.675 37.9 189.722 105.774 189.722 189.5C189.722 273.226 257.675 341.1 341.5 341.1Z"
        stroke={color}
        strokeWidth="41"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DescriptionIcon_V2 = ({ status }) => {
  let color = status ? "#8AB4F8" : "white";

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 527 703"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_301_16)">
        <path
          d="M461.418 83.5398H385.969V119.305H461.418H461.623C480.8 119.305 496.346 134.859 496.346 154.045V154.279V632.495V632.7C496.346 651.915 480.77 667.469 461.593 667.469C461.535 667.469 461.447 667.469 461.388 667.469H70.5008C70.4423 667.469 70.3544 667.469 70.2959 667.469C51.0897 667.469 35.5432 651.886 35.5432 632.7C35.5432 632.612 35.5432 632.553 35.5432 632.466V154.25C35.5432 154.191 35.5432 154.103 35.5432 154.045C35.5432 134.829 51.1189 119.276 70.2959 119.276H70.5008H145.95V83.5398H70.5008C31.5321 83.5398 -0.0878906 115.175 -0.0878906 154.162V632.378C-0.0586128 671.365 31.5321 702.971 70.5008 702.971H461.388C500.357 702.971 531.977 671.336 531.977 632.348V154.133C531.977 115.145 500.357 83.5105 461.388 83.5105L461.418 83.5398Z"
          fill={color}
        />
        <path
          d="M369.046 65.174H330.429C330.429 29.1745 301.268 0 265.286 0C229.303 0 200.143 29.1745 200.143 65.174H161.789V154.719H368.871V65.174H369.046ZM302.937 65.174H227.693C227.693 64.881 227.693 64.5588 227.693 64.2366C227.693 43.4395 244.557 26.5675 265.344 26.5675C286.132 26.5675 302.996 43.4395 302.996 64.2366V65.2325V65.174H302.937ZM174.115 249.331H451.024V283.602H174.115V249.331ZM174.115 392.801H451.024V427.072H174.115V392.801ZM174.115 534.573H451.024V569.02H174.115V534.573ZM76.9419 227.215H155.406V305.717H76.9419V227.215ZM76.9419 370.686H155.406V449.188H76.9419V370.686ZM76.9419 512.516H155.406V591.018H76.9419V512.516Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_301_16">
          <rect width="527" height="703" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NotesIcon_V2 = ({ status }) => {
  let color = status ? "#8AB4F8" : "white";
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 615 656"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M370.487 0.0175375V0.110819H370.254L219.036 11.4446H218.149L217.87 11.4912H47.7551C41.1587 11.4919 35.8114 16.8372 35.8107 23.4313V37.7967L10.2422 41.4347C3.72958 42.3734 -0.797334 48.4002 0.117483 54.9139L35.8107 303.557V620.435C35.8114 627.03 41.1587 632.375 47.7551 632.376H83.0284L84.9414 645.762C85.8805 652.272 91.9094 656.797 98.4255 655.883L213.857 639.325L223.935 650.799C224.999 652.014 226.298 653 227.754 653.699C229.211 654.397 230.793 654.794 232.407 654.863C234.021 654.933 235.632 654.675 237.143 654.105C238.654 653.534 240.034 652.664 241.198 651.545L260.935 632.562L262.241 632.376H525.531C532.128 632.375 537.475 627.03 537.476 620.435V592.871L571.349 588.02C577.862 587.081 582.389 581.055 581.474 574.541L550.493 358.593C552.799 356.915 555.117 355.231 557.259 353.09L563.884 346.467C571.903 338.45 578.449 329.398 582.734 319.974L612.735 253.978C615.505 247.881 616.791 239.047 610.262 232.523C606.997 229.261 603.178 227.995 599.391 227.859C595.603 227.62 591.848 228.712 588.799 230.097L537.476 253.371V143.672C537.485 143.392 537.485 143.112 537.476 142.832V142.506C537.47 142.225 537.457 141.945 537.429 141.666L537.382 141.293C537.296 140.629 537.158 139.974 536.962 139.334L536.869 139.008C536.769 138.739 536.661 138.475 536.542 138.215L536.496 138.168L536.402 137.888C536.288 137.635 536.163 137.386 536.029 137.142L535.843 136.815L535.796 136.722C535.607 136.418 535.405 136.122 535.189 135.836C535.027 135.612 534.855 135.395 534.676 135.183L534.443 134.903C534.292 134.728 534.137 134.557 533.976 134.39L414.532 14.9893C412.302 12.7501 409.255 11.4918 406.087 11.4912H405.901H397.829L376.32 1.18356C374.505 0.309571 372.499 -0.0915447 370.487 0.0175375ZM59.6995 35.3714H394.143V142.832C394.143 149.426 399.491 154.772 406.087 154.772H513.587V265.078C508.309 268.293 503.213 272.043 498.61 276.645L478.873 296.327C478.382 296.818 478.145 297.485 477.707 298.007H83.5883V309.947V321.933H454.238L402.914 369.694H83.5883V393.574H377.206L325.882 441.334H83.5883V465.214H300.221L248.944 512.928H83.5883V524.868V536.855H223.235L177.091 579.765C174.82 581.881 173.462 584.797 173.305 587.897C173.149 590.996 174.205 594.035 176.251 596.369L186.889 608.495H93.3398H59.6995V302.857V48.1044V35.3714ZM418.032 52.2554L496.697 130.892H418.032V52.2554ZM35.8107 61.7702V135.649L25.406 63.2627L35.8107 61.7702ZM83.5883 154.772V166.712V178.652H95.5327H286.643H298.588V154.772H286.643H95.5327H83.5883ZM83.5883 226.413V250.293H477.754V226.413H83.5883ZM584.507 258.268L560.944 310.087C558.123 316.291 553.187 323.393 546.994 329.582L540.368 336.206C537.218 339.353 533.792 341.361 531.643 342.176L499.216 309.76L515.5 293.529C520.207 288.825 525.581 285.017 530.15 282.942L584.507 258.268ZM482.839 327.997L512.234 357.381L273.392 587.32L240.872 553.086L482.839 327.997ZM513.587 389.236V582.563V608.495H285.897L360.269 536.855H489.698V512.928H385.138L434.688 465.214H477.754V441.334H459.464L513.587 389.236ZM537.476 435.924L556.139 566.099L537.476 568.804V435.924ZM223.375 569.364L256.222 603.878L233.64 625.613L201.866 589.373L223.375 569.364Z"
        fill={color}
      />
    </svg>
  );
};

export const CloseIconRound = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M174.084 91.1992L164.801 81.9167L128 118.718L91.1995 81.9167L81.917 91.1992L118.718 128L81.917 164.801L91.1995 174.083L128 137.283L164.801 174.083L174.084 164.801L137.283 128L174.084 91.1992Z"
        fill="black"
      />
      <circle cx="128" cy="128" r="122.5" stroke="black" strokeWidth="11" />
    </svg>
  );
};

export const MainLogoWhiteForFooter = () => {
  return (
    <svg
      width="130"
      viewBox="0 0 815 242"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_306_32)">
        <path
          d="M801.984 12.2293C799.406 12.2266 796.885 12.9887 794.741 14.4191C792.596 15.8494 790.924 17.8837 789.936 20.2647C788.948 22.6457 788.688 25.2664 789.189 27.7951C789.69 30.3239 790.93 32.6472 792.752 34.471C794.574 36.2948 796.895 37.5373 799.423 38.0412C801.951 38.5451 804.572 38.2878 806.953 37.3018C809.335 36.3159 811.371 34.6456 812.803 32.5023C814.235 30.3589 815 27.8389 815 25.2609C815 21.807 813.629 18.4943 811.188 16.0508C808.748 13.6073 805.437 12.2328 801.984 12.2293ZM801.984 35.7709C801.993 34.6178 802.46 37.5885 803.28 36.7784C804.1 35.9683 803.503 35.3687 804.656 35.3737C805.809 35.3786 808.618 31.9148 809.432 32.732C810.245 33.5491 809.432 30.0063 809.432 31.1595C809.432 32.3126 804.949 34.1734 804.136 34.9905C803.322 35.8077 807.469 34.1058 806.316 34.1107C805.163 34.1157 802.156 32.7358 801.336 31.9257C800.515 31.1156 801.993 36.9989 801.984 35.8458V35.7709Z"
          fill="white"
        />
        <path
          d="M807.889 22.8406C807.925 22.2025 807.811 21.5649 807.558 20.9781C807.305 20.3913 806.918 19.8714 806.43 19.4593C805.338 18.6234 803.986 18.2003 802.613 18.2646H796.781V32.2749H799.695V27.7561H802.058L804.813 32.2749H808.162L805.077 27.2007C805.921 26.8293 806.638 26.2182 807.138 25.443C807.638 24.6679 807.899 23.763 807.889 22.8406ZM802.058 25.0449H799.726V20.9934H802.058C804.054 20.9934 804.971 21.6327 804.971 23.0037C804.971 24.3748 803.966 25.0449 802.058 25.0449Z"
          fill="black"
        />
        <path
          d="M368.188 66.2957C367.593 69.483 365.952 72.3808 363.525 74.5308C361.125 76.4372 358.134 77.4432 355.07 77.3743C352.686 77.3637 350.348 76.716 348.299 75.4983C346.249 74.2807 344.562 72.5372 343.411 70.4485C343.134 69.8798 342.887 69.3111 342.653 68.7733C342.431 68.1036 342.266 67.4164 342.16 66.7189C341.832 63.7521 341.701 60.7669 341.767 57.7828C341.697 54.7884 341.828 51.7926 342.16 48.8158C342.357 47.5273 342.78 46.2839 343.411 45.1435C344.44 43.2122 345.945 41.5762 347.784 40.3911C350.232 38.792 353.135 38.0348 356.051 38.2345C358.968 38.4342 361.741 39.5798 363.948 41.4976C366.193 43.6787 367.688 46.5156 368.219 49.6005H362.216C361.787 48.071 360.932 46.695 359.752 45.6328C358.436 44.5702 356.792 43.9982 355.101 44.0149C353.911 44.0135 352.738 44.293 351.676 44.8305C350.747 45.3135 349.936 45.9954 349.3 46.8275C348.548 47.7533 348.045 48.8569 347.841 50.0325C347.514 52.5993 347.388 55.1875 347.462 57.7739C347.386 60.3545 347.513 62.937 347.841 65.4977C348.045 66.6868 348.547 67.8047 349.3 68.7468C349.935 69.5654 350.747 70.2288 351.676 70.6866C352.714 71.2928 353.9 71.5982 355.101 71.5683C356.694 71.5402 358.239 71.0153 359.519 70.0669C360.799 69.1185 361.751 67.7939 362.242 66.278L368.188 66.2957Z"
          fill="white"
        />
        <path
          d="M414.29 57.7827C414.227 60.365 414.375 62.9481 414.731 65.5065C414.896 66.7069 415.403 67.8346 416.19 68.7556C416.892 69.6282 417.78 70.3335 418.789 70.82C419.797 71.3065 420.902 71.5621 422.022 71.5682C423.255 71.6002 424.474 71.2953 425.548 70.6865C426.439 70.2265 427.208 69.5617 427.792 68.7468C428.539 67.8011 429.04 66.6847 429.251 65.4977C429.594 62.9383 429.725 60.3549 429.643 57.7739C429.723 55.187 429.592 52.5979 429.251 50.0325C429.039 48.8593 428.537 47.7576 427.792 46.8275C427.201 45.9973 426.427 45.314 425.53 44.8304C424.433 44.2912 423.227 44.0121 422.004 44.0148C420.81 44.0102 419.631 44.2898 418.566 44.8304C417.64 45.3059 416.838 45.9895 416.221 46.8275C415.434 47.7315 414.927 48.8451 414.762 50.0325C414.407 52.5969 414.26 55.1858 414.321 57.7739L414.29 57.7827ZM408.635 57.7827C408.557 54.7794 408.689 51.7744 409.027 48.7893C409.226 47.5048 409.64 46.2631 410.253 45.117C411.302 43.201 412.803 41.5698 414.625 40.3646C416.776 38.9162 419.319 38.1637 421.911 38.2088C424.553 38.1593 427.144 38.9293 429.33 40.4131C431.133 41.6006 432.595 43.2389 433.57 45.1655C434.271 46.2799 434.722 47.5326 434.893 48.8378C435.165 51.8186 435.272 54.8121 435.214 57.8048C435.269 60.7871 435.162 63.7702 434.893 66.7409C434.723 68.0643 434.272 69.336 433.57 70.4705C432.611 72.3902 431.17 74.0278 429.387 75.2229C427.195 76.6921 424.608 77.4608 421.969 77.4272C419.372 77.456 416.828 76.6866 414.682 75.2229C412.857 74.0402 411.355 72.4223 410.31 70.5146C410.063 69.9459 409.829 69.3772 409.582 68.8393C409.36 68.1697 409.195 67.4824 409.089 66.785C408.753 63.8188 408.622 60.833 408.697 57.8488L408.635 57.7827Z"
          fill="white"
        />
        <path
          d="M627.347 38.5394H651.176V44.0192H632.989V55.0406H648.527V60.2162H632.989V71.5726H651.18V77.0701H627.347V38.5394Z"
          fill="white"
        />
        <path
          d="M719.388 66.2957C718.804 69.49 717.155 72.3925 714.712 74.5309C712.328 76.4351 709.351 77.4415 706.301 77.3744C703.706 77.3931 701.165 76.6246 699.015 75.1701C697.173 74.0074 695.666 72.3846 694.642 70.4618C694.359 69.9177 694.106 69.3584 693.884 68.7865C693.635 68.1239 693.463 67.4344 693.373 66.7322C693.038 63.766 692.906 60.7802 692.981 57.796C692.903 54.8016 693.034 51.8053 693.373 48.8291C693.562 47.5361 693.993 46.2904 694.642 45.1568C695.603 43.4043 696.944 41.8897 698.568 40.7242C700.191 39.5588 702.055 38.7722 704.022 38.4224C705.99 38.0726 708.01 38.1685 709.936 38.703C711.861 39.2375 713.642 40.197 715.148 41.5109C717.384 43.6868 718.88 46.5105 719.424 49.5829H713.447C712.981 48.0565 712.109 46.6852 710.925 45.6152C709.614 44.5564 707.977 43.9847 706.293 43.9973C705.107 43.9942 703.937 44.2738 702.881 44.8129C701.95 45.288 701.142 45.9714 700.518 46.81C699.731 47.7139 699.224 48.8276 699.059 50.015C698.726 52.5811 698.594 55.1696 698.667 57.7564C698.593 60.3373 698.724 62.92 699.059 65.4801C699.224 66.6806 699.731 67.8083 700.518 68.7292C701.141 69.5541 701.951 70.219 702.881 70.669C703.914 71.2757 705.095 71.5811 706.293 71.5507C707.888 71.5254 709.435 71.0018 710.718 70.0531C712.001 69.1045 712.955 67.7784 713.447 66.2604L719.388 66.2957Z"
          fill="white"
        />
        <path
          d="M767.456 43.7151H757.238V38.5394H783.342V43.7151H773.107V77.0657H767.451V43.7151H767.456Z"
          fill="white"
        />
        <path
          d="M341.546 138.596L362.841 111.13C363.571 110.201 364.142 109.159 364.534 108.044C364.72 107.202 364.818 106.342 364.825 105.479C364.837 103.469 364.134 101.52 362.841 99.9813C362.149 99.1855 361.286 98.5559 360.317 98.1392C359.347 97.7225 358.297 97.5294 357.243 97.5742C356.252 97.5427 355.266 97.7138 354.343 98.0768C353.421 98.4399 352.582 98.9875 351.879 99.6859C350.312 101.299 349.373 103.419 349.234 105.664H341.502C341.551 101.379 343.169 97.2616 346.051 94.0915C347.406 92.6526 349.042 91.5066 350.857 90.7241C352.672 89.9417 354.628 89.5393 356.604 89.5418C358.727 89.4869 360.84 89.8673 362.811 90.6596C364.782 91.4519 366.57 92.6393 368.064 94.1488C370.722 96.9972 372.3 100.685 372.526 104.574C372.752 108.463 371.612 112.309 369.303 115.446L351.817 138.146H372.6V146.134H341.546V138.582V138.596Z"
          fill="white"
        />
        <path
          d="M470.901 123.047L454.517 90.0137H463.249L474.793 114.926L486.306 90.0137H495.038L478.654 123.029V146.148H470.901V123.047Z"
          fill="white"
        />
        <path
          d="M528.005 138.159H537.888C539.852 138.309 541.821 137.935 543.593 137.074C545.365 136.214 546.876 134.898 547.973 133.261C548.951 131.9 549.559 130.308 549.736 128.641C550.025 125.247 550.136 121.841 550.071 118.436C550.071 113.551 549.97 110.059 549.736 107.939C549.54 106.06 548.802 104.278 547.612 102.812C546.552 101.24 545.099 99.9743 543.398 99.1404C541.696 98.3064 539.805 97.9336 537.914 98.0592H528.032V138.221L528.005 138.159ZM519.798 90.0577H538.818C542.188 89.9418 545.524 90.7652 548.453 92.4359C551.382 94.1065 553.789 96.5587 555.405 99.5185C556.673 101.529 557.512 103.781 557.869 106.131C558.24 110.114 558.387 114.114 558.31 118.114C558.419 122.337 558.199 126.563 557.653 130.753C557.482 131.857 557.186 132.938 556.771 133.976C556.357 134.981 555.869 135.955 555.312 136.89C553.656 139.583 551.37 141.834 548.652 143.45C545.556 145.37 541.961 146.328 538.32 146.205H519.807V90.0137L519.798 90.0577Z"
          fill="white"
        />
        <path
          d="M575.841 118.092C575.734 121.844 575.939 125.598 576.453 129.316C576.727 131.064 577.467 132.706 578.595 134.068C579.507 135.261 580.684 136.224 582.034 136.881C583.542 137.77 585.269 138.219 587.019 138.177C588.82 138.224 590.599 137.776 592.163 136.881C593.47 136.221 594.599 135.256 595.456 134.068C596.599 132.708 597.36 131.068 597.66 129.316C598.114 125.593 598.293 121.841 598.197 118.092C598.292 114.317 598.112 110.541 597.66 106.793C597.344 105.063 596.585 103.445 595.456 102.097C594.59 100.892 593.465 99.8964 592.163 99.1834C590.56 98.4032 588.802 97.9948 587.019 97.9887C585.288 97.999 583.582 98.4078 582.034 99.1834C580.69 99.8938 579.517 100.888 578.595 102.097C577.48 103.446 576.741 105.066 576.453 106.793C575.941 110.536 575.736 114.315 575.841 118.092V118.092ZM567.62 118.092C567.523 113.711 567.709 109.329 568.175 104.972C568.459 103.091 569.086 101.278 570.026 99.6243C571.525 96.8336 573.694 94.4596 576.339 92.7161C579.494 90.573 583.237 89.4624 587.05 89.5375C590.9 89.4637 594.68 90.5732 597.88 92.7161C600.504 94.4659 602.641 96.8535 604.091 99.6551C605.084 101.289 605.73 103.112 605.986 105.007C606.406 109.355 606.565 113.725 606.462 118.092C606.561 122.437 606.4 126.784 605.982 131.11C605.729 133.038 605.084 134.894 604.086 136.563C602.641 139.344 600.501 141.704 597.876 143.414C594.676 145.516 590.933 146.636 587.105 146.636C583.277 146.636 579.533 145.516 576.334 143.414C573.684 141.702 571.513 139.344 570.022 136.563L568.916 134.13C568.585 133.147 568.336 132.138 568.171 131.114C567.707 126.791 567.522 122.443 567.615 118.096L567.62 118.092Z"
          fill="white"
        />
        <path
          d="M654.336 130.462C653.457 135.106 651.058 139.326 647.517 142.458C644.023 145.238 639.666 146.707 635.202 146.61C631.396 146.644 627.669 145.52 624.517 143.388C621.856 141.684 619.678 139.325 618.192 136.537C617.782 135.655 617.433 134.875 617.085 134.103C616.748 133.122 616.499 132.113 616.34 131.088C615.869 126.765 615.684 122.416 615.785 118.069C615.679 113.689 615.864 109.306 616.34 104.95C616.63 103.069 617.257 101.256 618.192 99.5977C619.68 96.8057 621.844 94.4307 624.486 92.6895C628.053 90.3616 632.283 89.2628 636.532 89.5605C640.781 89.8581 644.816 91.5358 648.024 94.3383C651.33 97.5036 653.528 101.65 654.292 106.162H645.547C644.907 103.906 643.632 101.882 641.875 100.33C639.975 98.7914 637.602 97.9567 635.158 97.9665C633.421 97.9678 631.709 98.3771 630.159 99.1613C628.807 99.8674 627.628 100.862 626.703 102.075C625.592 103.423 624.862 105.044 624.592 106.77C624.064 110.512 623.859 114.293 623.979 118.069C623.858 121.822 624.063 125.577 624.592 129.294C624.862 130.905 625.508 132.43 626.477 133.746C627.447 135.061 628.713 136.129 630.172 136.863C631.684 137.754 633.416 138.203 635.171 138.159C637.491 138.121 639.742 137.358 641.608 135.978C643.474 134.598 644.862 132.67 645.578 130.462H654.336Z"
          fill="white"
        />
        <path
          d="M670.725 97.5479H655.826V90.0137H693.88V97.5479H678.924V146.148H670.725V97.5479Z"
          fill="white"
        />
        <path
          d="M705.904 118.092C705.793 121.843 705.987 125.596 706.486 129.316C706.755 131.063 707.49 132.705 708.615 134.068C709.523 135.264 710.702 136.228 712.053 136.881C713.575 137.776 715.318 138.225 717.083 138.177C718.875 138.217 720.644 137.769 722.2 136.881C723.494 136.212 724.613 135.249 725.467 134.068C726.616 132.712 727.378 131.07 727.671 129.316C728.17 125.597 728.361 121.842 728.239 118.092C728.359 114.316 728.169 110.537 727.671 106.793C727.362 105.061 726.602 103.441 725.467 102.097C724.603 100.9 723.488 99.9053 722.2 99.1834C720.605 98.4088 718.856 98.0006 717.083 97.9887C715.337 97.9938 713.615 98.4027 712.053 99.1834C710.707 99.89 709.533 100.885 708.615 102.097C707.504 103.447 706.77 105.067 706.486 106.793C705.989 110.537 705.795 114.316 705.904 118.092V118.092ZM697.64 118.092C697.529 113.711 697.719 109.327 698.208 104.972C698.501 103.093 699.123 101.282 700.046 99.6198C701.542 96.8188 703.723 94.4423 706.385 92.7117C709.531 90.5608 713.272 89.4493 717.083 89.5331C720.936 89.4654 724.719 90.5742 727.926 92.7117C730.536 94.466 732.66 96.8533 734.097 99.6507C735.098 101.277 735.735 103.102 735.962 104.998C736.369 109.359 736.53 113.739 736.442 118.118C736.526 122.463 736.365 126.809 735.962 131.137C735.725 133.07 735.074 134.931 734.053 136.59C732.619 139.366 730.494 141.726 727.882 143.441C724.672 145.577 720.894 146.7 717.039 146.663C713.557 146.653 710.142 145.714 707.144 143.943C704.146 142.172 701.675 139.634 699.985 136.59C699.592 135.708 699.24 134.928 698.922 134.156C698.567 133.18 698.312 132.169 698.164 131.141C697.678 126.819 697.488 122.47 697.595 118.122L697.64 118.092Z"
          fill="white"
        />
        <path
          d="M755.842 114.56H768.338C769.546 114.632 770.756 114.451 771.891 114.031C773.025 113.61 774.061 112.959 774.931 112.118C775.801 111.276 776.486 110.264 776.945 109.144C777.404 108.024 777.625 106.821 777.595 105.611C777.668 104.409 777.458 103.206 776.982 102.1C776.506 100.993 775.777 100.014 774.853 99.2407C773.094 97.9752 770.95 97.3625 768.788 97.5081H755.829L755.842 114.56ZM747.621 90.0136H768.902C772.918 89.8394 776.858 91.141 779.98 93.6727C781.718 95.141 783.104 96.9814 784.035 99.0579C784.966 101.134 785.417 103.394 785.357 105.668C785.531 109.05 784.602 112.397 782.709 115.205C780.816 118.012 778.062 120.129 774.862 121.235L787.469 146.148H777.661L766.408 122.139H755.829V146.148H747.621V90.0136Z"
          fill="white"
        />
        <path
          d="M401.785 90.8424L424.944 124.211L447.843 90.8424V146.513H439.667V117.563H439.477L424.887 138.525L410.072 117.563L409.957 117.36V146.513H401.785V90.8424Z"
          fill="white"
        />
        <path
          d="M479.862 39.0508L502.783 62.2882L502.872 37.3888H508.672V77.0657L485.822 53.8767L485.69 77.0833H479.862V39.0508Z"
          fill="white"
        />
        <path
          d="M553.307 39.214L576.175 62.4338L576.29 37.5652H582.104V77.2421L559.249 54.0046L559.125 77.2288H553.307V39.214Z"
          fill="white"
        />
        <path
          d="M127.195 0H0V180.913H127.195V124.369H62.1912V59.3566H127.195V0Z"
          fill="white"
        />
        <path
          d="M192.185 0H319.423V180.913H192.185V124.369H257.201V59.3566H192.185V0Z"
          fill="white"
        />
        <path
          d="M127.238 180.799L52.6743 241.103L68.8073 180.799L88.3828 162.168L122.954 167.141L127.225 180.944"
          fill="white"
        />
        <path
          d="M127.569 124.167H61.4595V181.627H127.569V124.167Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_306_32">
          <rect width="815" height="241.103" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddFileIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.6663 18.6667H29.333V29.3334H18.6663V34.6667H29.333V45.3334H34.6663V34.6667H45.333V29.3334H34.6663V18.6667ZM31.9997 5.33337C17.2797 5.33337 5.33301 17.28 5.33301 32C5.33301 46.72 17.2797 58.6667 31.9997 58.6667C46.7197 58.6667 58.6663 46.72 58.6663 32C58.6663 17.28 46.7197 5.33337 31.9997 5.33337ZM31.9997 53.3334C20.2397 53.3334 10.6663 43.76 10.6663 32C10.6663 20.24 20.2397 10.6667 31.9997 10.6667C43.7597 10.6667 53.333 20.24 53.333 32C53.333 43.76 43.7597 53.3334 31.9997 53.3334Z"
        fill="#A2A2A2"
      />
    </svg>
  );
};

export const InviteIcon_V2 = ({ status }) => {
  let color = status ? "#8AB4F8" : "white";

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_206_2)">
        <path
          d="M85.9886 34.5182C85.9862 34.5003 85.9821 34.483 85.9791 34.4653C85.9728 34.4295 85.9659 34.3941 85.9566 34.3592C85.9512 34.3389 85.9447 34.3193 85.9383 34.2994C85.9283 34.2677 85.9172 34.2365 85.9047 34.2058C85.8966 34.186 85.888 34.1665 85.879 34.1472C85.8649 34.1173 85.8495 34.0882 85.8331 34.0595C85.8228 34.0414 85.8128 34.0233 85.8015 34.0057C85.7828 33.9762 85.7621 33.9481 85.7409 33.9202C85.7295 33.9053 85.7191 33.8899 85.7071 33.8755C85.6782 33.8412 85.6475 33.8085 85.6152 33.7775C85.6086 33.7712 85.603 33.7641 85.5963 33.7579C85.5593 33.7235 85.5201 33.6914 85.4792 33.6618L46.695 5.56841C45.621 4.78807 44.3276 4.36778 43 4.3678C41.6725 4.36781 40.379 4.78813 39.305 5.56849L0.520822 33.6618C0.479874 33.6914 0.44075 33.7236 0.403662 33.7579C0.397142 33.764 0.391606 33.7709 0.385228 33.7771C0.352736 33.8082 0.321943 33.8411 0.292981 33.8755C0.280966 33.8899 0.270488 33.9053 0.259149 33.9202C0.237928 33.9481 0.217259 33.9762 0.198499 34.0057C0.187283 34.0233 0.177215 34.0414 0.166921 34.0595C0.150559 34.0882 0.135139 34.1173 0.121065 34.1472C0.111995 34.1665 0.103474 34.186 0.0953659 34.2058C0.0827767 34.2365 0.0717663 34.2678 0.0616361 34.2995C0.0553004 34.3193 0.0487815 34.3389 0.0434283 34.3591C0.0341413 34.394 0.0272311 34.4296 0.0209575 34.4654C0.017882 34.4831 0.01376 34.5004 0.0114219 34.5182C0.00405711 34.5725 0.000241709 34.6272 0 34.682V75.3304C0.00187922 77.0004 0.666107 78.6014 1.84696 79.7823C3.02781 80.9631 4.62885 81.6273 6.29883 81.6292H79.7012C81.3711 81.6273 82.9722 80.9631 84.153 79.7823C85.3339 78.6014 85.9981 77.0004 86 75.3304V34.682C85.9998 34.6272 85.996 34.5725 85.9886 34.5182V34.5182ZM40.783 7.60897C41.4274 7.14073 42.2035 6.88854 43 6.88854C43.7966 6.88854 44.5727 7.14073 45.2171 7.60897L82.5927 34.6819L65.8438 46.814V29.6431C65.8419 27.9732 65.1777 26.3721 63.9968 25.1913C62.816 24.0104 61.2149 23.3462 59.5449 23.3443H26.4551C24.7851 23.3462 23.1841 24.0104 22.0032 25.1913C20.8224 26.3721 20.1581 27.9732 20.1563 29.6431V46.814L3.40727 34.6819L40.783 7.60897ZM40.8122 44.1317C42.3136 45.0495 44.0393 45.5348 45.7991 45.5339C46.4614 45.5327 47.122 45.466 47.7713 45.335C47.7282 46.5864 47.1951 47.7708 46.2871 48.633C45.3791 49.4952 44.1687 49.9662 42.9167 49.9445C41.6647 49.9229 40.4714 49.4103 39.5937 48.5172C38.7161 47.624 38.2244 46.4219 38.2246 45.1697V43.0769C38.2244 41.8386 38.7054 40.6486 39.5659 39.7581C40.4265 38.8676 41.5994 38.3463 42.8371 38.3042C44.0747 38.2621 45.2803 38.7025 46.1994 39.5325C47.1185 40.3624 47.6792 41.517 47.7632 42.7525C46.5532 43.0833 45.2787 43.0987 44.061 42.7974C43.3774 42.6225 42.7237 42.3467 42.1215 41.9791C41.9801 41.893 41.8232 41.8357 41.6597 41.8103C41.4962 41.7849 41.3293 41.792 41.1685 41.8311C41.0077 41.8702 40.8562 41.9407 40.7227 42.0384C40.5891 42.136 40.4761 42.2591 40.3901 42.4005C40.3041 42.5418 40.2468 42.6988 40.2215 42.8623C40.1962 43.0258 40.2033 43.1927 40.2425 43.3535C40.2817 43.5143 40.3522 43.6657 40.4499 43.7993C40.5477 43.9328 40.6708 44.0457 40.8122 44.1317V44.1317ZM44.8611 52.2232V52.3508C44.8615 52.5884 44.8151 52.8238 44.7244 53.0434C44.6338 53.263 44.5007 53.4626 44.3328 53.6308C44.165 53.7989 43.9656 53.9323 43.7461 54.0234C43.5266 54.1144 43.2913 54.1612 43.0537 54.1612C42.8161 54.1612 42.5809 54.1144 42.3614 54.0234C42.1419 53.9323 41.9425 53.7989 41.7747 53.6308C41.6068 53.4626 41.4737 53.263 41.3831 53.0434C41.2924 52.8238 41.246 52.5884 41.2464 52.3508V52.2503C42.4344 52.5451 43.6776 52.5358 44.8611 52.2232V52.2232ZM43.0538 56.6777C43.7406 56.6768 44.4173 56.5125 45.0281 56.1985C45.6389 55.8846 46.1663 55.4299 46.5668 54.872L49.0876 56.2156C49.7634 56.5786 50.3468 57.0919 50.7929 57.716L45.2171 61.7549C44.5727 62.2231 43.7966 62.4752 43 62.4753C42.2035 62.4753 41.4274 62.2231 40.783 61.7549L35.2039 57.7138C35.651 57.0902 36.2355 56.5776 36.9121 56.2157L39.5107 54.8317C39.909 55.4019 40.4392 55.8675 41.0561 56.1888C41.6729 56.5102 42.3583 56.678 43.0538 56.6777V56.6777ZM50.2725 53.9921L47.3774 52.449C47.3782 52.4163 47.3807 52.3836 47.3807 52.3508V50.9989C48.2855 50.3201 49.0199 49.44 49.5257 48.4282C50.0315 47.4165 50.2949 46.3009 50.295 45.1698V43.0769C50.295 41.1422 49.5264 39.2867 48.1584 37.9186C46.7903 36.5505 44.9348 35.782 43 35.782C41.0653 35.782 39.2098 36.5505 37.8417 37.9186C36.4736 39.2867 35.705 41.1422 35.705 43.0769V45.1697C35.7054 46.3232 35.9795 47.4601 36.5048 48.487C37.0301 49.5139 37.7917 50.4015 38.7268 51.0767V52.3508C38.7268 52.3652 38.728 52.3795 38.7281 52.3939L35.7268 53.9925C34.7125 54.5349 33.836 55.3026 33.1645 56.2365L22.6758 48.6391V29.6431C22.6769 28.6412 23.0755 27.6805 23.784 26.972C24.4925 26.2635 25.4531 25.865 26.4551 25.8638H59.5449C60.5469 25.865 61.5075 26.2635 62.2161 26.972C62.9246 27.6805 63.3231 28.6412 63.3242 29.6431V48.639L52.836 56.2361C52.1638 55.3024 51.2869 54.5349 50.2725 53.9921V53.9921ZM2.51955 75.3304V37.15L25.9886 54.1497L2.9879 77.1504C2.68005 76.5932 2.51889 75.9669 2.51955 75.3304V75.3304ZM79.7012 79.1097H6.29885C5.80961 79.11 5.32503 79.0147 4.8723 78.8292L28.055 55.6465L39.305 63.7954C40.379 64.5757 41.6725 64.996 43 64.996C44.3276 64.996 45.621 64.5757 46.695 63.7954L58.2328 55.4381L81.4657 78.671C80.9224 78.9596 80.3164 79.1102 79.7012 79.1097ZM83.4805 75.3304C83.4809 75.8416 83.3771 76.3476 83.1752 76.8173L60.2992 53.9413L83.4805 37.15V75.3304Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_206_2">
          <rect width="86" height="86" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowLeftBlue = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64 28H15.32L37.68 5.64L32 0L0 32L32 64L37.64 58.36L15.32 36H64V28Z"
        fill="#208CE1"
      />
    </svg>
  );
};

export const InformationIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.4174 70.5913C40.6522 70.5913 39.887 70.3043 39.313 69.8261C38.3565 69.0609 37.8783 67.8174 38.1652 66.5739L42.8522 42.6609L40.2696 44.0957C38.6435 44.9565 36.6348 44.4783 35.6783 42.8522C34.8174 41.2261 35.2957 39.2174 36.9217 38.2609L45.8174 33.1913C46.9652 32.5217 48.4 32.6174 49.4522 33.3826C50.5043 34.1478 50.9826 35.487 50.7913 36.7304L45.913 61.6L49.9304 59.8783C51.6522 59.113 53.5652 59.8783 54.3304 61.6C55.0957 63.3217 54.3304 65.2348 52.6087 66L42.7565 70.3043C42.3739 70.4957 41.8957 70.5913 41.4174 70.5913V70.5913ZM50.887 24.8696C51.7478 24.0087 52.3217 22.7652 52.3217 21.5217C52.3217 20.2783 51.8435 19.0348 50.887 18.1739C50.0261 17.313 48.7826 16.7391 47.5391 16.7391C46.2957 16.7391 45.0522 17.2174 44.1913 18.1739C43.3304 19.0348 42.7565 20.2783 42.7565 21.5217C42.7565 22.7652 43.2348 24.0087 44.1913 24.8696C45.0522 25.7304 46.2957 26.3043 47.5391 26.3043C48.7826 26.3043 50.0261 25.8261 50.887 24.8696ZM88 44C88 19.7043 68.2957 0 44 0C19.7043 0 0 19.7043 0 44C0 68.2957 19.7043 88 44 88C68.2957 88 88 68.2957 88 44ZM80.3478 44C80.3478 64.087 64.087 80.3478 44 80.3478C23.913 80.3478 7.65217 64.087 7.65217 44C7.65217 23.913 23.913 7.65217 44 7.65217C64.087 7.65217 80.3478 23.913 80.3478 44Z"
        fill="#208CE1"
      />
    </svg>
  );
};

export const AddIconV2 = () => {
  return (
    <svg
      width="45"
      height="25"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.6663 18.6667H29.333V29.3334H18.6663V34.6667H29.333V45.3334H34.6663V34.6667H45.333V29.3334H34.6663V18.6667ZM31.9997 5.33337C17.2797 5.33337 5.33301 17.28 5.33301 32C5.33301 46.72 17.2797 58.6667 31.9997 58.6667C46.7197 58.6667 58.6663 46.72 58.6663 32C58.6663 17.28 46.7197 5.33337 31.9997 5.33337ZM31.9997 53.3334C20.2397 53.3334 10.6663 43.76 10.6663 32C10.6663 20.24 20.2397 10.6667 31.9997 10.6667C43.7597 10.6667 53.333 20.24 53.333 32C53.333 43.76 43.7597 53.3334 31.9997 53.3334Z"
        fill="#258FC3"
      />
    </svg>
  );
};

export const AddIcon_Prescription = () => {
  return (
    <svg
      style={{ marginRight: 10 }}
      width="12"
      height="12"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="white" />
    </svg>
  );
};

export const DeleteIcon_Prescription = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 22 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.1875 8.3125V25.5C3.1875 26.047 3.36529 26.5716 3.68176 26.9584C3.99822 27.3452 4.42745 27.5625 4.875 27.5625H17.25C17.6976 27.5625 18.1268 27.3452 18.4432 26.9584C18.7597 26.5716 18.9375 26.047 18.9375 25.5V8.3125H3.1875Z"
        stroke="black"
      />
      <path
        d="M7.125 3.95788V2.4605C7.125 1.51587 7.83037 0.75 8.7 0.75H13.425C14.2946 0.75 15 1.51587 15 2.4605V3.95925M6.5625 12.3137V23.5613V12.3137ZM11.0625 12.3137V23.5613V12.3137ZM15.5625 12.3137V23.5613V12.3137Z"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M19.5 4.1875H2.625C1.69302 4.1875 0.9375 5.11091 0.9375 6.25C0.9375 7.38909 1.69302 8.3125 2.625 8.3125H19.5C20.432 8.3125 21.1875 7.38909 21.1875 6.25C21.1875 5.11091 20.432 4.1875 19.5 4.1875Z"
        stroke="black"
      />
    </svg>
  );
};

export const LabelIcon_Prescription = () => {
  return (
    <svg
      style={{ marginRight: 10 }}
      width="17"
      height="17"
      viewBox="0 0 61 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M55.9167 0H5.08333C3.73515 0 2.44218 0.533369 1.48887 1.48277C0.535564 2.43217 1.63088e-07 3.71984 1.63088e-07 5.0625V75.9299C-0.000335484 76.5965 0.13137 77.2565 0.387573 77.8723C0.643775 78.4881 1.01944 79.0475 1.49306 79.5184C1.96667 79.9894 2.52893 80.3627 3.14762 80.6169C3.76632 80.8712 4.42929 81.0013 5.09858 81C6.09746 81 7.07346 80.6988 7.90204 80.1394L28.8403 62.1726C29.3017 61.7763 29.8907 61.5584 30.5 61.5584C31.1093 61.5584 31.6983 61.7763 32.1597 62.1726L53.098 80.1419C53.9265 80.6988 54.9025 80.9975 55.9014 81C56.5707 81.0013 57.2337 80.8712 57.8524 80.6169C58.4711 80.3627 59.0333 79.9894 59.5069 79.5184C59.9806 79.0475 60.3562 78.4881 60.6124 77.8723C60.8686 77.2565 61.0003 76.5965 61 75.9299V5.0625C61 3.71984 60.4644 2.43217 59.5111 1.48277C58.5578 0.533369 57.2649 0 55.9167 0ZM5.08333 5.0625L37.1363 53.0803L53.098 33C52.6365 32.6038 -38.5 77.8723 30.5 48.1934C48.2917 62.1726 18.1597 18.8174 16.5 57.5L23.8663 53.0803L59.5069 5.0625L10.1667 12.6562C10.1667 11.9849 10.4345 11.3411 10.9111 10.8664C11.3878 10.3917 12.0342 10.125 12.7083 10.125H48.2917C48.9658 10.125 49.6122 10.3917 50.0889 10.8664C50.5656 11.3411 50.8333 11.9849 50.8333 12.6562L5.08333 5.0625Z"
        fill="white"
      />
    </svg>
  );
};

export const ClearInputIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9062 2.8125C12.2569 2.8125 2.8125 12.2569 2.8125 23.9062C2.8125 35.5556 12.2569 45 23.9062 45C35.5556 45 45 35.5556 45 23.9062C45 12.2569 35.5556 2.8125 23.9062 2.8125ZM33.6797 16.1212L25.8412 23.9597L32.7769 31.6912C33.033 31.9565 33.1748 32.3117 33.1716 32.6804C33.1684 33.0491 33.0205 33.4018 32.7597 33.6626C32.499 33.9233 32.1463 34.0712 31.7776 34.0744C31.4089 34.0776 31.0537 33.9358 30.7884 33.6797L23.8528 25.9481L16.1212 33.6797C15.856 33.9358 15.5008 34.0776 15.1321 34.0744C14.7634 34.0712 14.4107 33.9233 14.1499 33.6626C13.8892 33.4018 13.7413 33.0491 13.7381 32.6804C13.7349 32.3117 13.8767 31.9565 14.1328 31.6912L21.9712 23.8528L15.0356 16.1212C14.7795 15.856 14.6377 15.5008 14.6409 15.1321C14.6441 14.7634 14.792 14.4107 15.0528 14.1499C15.3135 13.8892 15.6662 13.7413 16.0349 13.7381C16.4036 13.7349 16.7588 13.8767 17.0241 14.1328L23.9597 21.8644L31.6912 14.1328C31.9565 13.8767 32.3117 13.7349 32.6804 13.7381C33.0491 13.7413 33.4018 13.8892 33.6626 14.1499C33.9233 14.4107 34.0712 14.7634 34.0744 15.1321C34.0776 15.5008 33.9358 15.856 33.6797 16.1212Z"
        fill="#D6D6D6"
      />
    </svg>
  );
};

export const SimpleCloseIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.04999 14.95C1.23752 15.1375 1.49182 15.2428 1.75699 15.2428C2.02215 15.2428 2.27646 15.1375 2.46399 14.95L7.99999 9.414L13.536 14.95C13.7246 15.1322 13.9772 15.233 14.2394 15.2307C14.5016 15.2284 14.7524 15.1232 14.9378 14.9378C15.1232 14.7524 15.2284 14.5016 15.2307 14.2394C15.2329 13.9772 15.1321 13.7246 14.95 13.536L9.41399 8L14.95 2.464C15.1321 2.2754 15.2329 2.02279 15.2307 1.7606C15.2284 1.4984 15.1232 1.24759 14.9378 1.06218C14.7524 0.876772 14.5016 0.771603 14.2394 0.769325C13.9772 0.767046 13.7246 0.867841 13.536 1.05L7.99999 6.586L2.46399 1.05C2.27539 0.867841 2.02278 0.767046 1.76059 0.769325C1.49839 0.771603 1.24758 0.876772 1.06217 1.06218C0.876762 1.24759 0.771593 1.4984 0.769315 1.7606C0.767036 2.02279 0.867831 2.2754 1.04999 2.464L6.58599 8L1.04999 13.536C0.862518 13.7235 0.757202 13.9778 0.757202 14.243C0.757202 14.5082 0.862518 14.7625 1.04999 14.95V14.95Z"
        fill="black"
      />
    </svg>
  );
};

export const SimpleCloseIconRed = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.645 14L22.995 6.66167C23.2147 6.44198 23.3381 6.14402 23.3381 5.83333C23.3381 5.52265 23.2147 5.22469 22.995 5.005C22.7753 4.78531 22.4773 4.66189 22.1667 4.66189C21.856 4.66189 21.558 4.78531 21.3383 5.005L14 12.355L6.66166 5.005C6.44197 4.78531 6.14401 4.66189 5.83333 4.66189C5.52264 4.66189 5.22468 4.78531 5.00499 5.005C4.78531 5.22469 4.66189 5.52265 4.66189 5.83333C4.66189 6.14402 4.78531 6.44198 5.00499 6.66167L12.355 14L5.00499 21.3383C4.89565 21.4468 4.80885 21.5758 4.74962 21.718C4.69039 21.8602 4.6599 22.0127 4.6599 22.1667C4.6599 22.3207 4.69039 22.4732 4.74962 22.6153C4.80885 22.7575 4.89565 22.8865 5.00499 22.995C5.11345 23.1043 5.24249 23.1911 5.38466 23.2504C5.52682 23.3096 5.67931 23.3401 5.83333 23.3401C5.98734 23.3401 6.13983 23.3096 6.282 23.2504C6.42417 23.1911 6.5532 23.1043 6.66166 22.995L14 15.645L21.3383 22.995C21.4468 23.1043 21.5758 23.1911 21.718 23.2504C21.8602 23.3096 22.0126 23.3401 22.1667 23.3401C22.3207 23.3401 22.4732 23.3096 22.6153 23.2504C22.7575 23.1911 22.8865 23.1043 22.995 22.995C23.1043 22.8865 23.1911 22.7575 23.2504 22.6153C23.3096 22.4732 23.3401 22.3207 23.3401 22.1667C23.3401 22.0127 23.3096 21.8602 23.2504 21.718C23.1911 21.5758 23.1043 21.4468 22.995 21.3383L15.645 14Z"
        fill="#FF0000"
      />
    </svg>
  );
};

export const AppointmentHistoryIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 147 138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_102_2)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.18728 123.338V43.7H137.812V123.338C137.812 126.862 135.877 128.8 132.357 128.8H14.6422C11.1216 128.8 9.18728 126.862 9.18728 123.338V123.338ZM146.999 21.8433V125.359C146.994 129.838 143.566 134.601 139.352 136.667C138.13 137.267 136.038 138 134.366 138H12.6315C6.40964 138 0.00368777 131.587 -0.000915527 125.357V21.834C0.00368777 20.1635 0.732851 18.0763 1.32944 16.8566C3.39448 12.6352 8.15614 9.19922 12.6324 9.19922H33.304V4.02361C33.304 2.22864 35.5301 -0.00146484 37.3236 -0.00146484C40.4999 -0.00146484 42.4922 1.93824 42.4922 4.02361V9.19922H104.507V4.02361C104.507 2.22864 106.734 -0.00146484 108.527 -0.00146484C111.703 -0.00146484 113.694 1.93824 113.694 4.02361V9.19922H134.366C140.588 9.19922 146.994 15.612 146.998 21.8423L146.999 21.8433ZM9.18728 23.8622C9.18728 20.2456 11.0304 18.3999 14.6422 18.3999H33.304V23.5746C33.304 25.66 35.2954 27.5997 38.4716 27.5997C40.2642 27.5997 42.4912 25.3696 42.4912 23.5746V18.3999H104.506V23.5746C104.506 25.66 106.497 27.5997 109.675 27.5997C111.467 27.5997 113.694 25.3696 113.694 23.5746V18.3999H132.356C135.877 18.3999 137.811 20.3378 137.811 23.8622V34.4993H9.18635V23.8622H9.18728Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M105.344 85.7521V87.583C105.315 90.9222 105.124 92.5291 104.129 96.1227C103.477 98.4782 101.79 101.785 100.396 103.706C99.8493 104.46 97.7161 107.139 97.1527 107.607C96.8194 107.884 96.7107 107.943 96.3885 108.272C95.8674 108.802 95.5167 109.078 94.9228 109.545C92.681 111.31 90.5865 112.538 87.749 113.681C85.4538 114.606 81.5723 115.589 78.3316 115.571C71.8888 115.538 67.8784 114.199 62.8977 111.244C60.1375 109.607 57.5238 106.998 55.5996 104.49C54.6587 103.265 53.877 101.89 55.1015 100.414C55.502 99.9311 56.3076 99.5467 57.0275 99.5421C58.9324 99.5292 59.6671 101.565 61.4596 103.508C61.9659 104.057 62.4198 104.364 62.9474 104.878C65.0133 106.893 69.195 108.971 72.165 109.709C75.3772 110.506 78.7984 110.678 82.2288 109.942C84.4328 109.47 87.517 108.363 89.397 107.111C94.4855 103.725 98.0135 99.4324 99.5123 93.4077C102.623 80.9028 95.0701 68.9364 83.2111 65.8784C75.6019 63.9166 67.0434 66.5431 62.7117 70.8567C62.3987 71.1684 62.2431 71.2264 61.9365 71.5095L59.3614 74.5315C58.0973 76.3689 55.8841 80.1754 55.839 82.2055C56.6896 81.7547 58.4914 80.4105 59.5483 79.7228C60.7645 78.9318 62.8212 79.2093 63.4501 81.1398C63.8717 82.4369 63.1886 83.3551 62.4705 83.959C62.1188 84.2549 61.6723 84.5075 61.2662 84.7795L57.649 87.2336C54.3235 89.4536 52.2346 91.7611 50.0563 88.4736C49.7543 88.0191 49.5508 87.7112 49.2479 87.2576C48.5059 86.1485 44.6115 80.3045 44.4844 79.8731C44.4568 79.7799 44.4347 79.6877 44.4163 79.5956V78.4727C44.7708 76.7791 46.7134 75.7622 48.3982 76.9073C48.9497 77.2825 49.7267 78.6229 50.1281 79.2259L50.9613 80.4179C51.1335 78.3371 53.262 74.3019 54.3622 72.5024C55.1172 71.267 55.9006 70.2852 56.7743 69.1982C59.0778 66.332 63.1831 63.5128 66.4707 61.9861C68.7227 60.9407 72.3887 59.8141 75.4748 59.6822C78.0011 59.5744 78.1622 59.4435 80.8524 59.78C87.6975 60.6392 93.9589 63.9415 98.4711 69.0682C99.4405 70.169 100.627 71.8008 101.38 73.0666C102.777 75.4147 104.071 78.3639 104.64 81.1222C104.902 82.3936 105.3 84.206 105.345 85.7502L105.344 85.7521Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M74.8792 74.3416V87.9269C74.8792 89.1198 78.5038 92.3318 79.4309 93.2592C80.2926 94.1221 81.0678 94.8984 81.9296 95.7613C83.0555 96.8888 83.4864 97.8172 85.232 97.8172C86.4555 97.8172 87.6119 96.7062 87.6119 95.1952C87.6119 93.7441 85.2743 91.8422 84.013 90.5783L80.9776 87.5397C79.4889 86.048 79.9962 86.7146 79.9962 82.3263C79.9962 80.971 80.1297 74.8763 79.8995 74.0807C78.9798 70.8982 74.8782 72.2267 74.8782 74.3416H74.8792Z"
          fill="#0B83DE"
        />
      </g>
      <defs>
        <clipPath id="clip0_102_2">
          <rect width="147" height="138" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BookConsultNowIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_107_2)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.053 92.1225C25.053 87.002 31.5626 87.245 31.5626 91.926C31.5626 96.1457 25.053 95.806 25.053 92.1225ZM98.4827 101H97.7065C96.8522 100.898 96.0374 100.463 95.5522 99.741C94.9455 98.8379 90.1028 83.7906 89.6331 82.3822C88.2541 78.246 88.0892 76.7788 85.072 73.7268C82.8883 71.5183 78.5424 69.894 75.7496 69.8321C75.7496 77.6293 75.2543 76.1334 77.5008 76.9576C81.7058 78.5006 85.2183 83.4021 85.2183 88.5721V98.2382C85.2183 98.8882 84.6418 99.9128 84.2719 100.251C83.765 100.714 83.0562 100.918 82.2483 101H78.7088C75.4176 101 74.7753 95.0824 79.1026 95.0824V87.7836C79.1026 83.3139 72.5064 79.803 68.1992 83.7844C67.3914 84.5311 66.2801 86.3133 66.2801 87.7836V95.0824C70.6074 95.0824 69.9659 101 66.6748 101H63.3589C61.6386 100.848 60.1645 100.225 60.1645 98.0408V88.1775C60.1645 84.7811 61.5868 82.2282 63.1809 80.3447C66.2043 76.7695 69.6332 76.9893 69.6332 75.9469C69.6332 67.2072 70.1934 68.5289 67.8982 68.0166C67.2869 67.8804 66.5324 67.7094 65.8011 67.5492C60.5622 66.3954 61.7694 66.0882 60.2016 68.686L53.9869 79.0415C53.1891 80.3795 52.5398 82.0626 50.4984 82.0626C48.4083 82.0626 47.7358 80.2526 46.9364 78.9169C46.1262 77.5627 45.3516 76.2735 44.495 74.8489C43.9479 73.938 39.8589 67.4626 39.6484 66.6756C38.7291 66.6756 36.3232 67.3001 35.1958 67.5492C33.6527 67.8889 31.3637 68.0901 31.3637 68.8462V82.4573C31.3637 83.1259 31.8481 83.0206 32.478 83.3154C37.5653 85.702 39.8009 93.0387 35.0665 98.1933C33.467 99.9352 31.1083 100.899 28.7087 101H27.8652C26.5435 100.944 25.2341 100.622 24.0579 100.02C19.0047 97.4341 17.1785 90.9625 20.9865 85.89C23.1664 82.9858 25.2473 83.4632 25.2473 82.4573V69.8321C24.1678 69.856 20.7544 70.7715 19.8606 71.153C18.1906 71.8642 17.0098 72.6341 15.8273 73.8266C12.8674 76.8129 12.6538 78.52 11.3158 82.5323C10.1837 85.9295 9.14367 89.0457 8.01077 92.4436C7.59831 93.681 5.95313 99.0646 5.36347 99.857C4.83648 100.567 4.09437 100.923 3.33059 101.001H2.67592C1.28224 100.862 -0.00311279 99.857 -0.00311279 98.4363C-0.00311279 96.4165 1.48189 92.8979 2.24102 90.6205C3.41416 87.1018 5.76741 79.5468 6.95603 76.5954C7.83898 74.4031 8.80009 72.4925 10.4019 70.77L12.7714 68.4043C15.4443 66.0039 19.0318 64.9948 22.5621 64.1892C27.7375 63.0091 32.7914 61.9428 37.8717 60.7588V53.2626C35.5579 52.0384 33.508 50.2044 31.804 48.2837C24.0703 39.5664 25.2465 31.3018 25.2465 19.7275C25.2465 8.34972 38.9032 0.00154114 49.1156 0.00154114H51.8774C58.1873 0.00154114 64.3834 2.98624 67.9183 5.85719C71.69 8.91927 75.7465 13.0106 75.7465 19.7283V30.9729C75.7465 39.9193 70.8373 49.1814 63.1213 53.2641V60.7603C68.2016 61.9443 73.2555 63.0114 78.431 64.1908C81.3414 64.8539 83.2504 65.2316 85.4984 66.592C86.4193 67.1492 87.5979 67.8208 88.3222 68.5026C88.5884 68.7533 88.6518 68.8477 88.9343 69.0745C91.2929 70.9626 92.976 73.9388 94.0942 76.737C94.9068 78.7691 100.996 96.9629 100.996 97.8466C100.996 99.8485 99.7967 100.843 98.4788 101.003L98.4827 101ZM43.9904 55.8263C48.6946 56.9221 52.3054 56.9221 57.0095 55.8263C57.0095 57.7122 57.0699 59.6893 57.0242 61.5613C56.9894 62.9751 53.6085 67.971 52.8563 69.2292C52.4903 69.8406 52.1498 70.4024 51.7459 71.0779C51.3984 71.6599 50.8598 72.3795 50.6973 72.9885H50.3027C49.8546 71.3085 44.0678 63.3078 43.9788 61.7563C43.8736 59.9416 43.9904 57.6921 43.9904 55.8271V55.8263ZM31.3653 30.7733C34.4335 30.5179 36.8634 26.7176 38.4668 25.6443C39.3497 25.8501 41.5915 26.7044 43.951 27.2616C49.4042 28.55 54.4427 28.054 59.7296 26.5884C60.6992 26.3198 61.5496 25.8725 62.5324 25.6435C64.1358 26.7168 66.5664 30.5171 69.6339 30.7725C69.6339 39.1733 65.7539 45.2193 58.5239 48.8579C51.2506 52.5174 42.6254 50.6052 36.8386 44.8277C33.0112 41.0065 31.3645 36.6189 31.3645 30.7725L31.3653 30.7733ZM31.3653 24.0664C31.3653 20.742 30.9992 17.9167 32.2157 15.6455C35.3474 9.79758 43.4689 5.91755 50.5 5.91755C57.4862 5.91755 65.4691 9.70317 68.7146 15.517C69.9922 17.8045 69.6347 20.6677 69.6347 24.0656C68.0081 22.9761 65.4552 18.9366 63.3217 18.9366C61.5891 18.9366 52.0956 25.0028 40.6304 19.9287C37.1868 18.405 37.0321 18.4971 34.3732 21.1552C33.5374 21.9917 32.2381 23.4798 31.3645 24.0656L31.3653 24.0664Z"
          fill="#0B83DE"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_2">
          <rect width="101" height="101" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ScheduleAppointmentIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 83 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_107_10)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.18777 69.7122V24.6996H77.8127V69.7122C77.8127 71.7044 76.7202 72.8 74.7323 72.8H8.26758C6.28022 72.8 5.18723 71.7044 5.18723 69.7122H5.18777ZM83.0003 12.3464V70.8552C82.9976 73.387 81.0618 76.0787 78.6826 77.2467C77.9928 77.5856 76.8108 77.9996 75.8671 77.9996H7.1328C3.61992 77.9996 0.00283556 74.3749 0.00012207 70.8536V12.3409C0.00283556 11.3965 0.414743 10.2171 0.751216 9.52787C1.91747 7.14186 4.606 5.19976 7.1328 5.19976H18.8046V2.27465C18.8046 1.26008 20.0615 -0.00038147 21.0742 -0.00038147C22.8678 -0.00038147 23.9922 1.09633 23.9922 2.27465V5.19976H59.0076V2.27465C59.0076 1.26008 60.2651 -0.00038147 61.2772 -0.00038147C63.0708 -0.00038147 64.1953 1.09633 64.1953 2.27465V5.19976H75.8671C79.38 5.19976 82.9971 8.82447 82.9998 12.3458L83.0003 12.3464ZM5.18777 13.4877C5.18777 11.4433 6.22866 10.3999 8.26812 10.3999H18.8051V13.325C18.8051 14.5033 19.9296 15.6001 21.7232 15.6001C22.7354 15.6001 23.9928 14.3396 23.9928 13.325V10.3999H59.0082V13.325C59.0082 14.5033 60.1327 15.6001 61.9263 15.6001C62.9384 15.6001 64.1958 14.3396 64.1958 13.325V10.3999H74.7329C76.7202 10.3999 77.8132 11.495 77.8132 13.4877V19.5H5.18831V13.4877H5.18777Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.6641 58.3375C34.9841 57.3196 34.4447 56.8866 33.5942 56.0254L29.2201 51.3095C27.8232 49.9125 27.9155 49.4 25.9379 49.4C24.5822 49.4 23.6683 50.6164 23.6683 52.3251C23.6683 53.5524 25.5775 55.0974 26.3058 55.8563L32.2169 62.281C33.6529 63.7133 35.8426 66.7831 38.2826 63.7248L53.9118 43.1537C54.4192 42.4792 54.8192 41.9983 55.3255 41.3215C55.8172 40.6655 56.2198 40.0872 56.7159 39.4654C57.868 38.0216 59.3322 36.5479 59.3322 34.9376C59.3322 32.5783 56.3154 31.5419 54.6764 33.5205L53.4027 35.1688C52.5029 36.3232 51.7752 37.3693 50.8802 38.49L43.3069 48.4485C42.8619 49.0459 42.4874 49.4849 42.0327 50.0958C41.332 51.0369 36.1786 57.992 35.6646 58.3369L35.6641 58.3375Z"
          fill="#0B83DE"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_10">
          <rect width="83" height="78" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PatientdetailsIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 78 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_107_15)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.4724 67.6408C14.4724 64.7516 15.7931 61.8081 17.343 59.6952C19.4334 56.8445 22.6684 54.8773 26.1669 54.0467C28.8786 53.4029 32.8077 53.7274 35.2941 54.8932C37.7766 56.0576 39.7677 57.6552 41.3732 59.7827C41.821 60.3761 42.4383 61.3644 42.7589 62.0532C44.575 65.9545 44.1776 69.1735 44.1776 73.4311H14.4711V67.6421L14.4724 67.6408ZM23.0035 42.8092C23.0035 37.1554 29.7555 34.3841 33.7111 38.1952C37.007 41.3706 35.7472 46.7383 32.083 48.3849C27.3658 50.5044 23.0035 46.8615 23.0035 42.8092V42.8092ZM18.4333 42.0475C18.4333 44.6638 18.6995 47.0059 20.4601 49.1625C20.823 49.6076 21.3635 50.1759 21.6338 50.5786C19.5103 51.7033 19.1817 51.6741 17.0834 53.3406C12.9477 56.6246 9.75116 62.3036 9.75116 68.0978V73.4298H5.02858C4.67754 73.4298 4.57156 73.3238 4.57156 72.9727V5.02726C4.57156 4.67622 4.67754 4.57024 5.02858 4.57024H25.29C25.7178 4.57024 25.9351 5.16636 26.1815 5.50681L35.1312 18.0372C36.3777 19.8428 37.3726 21.7848 39.153 21.7848H73.4311V72.9727C73.4311 73.3238 73.3251 73.4298 72.9741 73.4298H48.9042C48.9042 66.5916 49.2671 63.1302 45.2188 57.1571C43.4411 54.5328 41.0579 52.8187 38.3648 51.2145C37.8707 50.919 37.4998 50.8316 37.0202 50.5786C37.9263 49.2261 40.2194 47.2536 40.2194 43.7232C40.2194 40.3029 39.6842 37.6058 37.1342 35.0769C34.2423 32.2102 32.2062 31.8393 28.3355 31.8393C27.0492 31.8393 25.2436 32.4659 24.3825 32.9136C21.2986 34.5179 18.4333 38.2482 18.4333 42.0462V42.0475ZM34.8874 9.59882H73.4298V17.0635H40.067C39.9054 16.4581 35.2756 10.179 34.8874 9.59882V9.59882ZM0 1.98177V76.0209C0 76.9548 1.04652 78.0013 1.98044 78.0013H76.0196C76.9535 78.0013 78 76.9548 78 76.0209V6.85668C78 4.59806 75.0552 4.87625 74.0391 4.87625H31.3836C31.2273 4.29073 29.8509 2.6004 29.4681 2.07052C28.7925 1.13528 28.3302 0.00265503 26.8134 0.00265503H1.98176C1.04784 0.00265503 0.00132471 1.04917 0.00132471 1.98309L0 1.98177Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.6247 14.6247V17.0622C12.5317 17.0622 9.74983 16.6409 9.74983 19.652C9.74983 22.1583 13.2457 21.7848 14.6247 21.7848C14.6247 23.3559 14.2167 26.6597 16.9099 26.6597C19.7845 26.6597 19.3473 23.5718 19.3473 21.7848C20.9184 21.7848 24.2222 22.1915 24.2222 19.4997C24.2222 16.6251 21.1357 17.0622 19.3473 17.0622C19.3473 15.4911 19.754 12.1873 17.0622 12.1873C15.6858 12.1873 14.6247 13.2471 14.6247 14.6247V14.6247Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M46.4654 30.4683C46.4654 31.7347 47.6271 32.7534 48.5982 32.7534H66.1174C68.6529 32.7534 69.5166 28.0308 65.3557 28.0308H49.3599C47.7318 28.0308 46.4654 28.8508 46.4654 30.4683Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M46.4654 40.2194C46.4654 41.397 47.349 42.5045 48.4458 42.5045H66.2697C68.9284 42.5045 68.7748 37.9343 66.2697 37.9343H48.4458C47.3622 37.9343 46.4654 39.0881 46.4654 40.2194Z"
          fill="#0B83DE"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_15">
          <rect width="78" height="78" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FaqIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 99 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_107_22)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.1368 77.9443C25.1368 73.4419 25.1336 68.9411 25.1368 64.4388C25.1399 59.3637 24.1011 60.1341 19.751 59.5863C15.6722 59.0727 11.5077 56.3834 9.14003 53.1961C7.19815 50.5831 5.80062 47.2884 5.80062 42.8297V23.1503C5.80062 20.3832 6.29974 17.7251 7.15448 15.8186C10.0088 9.45648 15.5443 5.78674 23.5895 5.78674H75.4104C86.2506 5.78674 93.1993 12.8959 93.1993 23.1503V42.4437C93.1993 48.107 90.7536 53.677 86.4705 56.5671C81.1736 60.1434 78.1961 59.8073 71.7356 59.8073H45.8252C42.754 59.7948 43.0317 60.1854 41.4267 61.7853L28.4715 74.7119C27.6089 75.5725 26.0071 77.3622 25.1368 77.9443V77.9443ZM98.9999 21.2127V44.3828C98.9968 49.9684 96.0973 55.6846 92.4069 59.2096C89.512 61.9752 86.065 64.1711 82.0034 65.0364C77.5893 65.9764 65.0319 65.5967 59.9424 65.5967L46.5863 65.5811C45.7332 65.6278 45.8611 65.6309 45.3791 66.1134L24.7047 86.7732C22.0797 89.4469 19.3376 87.1622 19.3376 85.469V65.4037C16.9793 65.4037 13.3077 63.9065 11.6668 63.0257C5.31866 59.6189 0.00617459 52.0585 0.00149536 44.7672V21.2112C0.00461485 16.6139 1.78116 12.7138 4.09738 9.29619C7.53505 4.22578 14.7114 0.000442505 21.2717 0.000442505H77.7328C81.1986 0.000442505 83.8595 1.0914 86.2709 2.0921C88.5668 3.04455 90.7536 4.79383 92.4755 6.51198C96.2798 10.3078 98.9984 15.6085 99.0015 21.2127H98.9999Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M70.19 42.0593C69.5536 41.7231 69.2651 41.4866 68.9999 40.738C68.376 38.9701 68.6427 30.9832 68.6427 28.5538C68.6427 23.1161 75.4104 23.8335 75.4104 27.7819V39.3576C75.4104 40.6011 74.8099 41.5551 74.0566 42.0593C74.0566 36.7648 70.6813 38.9343 70.3709 39.5381C70.0839 40.0953 70.19 41.194 70.19 42.0593V42.0593ZM62.4552 30.0976C62.4552 34.4226 61.8532 41.9068 64.2489 44.7066C66.0473 46.8091 67.1469 47.139 70.19 47.8472C70.19 50.0353 69.8905 51.8982 72.1241 51.8982C74.3451 51.8982 73.9708 49.0875 74.041 48.409C74.1517 47.3523 74.6446 47.7102 75.7629 47.4254C79.0103 46.5975 81.5979 43.6187 81.5979 39.549V27.7803C81.5979 26.5539 81.2033 24.951 80.8274 24.1121C77.9404 17.6613 67.7568 18.5157 64.7262 21.9426C62.9809 23.916 62.4568 26.445 62.4568 30.0961L62.4552 30.0976Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M47.3725 27.0099L50.2721 37.0418H44.6648L47.3725 27.0099ZM36.158 45.1454C36.158 46.5741 38.3104 47.6526 40.218 47.6526C42.046 47.6526 42.1739 46.5632 42.5404 45.147C42.7058 44.5074 42.8524 43.9969 43.0364 43.3261C43.6369 41.124 42.2316 41.6718 51.0473 41.6718C51.7414 41.6718 51.7211 42.439 51.9067 43.13C52.0861 43.8024 52.2342 44.319 52.3996 44.9525C52.9626 47.1033 52.9595 47.6526 55.1073 47.6526C56.4346 47.6526 58.7805 46.5383 58.7805 45.3369C58.7805 44.6147 58.0365 42.4655 57.79 41.6936C56.8573 38.7709 51.7039 21.2719 51.0551 20.4393C49.734 18.7445 45.61 18.6853 44.0627 20.2338C43.3499 20.9482 43.0801 22.5076 42.7541 23.5596L36.1564 45.1439L36.158 45.1454Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.1427 21.801V45.1454C19.1427 48.7856 25.3302 48.1055 25.3302 45.7244V35.8855C27.8976 35.8855 31.5396 36.3352 32.4458 35.2676C33.5204 34.0024 33.366 31.0625 30.5523 31.0625H25.3318V24.6957H35.5793C37.3917 24.6957 38.2792 19.2938 34.8057 19.2938H22.4307C20.5574 19.2938 19.1427 19.9055 19.1427 21.801V21.801Z"
          fill="#0B83DE"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_22">
          <rect width="99" height="88" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const TestSystemIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 105 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_107_29)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.46215 99.7103V94.8441H101.616C101.616 97.9928 102.299 101.615 99.7117 101.615H5.36649C4.32065 101.615 3.46215 100.756 3.46215 99.7103V99.7103ZM22.0778 28.8255H42.3853V49.1388H22.0778V28.8255V28.8255ZM18.6924 27.1331V32.2118H8.53941C7.51569 32.2118 6.84748 32.8817 6.84748 33.9042V91.4593C-1.21978 91.4593 0.0782973 90.0885 0.0782973 100.346C0.0782973 102.675 2.40451 105.001 4.7322 105.001H100.347C102.675 105.001 105.001 102.675 105.001 100.346V93.1517C105.001 90.782 101.839 91.4593 98.2322 91.4593V37.2905H94.8469V91.4593H10.2328V35.5981H18.6939V37.2905C15.0873 37.2905 11.9247 36.6132 11.9247 38.9829V88.073C11.9247 89.097 12.5929 89.7654 13.6167 89.7654H91.463C92.4867 89.7654 93.1549 89.0955 93.1549 88.073V38.9829H89.7711V86.3806H15.3101V40.6753H18.6954V50.8312C18.6954 51.8552 19.3651 52.5236 20.3873 52.5236H44.0802C45.1039 52.5236 45.7721 51.8537 45.7721 50.8312V40.6753H61.0024V37.289H45.7721V35.5966H61.0024V32.2103H45.7721C45.7721 28.6027 46.4492 25.4392 44.0802 25.4392H20.3873C19.3636 25.4392 18.6954 26.1091 18.6954 27.1316L18.6924 27.1331Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M68.4044 9.56867L70.4695 7.40262C71.6835 8.24956 71.8281 9.1452 73.2692 9.1452C74.1499 9.1452 75.8285 7.9943 76.6796 7.68887C79.6711 6.61323 79.6165 7.54575 79.6165 3.43204H83.0004C83.0004 7.28458 82.8529 6.67077 85.7795 7.63428C87.3342 8.14628 88.0393 9.1452 89.7696 9.1452C90.4555 9.1452 91.5412 7.82462 92.0973 7.45279L94.2627 9.5185C93.416 10.7328 92.5206 10.8774 92.5206 12.319C92.5206 13.0391 93.6107 14.882 93.9441 15.7614C95.0711 18.7257 94.1196 18.6666 98.2322 18.6666V22.0515C94.3011 22.0515 95.0504 21.9349 94.0031 24.8047C93.4381 26.3555 92.5206 27.3234 92.5206 28.8226C92.5206 29.5087 93.8408 30.5946 94.2126 31.1494L92.1474 33.3155C90.9334 32.4685 90.7889 31.5714 89.3462 31.5714C88.6264 31.5714 86.784 32.6618 85.9049 32.9968C82.9414 34.124 82.9989 33.1723 82.9989 37.2861H79.6151C79.6151 33.4335 79.7626 34.0473 76.836 33.0838C75.2798 32.5718 74.5762 31.5729 72.8459 31.5729C72.16 31.5729 71.0743 32.8935 70.5197 33.2668L68.3542 31.2011C69.2009 29.9867 70.0963 29.8421 70.0963 28.3991C70.0963 27.5182 68.9458 25.8391 68.6404 24.9892C67.5651 21.9969 68.4973 22.0515 64.3848 22.0515V18.6666C68.2362 18.6666 67.6226 18.8142 68.5858 15.8868C69.0977 14.3316 70.0963 13.6263 70.0963 11.8955C70.0963 11.2094 68.7761 10.1235 68.4044 9.56719V9.56867ZM76.2312 4.27898C75.2001 4.36456 74.2384 4.93558 73.4817 5.33691C70.5993 1.03139 69.0372 3.75222 66.9765 5.8135C64.6237 8.16694 62.0114 9.66605 66.2891 12.5315C65.8879 13.2899 65.317 14.2519 65.2315 15.2818C60.1955 15.2818 61.0009 14.5898 61.0009 23.7453C61.0009 25.8597 63.1737 25.4377 65.2315 25.4377C65.317 26.4691 65.8879 27.4311 66.2891 28.1881C61.9848 31.0712 64.7034 32.6338 66.7656 34.6951C69.1183 37.0485 70.617 39.6616 73.4817 35.3827C74.2398 35.784 75.2016 36.355 76.2312 36.4406C76.2312 41.478 75.5394 40.6723 84.6923 40.6723C86.8076 40.6723 86.3843 38.4989 86.3843 36.4406C87.4139 36.355 88.3771 35.784 89.1338 35.3827C92.0161 39.6882 93.5783 36.9674 95.639 34.9061C97.9917 32.5526 100.604 31.0535 96.3264 28.1881C96.7276 27.4311 97.2984 26.4676 97.384 25.4377C102.42 25.4377 101.615 26.1298 101.615 16.9742C101.615 14.8584 99.4417 15.2818 97.384 15.2818C97.2984 14.2504 96.7276 13.2884 96.3264 12.5315C100.631 9.64834 97.9121 8.08578 95.8499 6.0245C93.4971 3.67107 91.997 1.05942 89.1338 5.33691C88.3756 4.93558 87.4139 4.36456 86.3843 4.27898C86.3843 -0.758403 87.0761 0.0472232 77.9231 0.0472232C75.8079 0.0472232 76.2312 2.22064 76.2312 4.27898V4.27898Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.0778 59.2947H42.3853V79.608H22.0778V59.2947ZM18.6924 57.6023V81.3019C18.6924 82.3259 19.3621 82.9943 20.3844 82.9943H44.0772C45.101 82.9943 45.7692 82.3244 45.7692 81.3019V57.6023C45.7692 56.5783 45.101 55.9099 44.0772 55.9099H20.3844C19.3607 55.9099 18.6924 56.5798 18.6924 57.6023V57.6023Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M66.0767 55.9084C66.0767 54.8962 66.5148 53.2422 66.8541 52.4543C70.3855 44.2755 82.9989 46.8695 82.9989 55.9084C82.9989 56.7406 82.5077 58.7001 82.223 59.3641C80.4972 63.3922 75.5497 65.5228 71.0846 63.5943C68.1227 62.3151 66.0767 59.066 66.0767 55.9084V55.9084ZM72.8459 43.6352C72.8459 44.6385 70.9622 43.9642 67.3453 46.3855L66.2464 45.1549L63.7948 47.4907L64.9689 48.7626C61.3564 54.3326 64.5013 54.2145 60.998 54.2145V57.6008C63.6325 57.6008 62.33 57.2969 63.5337 60.3556C64.0396 61.6408 64.4423 62.0156 65.0176 63.103L63.7874 64.2022L66.121 66.6545L67.3925 65.48C68.6301 66.1057 69.6066 66.9423 71.5065 67.4041C72.93 67.7508 72.8444 67.1238 72.8444 69.4521H76.2298C76.2298 66.8183 75.9259 68.1197 78.9837 66.9172C80.2685 66.4111 80.6432 66.0083 81.7304 65.4328L82.8293 66.6634L85.3768 64.2141L84.0964 63.0632C84.6097 62.2782 85.0655 61.5552 85.48 60.5091C86.7707 57.2497 85.4137 57.6038 88.0762 57.6038V54.2175C84.5478 54.2175 87.7325 54.2072 84.0566 48.7168L85.2868 47.6176L82.8382 45.0694L81.6891 46.3501C80.9043 45.8366 80.1815 45.3792 79.1357 44.9646C75.8772 43.6735 76.2312 45.031 76.2312 42.3677H72.8459V43.6381V43.6352Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72.8459 20.3605C72.8459 11.3216 85.4594 8.72761 88.9907 16.9063C92.7552 25.6266 81.7717 32.7754 75.3329 26.3363C73.9168 24.9198 72.8444 22.4528 72.8444 20.3605H72.8459ZM69.4621 19.726V20.995C69.4621 26.7613 74.9096 32.2103 80.6742 32.2103H81.9428C87.7074 32.2103 93.1549 26.7613 93.1549 20.995V19.726C93.1549 13.9598 87.7074 8.51071 81.9428 8.51071H80.6742C74.9096 8.51071 69.4621 13.9598 69.4621 19.726V19.726Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.1414 63.8998L29.7438 69.399L24.1429 75.1151L26.5694 77.442L32.1807 71.9398L37.783 77.4405L40.3202 75.0044L34.7178 69.5037L40.3187 63.7876L37.7771 61.3634L32.2824 66.9644L26.6786 61.4622L24.1414 63.8998Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M71.154 56.1209C70.9888 55.0497 71.9903 52.742 74.3682 52.5753C78.6046 52.2772 79.1903 58.9376 74.7104 59.2431C72.8444 59.37 71.4151 57.803 71.154 56.1209ZM67.7686 55.4864C67.7686 59.8805 70.8752 62.681 73.9035 62.681C76.0999 62.681 77.6355 62.4567 79.3599 60.7319C83.17 56.9206 81.4604 49.1388 74.116 49.1388C70.8516 49.1388 67.7701 52.2211 67.7701 55.4864H67.7686Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.5389 42.5787C29.8736 42.1331 27.3837 38.7586 26.9426 37.9235C25.9705 38.4384 25.1209 39.2057 24.193 39.8283C24.4069 40.7476 26.3555 43.0656 27.0341 43.9701C27.574 44.6916 27.956 45.1903 28.4841 45.9045C31.3295 49.7585 32.4845 45.8823 35.7872 40.634L40.4825 33.0572C39.742 32.5615 38.1562 31.4342 37.3095 31.3648C37.1532 32.0377 36.954 32.2206 36.5897 32.7607C36.2165 33.3169 36.0719 33.6386 35.7017 34.2008L30.5389 42.5787Z"
          fill="#0B83DE"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_29">
          <rect width="105" height="105" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HelpIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 89 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_107_40)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.25806 44.8477C6.25806 38.2269 7.40612 34.2848 9.70957 28.6563C10.9059 25.7328 14.0613 20.9379 16.296 18.7288C19.9266 15.1406 23.7781 11.7059 28.657 9.70884C34.1912 7.44415 38.3703 6.25733 44.8477 6.25733C47.7859 6.25733 50.8842 6.71143 53.2279 7.26426C58.9755 8.61854 66.1125 12.0883 70.2704 16.2952C70.7158 16.7464 71.0382 17.0652 71.4865 17.5128C72.3699 18.3961 72.9395 18.9636 73.7563 19.9361C75.2371 21.6985 76.5146 23.3701 77.6407 25.4381C78.2637 26.5818 78.7793 27.4088 79.2897 28.6556C83.9383 40.0171 83.9324 48.9961 79.2897 60.3429C78.7018 61.7791 76.8597 64.9893 75.8886 66.329C75.2042 67.2745 74.5841 68.1147 73.8375 68.9703C70.8971 72.3391 67.526 75.4806 63.5612 77.6407C54.2831 82.6951 46.0506 83.8403 35.7933 81.7131C31.6764 80.859 26.1306 78.3954 22.6696 75.8894C17.4162 72.0832 12.1549 66.3209 9.7081 60.3429C7.61892 55.2366 6.25659 50.8798 6.25659 44.847L6.25806 44.8477ZM45.7179 -1.16953e-06H46.0762C52.161 0.00292384 59.3989 2.12648 63.4478 4.17106C68.0057 6.47231 70.3319 7.89899 74.0086 11.1662L76.0056 12.9929C83.501 20.489 88.9963 31.8351 88.9993 42.9267V46.0762C88.9963 52.131 86.8625 59.4179 84.8282 63.4478C82.5269 68.0057 81.1003 70.3319 77.833 74.0086L76.0056 76.0056C68.5103 83.501 57.1642 88.9963 46.0726 88.9993H42.9223C37.5981 88.9963 30.2468 87.1989 25.5514 84.8282C23.0944 83.588 20.897 82.4443 18.7457 80.8568C9.99622 74.4013 3.86467 65.8814 1.24898 55.2439C0.0446053 50.3482 0.00146134 48.0389 -0.000732422 43.2338V42.749C0.00219259 36.7359 2.18206 29.4973 4.22883 25.4359C8.62146 16.7215 13.7439 11.0229 22.2396 5.89901C25.6136 3.86467 29.8987 2.20838 33.7553 1.24898C38.5333 0.0606928 40.9545 0.00146134 45.7172 -0.000732422L45.7179 -1.16953e-06Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32.3323 30.072C32.3323 32.0983 33.9923 33.3751 36.1568 33.3751C38.8946 33.3751 37.9747 28.8552 43.805 28.8552C47.6009 28.8552 50.3204 31.3071 48.3307 35.1191C48.0426 35.6712 48.0974 35.5754 47.6791 36.0317C47.5365 36.1875 47.4919 36.2423 47.3479 36.3959L45.2192 38.2657C41.6807 40.8975 39.8065 43.7004 39.8065 48.4974C39.8065 51.6454 40.9794 52.3218 43.4569 52.3218C44.6993 52.3218 45.8656 51.8429 46.3534 51.0465C46.6437 50.5727 46.6883 48.0491 46.7702 47.2908C47.0356 44.8177 48.6429 43.6536 50.1829 42.36C53.2498 39.7831 56.4944 36.3396 56.4944 31.8102C56.4944 28.4135 54.6326 26.0538 52.5983 24.5811C45.2638 19.2722 32.3323 22.9299 32.3323 30.0713V30.072Z"
          fill="#0B83DE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.7637 60.3188V61.3616C38.7637 65.3886 45.2148 67.2152 47.285 62.7561C48.9193 59.2365 45.8846 56.3203 43.6309 56.3203H42.7615C40.82 56.3203 38.763 58.3773 38.763 60.3188H38.7637Z"
          fill="#0B83DE"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_40">
          <rect width="89" height="89" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SaveIcon = () => {
  return (
    <svg
      style={{ marginRight: ".8rem" }}
      width="18"
      height="18"
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.48 1.18H1.18V57.82H57.82V13.6715L45.3285 1.18H42.48ZM40.12 3.54V20.06H9.44V3.54H40.12ZM55.46 55.46H3.54V3.54H7.08V22.42H42.48V3.54H44.3515L55.46 14.6485V55.46Z"
        fill="white"
      />
      <path
        d="M12.98 51.92H46.02V31.86H12.98V51.92ZM15.34 34.22H43.66V49.56H15.34V34.22ZM34.22 7.08H36.58V16.52H34.22V7.08ZM49.56 49.56H51.92V51.92H49.56V49.56ZM7.08 49.56H9.44V51.92H7.08V49.56Z"
        fill="white"
      />
    </svg>
  );
};
export const RightArrowIconOriginalForAccord = ({ isOpen }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: 10,
        transitionDuration: ".3s",
        cursor: "pointer",
        marginLeft: 10,
        transform: isOpen ? "rotate(-90deg)" : "rotate(0deg)",
      }}
      width="10"
      height="10"
      viewBox="0 0 55.934 31.744"
    >
      <path
        id="XMLID_225_"
        d="M52,75.7a2.4,2.4,0,0,0-3.388,0L26.35,97.961,4.09,75.7A2.4,2.4,0,0,0,.7,79.089l23.954,23.954a2.4,2.4,0,0,0,3.387,0L52,79.089A2.4,2.4,0,0,0,52,75.7Z"
        transform="translate(1.736 -73.5)"
        stroke="#000"
        strokeWidth="3"
      />
    </svg>
  );
};

export const BloodPressureicon = () => {
  return (
    <svg
      style={{
        marginRight: 10,
        transitionDuration: ".3s",
        cursor: "pointer",
        marginLeft: 10,
      }}
      width="25"
      height="25"
      viewBox="0 0 226 226"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_101_7)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.71082 41.4922C11.7872 41.665 21.711 44.8776 28.25 45.0235V166.852C25.2955 166.852 21.2515 166.03 18.5727 165.493L12.1321 163.989C10.6626 163.507 11.4094 163.462 9.71082 163.321V41.4922V41.4922ZM148.192 226H142.765C136.577 225.661 130.403 224.147 124.323 221.299L120.211 219.23C113.327 215.472 111.646 212.894 107.146 208.46C100.488 201.9 94.4608 187.861 94.4608 177.887C90.354 177.887 85.324 178.779 81.234 178.785L54.7343 178.77C42.5292 178.771 11.5742 176.865 2.3163 169.391C1.26244 168.539 0 166.831 0 165.085V32.6638C0 27.5827 9.64518 24.3 14.4506 23.279C25.246 20.986 24.6187 21.4761 34.7445 20.1779C38.0403 19.7564 64.9951 18.203 68.2974 18.6595C71.933 19.162 86.3253 18.9848 90.8653 19.4866C94.0371 19.8359 98.5822 20.1889 101.659 20.6104C110.141 21.7744 122.442 23.1674 129.35 28.2318C132.01 30.182 131.991 32.5216 131.981 37.0776C131.962 44.8747 131.98 52.6747 131.98 60.4726C137.676 63.4861 143.512 66.5835 147.741 71.6377C162.838 89.6816 164.604 111.05 151.496 130.75C147.71 136.442 137.918 145.163 131.98 146.546C131.98 151.549 131.954 156.557 131.983 161.558C132.019 167.653 130.954 168.84 126.947 171.088C122.235 173.734 114.782 175.163 109.407 176.059C105.719 176.675 104.172 176.132 104.172 177.887C104.172 182.79 106.521 189.727 108.397 193.084C111.595 198.809 111.991 199.607 116.641 204.261C123.12 210.743 133.299 216.289 143.457 216.289C158.358 216.289 167.413 212.796 177.565 202.283C180.869 198.862 183.881 193.214 185.584 188.674C187.994 182.252 188.039 178.461 188.039 169.941C188.039 141.25 188.039 112.559 188.039 83.8668C185.513 83.6567 183.384 82.2455 181.588 81.0487C166.608 71.071 155.488 43.6043 162.045 24.3263C164.226 17.9112 167.53 12.2372 172.482 7.83721C173.626 6.82128 176.224 4.84848 177.584 4.11115C183.866 0.700871 186.924 0 194.219 0C207.733 0 218.106 9.84793 223.045 21.4944C225.653 27.6418 226 32.6106 226 39.2853C226 49.7057 219.168 65.3531 213.339 72.5303C206.476 80.9816 205.928 80.3843 197.75 84.3088C197.75 91.3722 198.252 175.243 197.574 179.918C195.487 194.293 189.984 203.641 181.758 211.773C178.341 215.152 171.932 219.582 167.551 221.402C161.168 224.056 154.685 225.649 148.192 226V226ZM75.4804 104.613C75.4804 83.0463 92.0191 66.2108 111.676 66.2108C124.156 66.2108 132.328 69.8669 139.595 77.1352C154.169 91.7084 154.462 114.933 139.154 130.326C134.405 135.101 128.119 138.645 121.206 140.187C114.95 141.583 113.899 141.092 109.026 140.809C107.19 140.703 106.508 140.57 104.794 140.187C102.375 139.647 99.8264 138.839 97.8375 137.873C84.8733 131.58 75.4804 119.409 75.4804 104.613ZM65.7696 102.848C65.7696 112.203 67.7526 117.875 70.8092 124.734C75.565 135.405 87.4966 145.11 98.9702 148.659C103.065 149.925 105.405 150.153 110.326 150.552C115.646 150.983 118.105 150.078 122.27 150.078V163.321C120.562 163.462 119.185 164.177 117.773 164.562C113.901 165.617 107.326 166.513 103.102 167.106L82.104 169.06C78.3597 169.263 74.4761 168.77 70.8806 169.314L48.7408 168.872C45.9592 168.451 40.7738 168.176 37.9608 168.176V45.906C40.0386 46.9029 62.5781 47.2304 67.9765 47.2304C79.876 47.2304 103.544 46.0008 116.188 42.9143C118.303 42.3972 119.932 41.5439 122.27 41.4922V57.3825C95.2456 51.087 65.7696 73.14 65.7696 102.848V102.848ZM191.571 9.71082C199.617 9.71082 205.457 12.0074 210.051 18.1556C218.351 29.263 217.857 44.1899 211.733 56.3585C207.957 63.8624 202.51 75.0392 192.454 75.0392C185.995 75.0392 180.168 66.9591 177.525 62.6C175.981 60.0518 174.03 56.2221 173.085 53.3566C171.993 50.0434 170.42 45.9898 170.005 42.3112C168.095 25.402 178.04 9.71082 191.571 9.71082V9.71082ZM116.09 33.1058L79.0059 37.0725C76.1682 37.055 75.1945 37.4634 72.8461 37.5342C64.2628 37.7909 46.7607 37.2629 39.6047 36.3169C33.7534 35.5439 27.7891 35.3667 21.4418 34.1757C19.4158 33.795 17.3883 33.1488 15.4491 33.1058C18.6034 31.1045 48.4622 28.665 52.0803 28.6854C54.439 28.6993 56.799 28.692 59.1591 28.7014C62.0865 28.7138 62.9734 28.2398 65.7652 28.2245C68.5745 28.2092 69.3826 28.6781 71.9316 28.7087C74.2705 28.7379 76.6707 28.7007 79.0147 28.689C86.294 28.6511 105.411 30.7749 113.341 32.3232L116.09 33.1058Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M113 95.7852C100.384 99.8913 102.601 113 113.441 113C117.656 113 121.181 109.757 122.104 106.193C123.329 101.459 121.268 97.5903 117.855 95.7852H113Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_7">
          <rect width="226" height="226" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Tempetatureicons = () => {
  return (
    <svg
      style={{
        marginRight: 10,
        transitionDuration: ".3s",
        cursor: "pointer",
        marginLeft: 10,
      }}
      width="25"
      height="25"
      viewBox="0 0 115 299"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_101_2)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72.9528 87.5981H79.9556V108.037H72.9528C66.7071 108.037 65.5792 117.965 74.1206 117.965H79.9556V138.404C75.593 138.404 67.9216 137.009 67.9216 143.077C67.9216 149.144 75.593 147.748 79.9556 147.748V168.187H73.5367C66.5445 168.187 66.021 178.116 72.9528 178.116H79.9556V197.386C79.9556 200.379 88.8561 203.218 96.6404 213.979C112.558 235.985 105.647 270.029 80.3517 283.628C42.4978 303.977 -2.17501 268.268 12.4662 225.043C18.2866 207.859 33.4533 201.243 34.6444 198.182C35.8375 195.117 35.0239 62.2373 35.0171 37.3751C35.0152 27.4787 35.5796 20.3021 44.2602 13.92C58.2065 3.66818 79.9556 11.8332 79.9556 33.8715V77.6696C75.1356 77.6696 69.3959 76.9529 68.1298 81.6455C67.3698 84.4577 69.3784 87.5981 72.9528 87.5981V87.5981ZM60.9683 299H53.1733C46.1131 298.509 39.0849 296.679 32.484 293.359C19.7746 286.967 11.7966 278.833 5.43995 266.109C0.427217 256.075 0 249.352 0 238.265C0 223.602 8.17258 209.446 17.3602 200.158C19.2724 198.226 20.156 197.53 22.4459 195.902C25.3002 193.876 25.1698 194.265 25.126 189.825C24.6491 141.676 25.0958 91.5925 25.0958 43.2148C25.0958 29.2159 25.4705 21.0879 31.5858 12.918C38.4748 3.71297 47.313 0 58.9461 0C73.5483 0 85.8724 11.3755 88.968 26.021C90.056 31.1664 89.294 190.974 89.294 193.883C92.0208 195.327 92.4412 195.861 94.7272 197.79C98.6461 201.096 100.403 202.873 103.561 207.055C116.358 224.01 118.429 246.164 109.715 265.707C100.983 285.288 81.4621 297.608 60.9683 299Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M57.7783 266.88C30.4978 266.88 22.1861 230.221 46.8673 218.588C51.5131 216.398 56.5813 215.882 62.2918 216.813C67.87 217.723 71.3743 220.013 74.8533 223.516C78.2516 226.94 80.5745 229.613 81.8523 235.201C85.742 252.215 73.2291 266.88 57.7783 266.88ZM52.5262 206.731C38.864 209.915 30.0764 215.984 24.7513 229.161C13.957 255.874 40.8473 285.615 70.6279 273.898C82.3496 269.287 92.2116 256.214 92.2116 244.689C92.2116 233.719 90.5572 225.508 83.0327 217.668C73.6476 207.889 66.5474 208.699 62.4475 206.731V63.0709C62.4475 56.8232 63.8255 46.7184 57.7783 46.7184C51.0003 46.7184 52.5262 55.1259 52.5262 61.9024V206.731V206.731Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_2">
          <rect width="115" height="299" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Ecgicon = () => {
  return (
    <svg
      style={{
        marginRight: 10,
        transitionDuration: ".3s",
        cursor: "pointer",
        marginLeft: 10,
      }}
      width="25"
      height="25"
      viewBox="0 0 182 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_101_12)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.5488 116.651C49.2168 116.129 49.4812 116.711 49.134 115.739L46.6267 106.311C45.7036 102.605 44.7751 99.2402 43.887 95.7895C42.9899 92.3068 42.0867 88.7542 41.0839 85.33C39.9778 81.5509 39.5462 78.6514 34.4929 78.6514H6.15374C4.43612 78.6514 2.78552 79.2346 1.81834 80.0695C-0.970901 82.4775 -0.66179 87.6934 3.51845 89.2344C6.03843 90.1633 27.2795 89.6977 30.9508 89.6977L43.6974 138.396C45.9524 147.16 45.9614 152 52.2058 152C56.4326 152 57.1202 147.011 57.48 143.123C57.8942 138.647 58.4641 134.826 58.8885 130.39C59.9722 119.062 67.7042 59.8205 67.7042 53.0232C69.1429 54.075 68.7559 57.4041 69.2812 61.1705L75.7852 114.332C76.8586 120.448 83.7732 120.438 85.8554 116.648C86.589 115.312 87.4813 112.686 88.1973 111.031L92.5013 99.8608C92.5605 99.9529 92.6299 99.9969 92.6492 100.154L101.025 139.076C101.858 143.263 102.363 148.907 107.557 148.907C109.674 148.907 111.197 147.692 112.06 146.33C113.511 144.039 127.566 70.9474 129.808 59.7614C130.136 58.127 130.875 55.2745 131.026 53.4654L135.896 72.0234C136.669 75.1061 137.353 78.0484 138.191 81.2226C139.005 84.3095 140.726 86.6048 144.753 86.6048H175.75C183.744 86.6048 183.806 76.6844 177.434 75.6446L148.296 75.5579C147.658 74.2331 146.949 70.6245 146.524 68.9299L137.845 34.288C136.094 27.2967 136.25 22.9767 130.14 22.9767C125.911 22.9767 125.394 27.8697 124.642 31.6301L110.028 103.651C109.193 107.863 108.48 111.815 107.557 115.767L106.841 113.389C106.583 112.125 106.474 111.434 106.27 110.424C105.29 105.574 100.209 79.834 98.9824 77.9285C98.2452 76.7844 96.4105 75.5579 94.7152 75.5579C90.0725 75.5579 89.4132 79.0544 88.1363 82.2491L84.0877 91.9068L78.3692 44.1487C77.4346 36.0875 76.6099 28.2859 75.4875 20.0705C74.9363 16.0324 74.5198 11.9328 74.0386 8.26098C73.4487 3.76138 73.3026 0.00037384 67.7042 0.00037384C62.2248 0.00037384 62.3908 7.12177 61.947 11.0466C61.3922 15.9619 60.6037 21.2386 60.1884 26.0822C59.3287 36.111 57.6056 46.2903 56.6741 56.1564C55.2867 70.8505 53.0016 86.6391 51.398 101.264L49.5488 116.651V116.651Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_12">
          <rect width="182" height="152" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Glucoseicon = () => {
  return (
    <svg
      style={{
        marginRight: 10,
        transitionDuration: ".3s",
        cursor: "pointer",
        marginLeft: 10,
      }}
      width="25"
      height="25"
      viewBox="0 0 123 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_101_15)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M95.1131 51.5671C85.1068 51.5671 88.236 46.9838 81.3192 52.6358L77.2796 55.7819C77.4205 54.0852 79.7561 48.0843 79.7561 46.8568C79.7561 45.4459 76.8244 43.3812 74.5416 39.4327C69.2096 30.2095 71.0951 18.4626 78.4556 11.0952C82.1814 7.36563 87.7694 4.2157 93.6269 4.2157C101.941 4.2157 104.826 5.36956 110.823 10.0595C118.078 15.7331 121.174 28.3976 116.749 37.5235C113.991 43.2102 110.542 46.6633 104.86 49.4232C102.655 50.4945 98.2703 51.5679 95.1131 51.5679V51.5671ZM67.3719 26.0315C67.3719 34.4718 68.7929 39.1761 73.7032 45.4772C76.1069 48.5615 75.6851 45.6572 73.3165 54.294C72.4501 57.4532 69.446 63.4673 73.3165 63.4673C74.7409 63.4673 82.8392 56.6051 84.3918 55.4631C85.0509 54.9783 85.523 54.6823 85.9486 54.0463C87.2381 54.3469 88.159 54.7716 89.6359 55.0655C99.3765 57.0023 108.379 53.7791 115.114 47.0427C116.451 45.7055 117.107 44.9564 118.149 43.3867C119.145 41.8857 119.797 40.6039 120.629 38.9276C124.649 30.8307 123.357 19.9755 118.248 12.2961C113.601 5.31028 105.055 0.000411987 96.3517 0.000411987C91.2033 0.000411987 87.7923 0.302321 83.1396 2.64306C74.4274 7.02603 67.3719 16.3314 67.3719 26.0319V26.0315Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M99.0762 42.6419V35.2043C100.868 34.2554 103.23 33.674 105.021 32.7251V40.1627C103.23 41.1116 100.868 41.693 99.0762 42.6419ZM89.1684 32.7251C90.96 33.674 93.3219 34.2554 95.1131 35.2043V42.6419C93.3219 41.693 90.96 41.1116 89.1684 40.1627V32.7251ZM93.132 29.5019C94.2314 29.2453 96.444 28.1215 97.095 28.1215C97.7457 28.1215 99.9578 29.2453 101.058 29.5019V29.9978C99.9578 30.2544 97.7457 31.3782 97.095 31.3782C96.444 31.3782 94.2314 30.2544 93.132 29.9978V29.5019ZM83.2238 18.8415C85.0154 19.7905 87.3773 20.3718 89.1684 21.3208V26.775C87.9991 27.0481 87.2076 27.8611 86.1927 27.5435C85.5053 27.3284 83.8351 26.6027 83.2238 26.2796V18.8415ZM93.132 25.0394V21.3208C94.9231 20.3718 97.285 19.7905 99.0762 18.8415V24.2958C97.8789 24.0168 98.6057 23.8004 96.8471 23.8004C96.0023 23.8004 94.2289 24.784 93.132 25.0398V25.0394ZM87.1873 15.6184C88.2868 15.3622 90.4993 14.238 91.1504 14.238C91.8011 14.238 94.0132 15.3622 95.1131 15.6184V16.1142C94.0132 16.3704 91.8011 17.4946 91.1504 17.4946C90.4993 17.4946 88.2868 16.3704 87.1873 16.1142V15.6184ZM79.2611 15.8665V27.7667C79.2611 29.8483 83.5343 31.0953 85.2058 31.4853C85.2058 33.7989 85.2058 36.113 85.2058 38.4266C85.2054 41.4796 84.6063 42.6741 86.8463 43.7264C88.5542 44.5288 95.8551 47.5995 97.3425 47.5995C98.0541 47.5995 102.615 45.6369 103.641 45.2266C104.819 44.7549 105.676 44.4415 106.828 43.955C107.943 43.485 108.984 43.1191 108.984 41.6498V29.7501C108.984 27.668 104.711 26.421 103.04 26.031C103.04 23.7174 103.039 21.4033 103.04 19.0893C103.04 16.0367 103.639 14.8422 101.399 13.79C99.6909 12.988 92.3895 9.91682 90.9025 9.91682L81.4161 13.5617C80.3023 14.0322 79.2611 14.3976 79.2611 15.8669V15.8665Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.7598 28.5107C25.7598 24.8018 27.4195 20.8617 29.9002 18.2754C37.0137 10.8594 47.5488 13.9568 54.3078 20.7618C60.9132 27.4123 64.7333 37.4295 57.2873 45.1919C50.1738 52.6075 39.6391 49.51 32.8801 42.705C30.2864 40.0941 27.911 36.6762 26.6525 33.0719C26.2785 32.0015 25.7598 29.7822 25.7598 28.5107V28.5107ZM21.7972 27.519C21.7972 33.58 23.604 37.6242 26.9985 42.1465C30.946 47.4047 38.9889 53.5504 45.8232 53.5504C52.0826 53.5504 56.0114 52.1548 60.0037 48.1584C66.3143 41.8421 67.0745 32.6044 62.5238 24.9343C59.3615 19.6041 56.0469 16.0537 50.5423 12.8792C35.7522 4.34951 21.7976 15.6514 21.7976 27.519H21.7972Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.96327 71.8966C3.86724 71.4024 4.34359 69.0879 4.48193 68.6967C7.46609 60.2225 22.9153 56.6436 33.2719 62.3943C36.322 64.0876 39.1598 66.8539 39.5778 70.9748C39.783 73.0005 38.6902 75.3272 37.7963 76.5061C32.1588 83.9374 18.8761 85.1568 10.3221 80.4072C7.86841 79.0446 4.95912 76.3782 4.31736 73.526C4.23529 73.161 4.24418 73.0136 4.17564 72.6761C4.00177 71.8237 4.06057 72.3992 3.96327 71.897V71.8966ZM0.000183105 70.4086C0.000183105 74.0121 0.156287 75.5186 2.37347 78.694C2.86039 79.3914 3.82832 80.6396 4.41847 81.1097C10.5818 86.0223 14.6591 87.2672 23.2833 87.2672C32.4507 87.2672 43.5938 80.7396 43.5938 71.8962C43.5938 66.4101 41.0077 62.6208 36.66 59.7466C26.2662 52.8772 9.41337 54.3694 2.47542 63.9602C1.41442 65.4265 0.000606151 67.9142 0.000606151 70.4082L0.000183105 70.4086Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M83.2238 91.7298C82.9645 90.3858 83.9756 87.5573 85.0586 86.1286C86.3053 84.4857 87.2419 83.7125 88.9666 82.6023C99.0906 76.0852 117.732 79.894 118.838 90.808C119.23 94.6718 116.039 98.0051 113.149 99.8657C110.06 101.855 106.176 102.753 101.532 103.129C97.4732 103.459 90.872 101.592 87.3751 98.7313C86.315 97.8637 86.3746 97.9433 85.5078 96.8813C84.7163 95.9112 83.874 94.6739 83.5779 93.3588C83.4962 92.9938 83.5051 92.846 83.4362 92.5089C83.2623 91.6565 83.3211 92.232 83.2238 91.7294V91.7298ZM79.2611 90.2423C79.2611 93.8461 79.4168 95.3523 81.6336 98.5276C82.1205 99.225 83.0889 100.473 83.6786 100.943C89.8424 105.856 93.9197 107.1 102.543 107.1C111.711 107.1 122.854 100.573 122.854 91.7294C122.854 86.2438 120.268 82.4545 115.92 79.5802C113.948 78.2769 112.585 77.64 110.122 76.7068C103.04 74.0239 92.8291 75.1951 86.1949 79.5802C82.9196 81.7448 79.2611 85.9923 79.2611 90.2419V90.2423Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.6676 103.134C35.6676 89.3565 48.9626 81.459 56.2271 92.4725C63.6372 103.707 56.9679 119.001 47.5568 119.001C42.0484 119.001 38.0734 113.802 36.6236 109.119C36.2137 107.794 35.6676 104.877 35.6676 103.134V103.134ZM31.7045 101.646C31.7045 107.826 32.3974 112.006 36.053 116.879C42.1748 125.04 52.9392 125.04 59.0607 116.879C69.0425 103.573 60.6243 83.3001 48.2997 83.3001C42.7316 83.3001 39.0714 85.4075 36.1579 89.2455C33.7643 92.3976 31.7045 97.3086 31.7045 101.646Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M59.4461 73.3837C59.4461 68.5896 65.6162 65.2863 69.548 69.2226C75.0193 74.6984 66.7043 83.0206 61.2331 77.5448C60.4301 76.7407 59.4461 74.8742 59.4461 73.3837ZM55.483 72.6401V74.1276C55.483 78.7012 60.0782 83.3005 64.6479 83.3005H66.134C70.7034 83.3005 75.2989 78.7016 75.2989 74.1276V72.6401C75.2989 68.0666 70.7038 63.4668 66.134 63.4668H64.6479C60.0786 63.4668 55.483 68.0662 55.483 72.6401V72.6401Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.871 103.382C13.6552 101.988 15.042 99.4046 17.6336 99.2271C19.8279 99.0777 21.603 100.964 21.7367 102.933C21.9765 106.453 17.6475 108.238 15.1659 106.052C14.5039 105.469 13.9729 104.042 13.871 103.382V103.382ZM9.9079 102.638C9.9079 113.908 25.7598 113.908 25.7598 102.638C25.7598 98.5543 22.3247 95.2003 17.3387 95.2003C13.5161 95.2003 9.9079 98.8122 9.9079 102.638V102.638Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M29.7234 25.0394C29.7234 32.6243 35.7733 40.4214 42.0183 43.4753C45.1002 44.9827 47.7214 45.6174 51.5199 45.6174V41.6503C49.0295 41.6503 46.0876 40.7936 44.2609 39.9912C40.8059 38.4741 36.8597 34.5234 35.3439 31.0661C34.5423 29.2377 33.6865 26.2936 33.6865 23.8004H29.7234V25.0398V25.0394Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M49.5384 93.7128C50.3092 97.024 52.5268 101.238 50.9429 106.027C49.7165 109.735 47.0107 112.138 43.0984 113.051C43.3344 114.066 43.8167 115.918 43.8412 117.017C49.4335 116.552 55.4826 110.197 55.4826 103.63C55.4826 100.264 55.5769 100.035 54.7406 96.6874C54.3602 95.1651 53.8285 93.8787 53.501 92.4734C52.8512 92.7854 50.3625 93.6442 49.538 93.7132L49.5384 93.7128Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.4029 73.3837C10.1588 73.8931 9.47216 76.631 9.41251 77.3504C16.6292 79.0331 21.1271 80.6231 28.8303 77.9441C29.9484 77.5553 30.6676 77.1522 31.776 76.6784C32.8767 76.208 33.7892 75.7143 34.6768 75.1193L32.9381 71.6506C31.0356 72.0914 28.4627 74.5473 22.315 75.1426C17.59 75.5999 14.4015 74.3157 10.4029 73.3837V73.3837Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M89.6647 93.2173C89.4197 93.7272 88.7331 96.4646 88.6739 97.1841C95.9295 98.8757 100.396 100.451 108.091 97.7777L113.938 94.9526L112.199 91.4842C110.297 91.925 107.724 94.3805 101.576 94.9759C96.8509 95.4336 93.6629 94.1493 89.6647 93.2173V93.2173Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.871 47.6003C13.871 45.0957 17.8341 45.0957 17.8341 47.6003C17.8341 50.1049 13.871 50.1049 13.871 47.6003ZM9.9079 47.1045C9.9079 55.7468 21.7972 55.7468 21.7972 47.1045C21.7972 44.0702 19.1937 41.6502 15.3571 41.6502C12.6323 41.6502 9.9079 44.3772 9.9079 47.1045Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M71.3349 113.051C71.3349 110.546 75.298 110.546 75.298 113.051C75.298 115.556 71.3349 115.556 71.3349 113.051ZM67.3719 112.555C67.3719 121.197 79.2611 121.197 79.2611 112.555C79.2611 109.52 76.6577 107.1 72.8211 107.1C70.0963 107.1 67.3719 109.827 67.3719 112.555Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M101.058 67.4336C101.058 64.9285 105.021 64.9285 105.021 67.4336C105.021 69.9386 101.058 69.9386 101.058 67.4336ZM97.095 66.9377C97.095 75.58 108.984 75.58 108.984 66.9377C108.984 63.9034 106.38 61.4835 102.544 61.4835C99.8194 61.4835 97.095 64.21 97.095 66.9377V66.9377Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_15">
          <rect width="123" height="123" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Spo2icons = () => {
  return (
    <svg
      style={{
        marginRight: 10,
        transitionDuration: ".3s",
        cursor: "pointer",
        marginLeft: 10,
      }}
      width="25"
      height="25"
      viewBox="0 0 220 315"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_101_16)">
        <path d="M90.87 1992.72l0 -1746.07c0,-80.25 51.08,-149.29 129.82,-149.29l1765.54 0c78.74,0 129.82,69.04 129.82,149.29l0 1752.56c0,423.86 -234.3,749.95 -569.04,917.39 -272.59,136.36 -612.48,137.52 -882.77,2.16 -340.84,-170.68 -573.37,-492.22 -573.37,-926.04zm-90.87 -1785.01l0 1856.41c0,281.47 144.72,548.24 335.87,741.62 77.9,78.82 219.63,173.55 322.4,216.35 223.44,93.05 433.74,118.56 684.94,67.19 76.14,-15.56 137.56,-40.35 204.42,-68.2 56.38,-23.48 123.73,-59.11 172.52,-93.61 270.11,-191.06 486.77,-510.42 486.77,-863.35l0 -1856.41c0,-105.19 -111.19,-207.71 -240.16,-207.71l-1726.6 0c-133.48,0 -240.16,106.76 -240.16,207.71z" />
        <path d="M331.04 2025.18l0 -1648.71c0,-31.39 20.53,-51.92 51.92,-51.92l1441 0c31.39,0 51.92,20.53 51.92,51.92l0 1648.71c0,30.27 -39.41,45.43 -71.39,45.43l-1402.06 0c-31.98,0 -71.39,-15.16 -71.39,-45.43zm-97.37 -1642.21l0 1635.72c0,78.67 68.59,142.8 149.29,142.8l1441 0c89.05,0 149.29,-74.43 149.29,-142.8l0 -1635.72c0,-97.65 -76.45,-155.79 -175.26,-155.79l-1389.06 0c-98.81,0 -175.26,58.14 -175.26,155.79z" />
        <path d="M765.93 1395.55c0,-55.15 -0.49,-92.6 43.59,-138.15 71.08,-73.44 173,-80.84 249.39,-18.5 69.5,56.71 59.23,4.72 133.2,-27.32 122.59,-53.11 248.88,46.41 248.88,145.03 0,127.28 -50.82,151.42 -150.91,251.53l-186.62 183.36 -183.37 -180.12c-48.92,-48.92 -154.16,-128.78 -154.16,-215.83zm-97.36 -38.94c0,81.23 13.71,145.51 69.63,202.99l298.73 298.43c90.23,90.41 77.26,55.8 314.81,-181.74 87.36,-87.36 186.61,-149.86 186.61,-306.7 0,-79.41 -36.22,-141.72 -76.1,-183.53 -97.29,-101.98 -242.11,-108.81 -358.79,-30.67 -7.36,-6.4 2.25,0.93 -11.2,-8.27 -167.02,-114.43 -423.69,6.92 -423.69,209.49z" />
        <path d="M739.97 752.95l0 -168.77 726.98 0 0 168.77c0,14.96 -4.51,19.47 -19.47,19.47l-688.04 0c-14.96,0 -19.47,-4.51 -19.47,-19.47zm-97.37 -155.78c0,93.58 -29.41,266.13 103.85,266.13l714.02 0c133.82,0 103.85,-175.95 103.85,-266.13 0,-61.56 -48.78,-110.35 -110.35,-110.35l-701.02 0c-61.57,0 -110.35,48.79 -110.35,110.35z" />
        <path d="M902.24 2583.4c0,-264.67 402.44,-264.67 402.44,0 0,264.67 -402.44,264.67 -402.44,0zm181.75 -292.09c-44.64,10.74 -117.24,-0.8 -202.86,95.73 -179.43,202.29 -7.75,517.65 242.77,489.94 46.46,-5.14 84.46,-13.66 118.12,-31.69 97.17,-52.06 166.55,-163.14 154.98,-282.3 -7.75,-79.83 -37.27,-153.01 -97.76,-201.34 -43.24,-34.54 -92.06,-63.31 -150.75,-69.99l-50.65 -5.14c-41.41,5.45 32.61,-6.4 -13.85,4.79z" />
      </g>
      <defs>
        <clipPath id="clip0_101_16">
          <rect width="220" height="315" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditRpmIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10_2)">
        <path
          d="M6.70834 46H35.4583C37.2403 45.9949 38.9474 45.2831 40.205 44.0208C41.4627 42.7584 42.1682 41.0487 42.1667 39.2667V24.8208C42.1667 24.3125 41.9647 23.825 41.6053 23.4655C41.2458 23.1061 40.7583 22.9042 40.25 22.9042C39.7417 22.9042 39.2542 23.1061 38.8947 23.4655C38.5353 23.825 38.3333 24.3125 38.3333 24.8208V39.2667C38.3359 40.0323 38.0346 40.7676 37.4956 41.3113C36.9566 41.855 36.2239 42.1626 35.4583 42.1667H6.70834C5.94277 42.1626 5.21008 41.855 4.67108 41.3113C4.13207 40.7676 3.83079 40.0323 3.83334 39.2667V10.5666C3.83079 9.80101 4.13207 9.0657 4.67108 8.52202C5.21008 7.97835 5.94277 7.67073 6.70834 7.66667H21.0833C21.5917 7.66667 22.0792 7.46474 22.4386 7.10529C22.7981 6.74585 23 6.25833 23 5.75C23 5.24167 22.7981 4.75416 22.4386 4.39471C22.0792 4.03527 21.5917 3.83334 21.0833 3.83334H6.70834C4.92642 3.83841 3.2193 4.55023 1.96163 5.81257C0.703956 7.07492 -0.00152776 8.78466 2.48421e-06 10.5666V39.2667C-0.00152776 41.0487 0.703956 42.7584 1.96163 44.0208C3.2193 45.2831 4.92642 45.9949 6.70834 46V46Z"
          fill="#0C8DE0"
        />
        <path
          d="M18.1221 20.2093L16.6098 27.1362C16.5414 27.4504 16.5531 27.7767 16.6439 28.0852C16.7346 28.3937 16.9016 28.6744 17.1293 28.9014C17.3601 29.1228 17.6409 29.2852 17.9479 29.3749C18.2548 29.4647 18.5789 29.4791 18.8926 29.417L25.8041 27.9009C26.163 27.8221 26.4916 27.6418 26.7509 27.3815L44.2194 9.913C44.7535 9.37905 45.1771 8.74513 45.4661 8.04744C45.7552 7.34976 45.9039 6.60197 45.9039 5.84679C45.9039 5.09161 45.7552 4.34382 45.4661 3.64613C45.1771 2.94845 44.7535 2.31453 44.2194 1.78058C43.1246 0.734342 41.6685 0.15049 40.1542 0.15049C38.6398 0.15049 37.1838 0.734342 36.0889 1.78058L18.6473 19.2663C18.3855 19.5239 18.2032 19.8512 18.1221 20.2093ZM38.7991 4.49266C39.1637 4.14333 39.6492 3.94832 40.1542 3.94832C40.6592 3.94832 41.1446 4.14333 41.5093 4.49266C41.8638 4.8542 42.0625 5.3404 42.0625 5.84679C42.0625 6.35318 41.8638 6.83938 41.5093 7.20091L40.1542 8.556L37.444 5.84583L38.7991 4.49266ZM21.7408 21.5778L34.7243 8.56175L37.4076 11.2585L24.4183 24.2784L20.9779 25.0336L21.7408 21.5778Z"
          fill="#0C8DE0"
        />
      </g>
      <defs>
        <clipPath id="clip0_10_2">
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RpmStatusTriangleold = ({ variant, size, direction }) => {
  // console.log("variant :",variant)
  let params = {
    color:
      variant === "normal" || variant === "Normal"
        ? "#4AD395"
        : variant === "Abnormal" || variant === "abnormal"
        ? "#F1BC2C"
        : "#CB2027",
    size: size ? size : "15",
    direction:
      direction === "right"
        ? "90deg"
        : direction === "down"
        ? "180deg"
        : direction === "left"
        ? "270deg"
        : direction === "up"
        ? "0deg"
        : "0deg",
  };

  return (
    <svg
      width={params.size}
      style={{ transform: `rotate(${params.direction})` }}
      viewBox="0 0 49 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M49 40.9167H0L24.5 0.0833435L49 40.9167Z" fill={params.color} />
    </svg>
  );
};

export const BackArrow = ({ size }) => {
  return (
    <svg
      width={size ? size : 20}
      height={size ? size : 20}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M64 28H15.32L37.68 5.64L32 0L0 32L32 64L37.64 58.36L15.32 36H64V28Z"
        fill="black"
      />
    </svg>
  );
};

export const CompletedGreen = ({ size }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5" cy="11.5" r="11.5" fill="#2BB673" />
      <line
        x1="6.53033"
        y1="12.2316"
        x2="9.14938"
        y2="14.8507"
        stroke="white"
        strokeWidth="1.5"
      />
      <line
        x1="17.5303"
        y1="7.53033"
        x2="9.14938"
        y2="15.9113"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const FolderEmpty = ({ size }) => {
  return (
    <svg
      height="45px"
      style={{ marginRight: "0" }}
      viewBox="0 0 205 205"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_104_49)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.343 65.86H99.9616C107.537 65.86 113.735 72.0579 113.735 79.6333V86.2008H146.274C153.817 86.2008 159.989 92.3723 159.989 99.9158V183.178C159.989 190.721 153.817 196.893 146.274 196.893H99.9616H62.5383H16.343C8.76765 196.893 2.5697 190.695 2.5697 183.119V79.6333C2.5697 72.0579 8.76765 65.86 16.343 65.86V65.86Z"
          fill="#D3D9DD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M74.971 112.167H193.024C201.537 112.167 204.897 119.132 200.491 127.644L175.42 176.089C166.39 193.537 165.347 196.893 146.274 196.893H15.6458L51.4831 127.644C55.8888 119.132 66.4579 112.167 74.971 112.167V112.167Z"
          fill="#D3D9DD"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M40.4133 8.38555H95.5089C110.083 8.38555 108.127 5.80134 117.587 16.3941L134.603 35.4458C141.7 43.3926 140.698 42.5014 140.698 53.174V112.167H74.971C66.4578 112.167 55.8888 119.132 51.483 127.644L29.7699 169.6V19.0289C29.7699 13.175 34.5594 8.38555 40.4133 8.38555V8.38555Z"
          fill="white"
        />
        <path
          d="M52.0028 57.5032C50.8707 57.5032 49.9528 56.5853 49.9528 55.4532C49.9528 54.321 50.8707 53.4031 52.0028 53.4031H119.648C120.78 53.4031 121.698 54.321 121.698 55.4532C121.698 56.5853 120.78 57.5032 119.648 57.5032H52.0028ZM52.0028 78.7902C50.8707 78.7902 49.9528 77.8723 49.9528 76.7402C49.9528 75.608 50.8707 74.6901 52.0028 74.6901H119.648C120.78 74.6901 121.698 75.608 121.698 76.7402C121.698 77.8723 120.78 78.7902 119.648 78.7902H52.0028ZM52.0028 100.077C50.8707 100.077 49.9528 99.1591 49.9528 98.0269C49.9528 96.8947 50.8707 95.9768 52.0028 95.9768H119.648C120.78 95.9768 121.698 96.8947 121.698 98.0269C121.698 99.1591 120.78 100.077 119.648 100.077H52.0028Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_104_49">
          <rect width="205" height="205" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LogoutSVG = ({ size }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 81 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70.875 40.5C70.875 40.6688 70.8412 40.8375 70.8075 41.0063C70.7062 41.5125 70.47 41.9513 70.1325 42.2888L55.7888 56.6325C55.2825 57.1388 54.6412 57.375 54 57.375C53.3588 57.375 52.7175 57.1388 52.2113 56.6325C51.2325 55.6538 51.2325 54.0338 52.2113 53.055L62.235 43.0313H29.5312C28.1475 43.0313 27 41.8838 27 40.5C27 39.1163 28.1475 37.9688 29.5312 37.9688H62.235L52.2113 27.945C51.2325 26.9663 51.2325 25.3463 52.2113 24.3675C53.19 23.3888 54.81 23.3888 55.7888 24.3675L70.1325 38.7113C70.47 39.0488 70.7062 39.4875 70.8075 39.9938C70.8412 40.1625 70.875 40.3313 70.875 40.5Z"
        fill="#121331"
      />
      <path
        d="M44.7188 70.875H19.4062C14.2763 70.875 10.125 66.7237 10.125 61.5938V19.4062C10.125 14.2763 14.2763 10.125 19.4062 10.125H44.7188C46.1025 10.125 47.25 11.2725 47.25 12.6562C47.25 14.04 46.1025 15.1875 44.7188 15.1875H19.4062C17.0775 15.1875 15.1875 17.0775 15.1875 19.4062V61.5938C15.1875 63.9225 17.0775 65.8125 19.4062 65.8125H44.7188C46.1025 65.8125 47.25 66.96 47.25 68.3438C47.25 69.7275 46.1025 70.875 44.7188 70.875Z"
        fill="#121331"
      />
    </svg>
  );
};

export const IphoneIcon = ({ size }) => {
  let scale = size ? size : "24";

  return (
    <svg
      width={scale}
      height={scale}
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7_2)">
        <g opacity="0.7">
          <path
            opacity="0.7"
            d="M9.76347 5.73227C9.97069 5.71097 10.1769 5.69451 10.3813 5.66062C10.9492 5.55537 11.4855 5.31983 11.9489 4.97216C12.4902 4.57698 12.9579 4.0882 13.3304 3.52844C13.7764 2.87857 14.0808 2.14065 14.2235 1.36335C14.2926 0.955759 14.318 0.541857 14.2993 0.128782C14.2947 0.0849606 14.2854 0.0417771 14.2715 0C14.1794 0.000332055 14.0873 0.00745174 13.9962 0.0213024C13.5633 0.112809 13.1393 0.24241 12.7289 0.408618C11.8932 0.764939 11.1726 1.34941 10.648 2.09634C9.9665 3.08587 9.60064 4.26185 9.5994 5.46696V5.7129C9.65336 5.7245 9.70831 5.73098 9.76347 5.73227V5.73227Z"
            fill="#208CE1"
          />
          <path
            opacity="0.7"
            d="M0.0825048 14.4052C0.118001 14.626 0.14966 14.8477 0.187076 15.0695C0.233125 15.3367 0.262866 15.6088 0.330981 15.8722C0.426917 16.245 0.535326 16.612 0.641815 16.9809C0.865147 17.7306 1.15144 18.4598 1.49757 19.1605C1.99305 20.2118 2.59832 21.2067 3.3031 22.1283C3.68921 22.6441 4.15235 23.0961 4.67595 23.4684C5.06318 23.7436 5.50976 23.9219 5.97877 23.9884C6.45057 24.0341 6.92604 23.955 7.35834 23.7589C7.81308 23.5739 8.25823 23.3541 8.71297 23.1711C8.91668 23.0839 9.13193 23.0271 9.3519 23.0027C9.76668 22.9678 10.1829 22.9539 10.5991 22.961C10.9051 22.9451 11.2111 22.9915 11.499 23.0976C11.8472 23.2506 12.1935 23.4132 12.5428 23.5672C12.893 23.7314 13.2588 23.8595 13.6345 23.9496C14.0236 24.0277 14.4259 24.0068 14.8049 23.8886C15.4374 23.6864 16.0057 23.3189 16.4522 22.8235C17.0431 22.1996 17.5508 21.5004 17.9622 20.7437C18.5253 19.7222 19.0183 18.663 19.4377 17.5735C19.4468 17.542 19.451 17.5094 19.4502 17.4766C19.1413 17.2975 18.8439 17.1377 18.5541 16.9518C17.7347 16.4367 17.0969 15.674 16.7313 14.7722C16.4918 14.1667 16.3577 13.524 16.3351 12.8724C16.2799 12.0665 16.4113 11.2586 16.7189 10.5127C17.0124 9.82949 17.4269 9.20605 17.9421 8.67297C18.2299 8.3757 18.5311 8.0978 18.8515 7.78795C18.4832 7.25979 18.0291 6.7982 17.5084 6.42266C16.6947 5.83888 15.7297 5.50803 14.732 5.47083C14.1429 5.42514 13.5504 5.4798 12.9793 5.63253C12.4094 5.80294 11.852 6.01499 11.286 6.19897C10.9695 6.31918 10.6443 6.41437 10.3132 6.48365C9.87071 6.54365 9.42039 6.489 9.00461 6.32485C8.51246 6.14087 8.01934 5.95208 7.52335 5.78941C7.215 5.68501 6.89815 5.60822 6.57646 5.55992C6.25786 5.52573 5.93731 5.51374 5.61709 5.52408C5.05558 5.53457 4.50002 5.64233 3.97465 5.84265C2.91561 6.25192 2.00693 6.98007 1.37189 7.92834C0.793168 8.76034 0.393189 9.70526 0.197629 10.7025C0.106809 11.1896 0.048158 11.6822 0.0220647 12.1772C-0.012787 12.8915 0.00549224 13.6075 0.0767486 14.3191C0.0781065 14.3477 0.0816345 14.3762 0.0873017 14.4043L0.0825048 14.4052Z"
            fill="#208CE1"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7_2">
          <rect width="19.4483" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AndroidIcon = ({ size }) => {
  let scale = size ? size : "24";

  return (
    <svg
      width={scale}
      height={scale}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7_6)">
        <g opacity="0.7">
          <path
            opacity="0.7"
            d="M11.0562 1.67424L11.272 1.34729L11.4841 1.0248L11.9621 0.300886C11.976 0.279712 11.9857 0.255971 11.9905 0.231018C11.9954 0.206066 11.9953 0.180391 11.9904 0.15546C11.9854 0.130528 11.9757 0.106828 11.9616 0.0857132C11.9476 0.0645982 11.9296 0.0464816 11.9087 0.0323978C11.8878 0.0183139 11.8643 0.00853878 11.8396 0.00363021C11.8149 -0.00127836 11.7895 -0.0012243 11.7649 0.00378967C11.7402 0.00880363 11.7168 0.0186792 11.6959 0.0328523C11.675 0.0470255 11.6571 0.065219 11.6432 0.0863936L11.1321 0.862442L10.917 1.18865L10.6961 1.51933C9.22914 0.955296 7.60852 0.955296 6.1416 1.51933L5.92433 1.19088L5.70928 0.864676L5.19373 0.087883C5.1798 0.0667084 5.16189 0.0485149 5.14101 0.0343418C5.12013 0.0201686 5.09669 0.0102934 5.07204 0.00527945C5.04738 0.000265485 5.02199 0.000211065 4.99732 0.00511964C4.97264 0.0100282 4.94917 0.0198034 4.92823 0.0338872C4.90729 0.047971 4.8893 0.0660877 4.87528 0.0872026C4.86127 0.108318 4.8515 0.132017 4.84654 0.156949C4.84158 0.18188 4.84153 0.207555 4.84638 0.232508C4.85124 0.25746 4.8609 0.281202 4.87483 0.302376L5.35208 1.02629L5.56492 1.34878L5.78072 1.67573C5.00794 1.98924 4.34038 2.52047 3.85733 3.20631C3.37429 3.89215 3.09606 4.70378 3.05569 5.5448H13.7805C13.7408 4.70313 13.4629 3.8907 12.9798 3.20414C12.4967 2.51758 11.8288 1.98578 11.0555 1.672L11.0562 1.67424ZM6.12171 3.9994C6.00806 3.99955 5.89692 3.96561 5.80236 3.90186C5.70779 3.83812 5.63404 3.74745 5.59045 3.64131C5.54686 3.53517 5.53538 3.41835 5.55746 3.30561C5.57954 3.19287 5.6342 3.0893 5.71451 3.00798C5.79482 2.92666 5.89718 2.87126 6.00863 2.84878C6.12009 2.82631 6.23563 2.83777 6.34064 2.88172C6.44566 2.92566 6.53542 3.00012 6.59857 3.09567C6.66173 3.19121 6.69544 3.30356 6.69544 3.41849C6.69544 3.57243 6.63502 3.72007 6.52744 3.82899C6.41987 3.93792 6.27394 3.99921 6.12171 3.9994V3.9994ZM10.7145 3.9994C10.5818 3.99918 10.4533 3.95244 10.3508 3.86715C10.2484 3.78186 10.1783 3.6633 10.1526 3.53165C10.1269 3.4 10.1471 3.26341 10.2098 3.14514C10.2725 3.02687 10.3738 2.93423 10.4964 2.883C10.6191 2.83177 10.7555 2.82512 10.8825 2.86418C11.0094 2.90324 11.119 2.98559 11.1927 3.09722C11.2664 3.20884 11.2995 3.34283 11.2864 3.47637C11.2733 3.60991 11.2149 3.73474 11.121 3.8296C11.0676 3.88352 11.0042 3.92627 10.9345 3.95541C10.8647 3.98454 10.79 3.99949 10.7145 3.9994V3.9994Z"
            fill="#208CE1"
          />
          <path
            opacity="0.7"
            d="M3.14483 6.32234H3.06235V14.8388C3.06254 15.1637 3.19022 15.4753 3.41737 15.7051C3.64451 15.9349 3.95255 16.0643 4.27388 16.0646H5.14662C5.11647 16.1694 5.1011 16.278 5.10096 16.3871V18.8397C5.10096 19.1477 5.22197 19.4431 5.43736 19.6609C5.65276 19.8787 5.9449 20.0011 6.24952 20.0011C6.55413 20.0011 6.84628 19.8787 7.06167 19.6609C7.27707 19.4431 7.39808 19.1477 7.39808 18.8397V16.3871C7.39753 16.278 7.38216 16.1695 7.35241 16.0646H9.48824C9.45809 16.1694 9.44272 16.278 9.44258 16.3871V18.8397C9.44258 19.1476 9.56355 19.4429 9.77888 19.6607C9.9942 19.8784 10.2863 20.0007 10.5908 20.0007C10.8953 20.0007 11.1873 19.8784 11.4027 19.6607C11.618 19.4429 11.739 19.1476 11.739 18.8397V16.3871C11.7388 16.278 11.7234 16.1694 11.6933 16.0646H12.566C12.7256 16.0651 12.8837 16.0338 13.0313 15.9724C13.1789 15.9111 13.3131 15.8209 13.4261 15.707C13.5392 15.5931 13.629 15.4578 13.6903 15.3089C13.7516 15.1599 13.7833 15.0001 13.7835 14.8388V6.32234H3.14483Z"
            fill="#208CE1"
          />
          <path
            opacity="0.7"
            d="M1.14819 6.32234C0.843672 6.32234 0.551625 6.44467 0.336298 6.66241C0.12097 6.88016 0 7.17549 0 7.48343V12.451C9.07538e-09 12.759 0.12097 13.0543 0.336298 13.272C0.551625 13.4898 0.843672 13.6121 1.14819 13.6121C1.45271 13.6121 1.74476 13.4898 1.96009 13.272C2.17541 13.0543 2.29638 12.759 2.29638 12.451V7.48343C2.29638 7.17549 2.17541 6.88016 1.96009 6.66241C1.74476 6.44467 1.45271 6.32234 1.14819 6.32234Z"
            fill="#208CE1"
          />
          <path
            opacity="0.7"
            d="M15.6946 6.32234C15.3901 6.32234 15.0981 6.44467 14.8827 6.66241C14.6674 6.88016 14.5464 7.17549 14.5464 7.48343V12.451C14.5426 12.6059 14.5694 12.7601 14.6253 12.9043C14.6813 13.0486 14.7652 13.18 14.8722 13.291C14.9791 13.4019 15.107 13.4901 15.2482 13.5503C15.3894 13.6105 15.541 13.6415 15.6943 13.6415C15.8475 13.6415 15.9992 13.6105 16.1404 13.5503C16.2816 13.4901 16.4094 13.4019 16.5164 13.291C16.6234 13.18 16.7073 13.0486 16.7632 12.9043C16.8192 12.7601 16.846 12.6059 16.8421 12.451V7.48343C16.8421 7.17562 16.7212 6.8804 16.5061 6.66268C16.2909 6.44495 15.999 6.32253 15.6946 6.32234V6.32234Z"
            fill="#208CE1"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_7_6">
          <rect width="16.8421" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowRightGreen = () => {
  return (
    <svg
      width="30"
      height="25"
      viewBox="0 0 37 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8_12)">
        <path
          d="M0.93811 12.2465H36.0619"
          stroke="#00D585"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.1282 23.1681L36.0628 12.2465L25.1282 1.32491"
          stroke="#00D585"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8_12">
          <rect width="37" height="24.493" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GreenCheckSmall = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="#00D585"
      />
      <path
        d="M5.05527 10.2462L8.4641 13.3193L14.9431 6.68056"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const QrCode = () => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 78 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10_6)">
        <path d="M3.12042 0H0V3.15979H3.12042V0Z" fill="black" />
        <path d="M6.24083 0H3.12042V3.15979H6.24083V0Z" fill="black" />
        <path d="M9.35995 0H6.23953V3.15979H9.35995V0Z" fill="black" />
        <path d="M12.4804 0H9.35995V3.15979H12.4804V0Z" fill="black" />
        <path d="M15.6008 0H12.4804V3.15979H15.6008V0Z" fill="black" />
        <path d="M18.7199 0H15.5995V3.15979H18.7199V0Z" fill="black" />
        <path d="M21.8403 0H18.7199V3.15979H21.8403V0Z" fill="black" />
        <path d="M28.0798 0H24.9594V3.15979H28.0798V0Z" fill="black" />
        <path d="M31.2003 0H28.0798V3.15979H31.2003V0Z" fill="black" />
        <path d="M34.3207 0H31.2003V3.15979H34.3207V0Z" fill="black" />
        <path d="M37.4398 0H34.3194V3.15979H37.4398V0Z" fill="black" />
        <path d="M59.2801 0H56.1597V3.15979H59.2801V0Z" fill="black" />
        <path d="M62.4005 0H59.2801V3.15979H62.4005V0Z" fill="black" />
        <path d="M65.5196 0H62.3992V3.15979H65.5196V0Z" fill="black" />
        <path d="M68.6401 0H65.5196V3.15979H68.6401V0Z" fill="black" />
        <path d="M71.7605 0H68.6401V3.15979H71.7605V0Z" fill="black" />
        <path d="M74.8796 0H71.7592V3.15979H74.8796V0Z" fill="black" />
        <path d="M78 0H74.8796V3.15979H78V0Z" fill="black" />
        <path d="M3.12042 3.15979H0V6.31958H3.12042V3.15979Z" fill="black" />
        <path
          d="M21.8403 3.15979H18.7199V6.31958H21.8403V3.15979Z"
          fill="black"
        />
        <path
          d="M37.4398 3.15979H34.3194V6.31958H37.4398V3.15979Z"
          fill="black"
        />
        <path
          d="M40.5602 3.15979H37.4398V6.31958H40.5602V3.15979Z"
          fill="black"
        />
        <path
          d="M43.6806 3.15979H40.5602V6.31958H43.6806V3.15979Z"
          fill="black"
        />
        <path
          d="M46.7997 3.15979H43.6793V6.31958H46.7997V3.15979Z"
          fill="black"
        />
        <path
          d="M53.0406 3.15979H49.9202V6.31958H53.0406V3.15979Z"
          fill="black"
        />
        <path
          d="M59.2801 3.15979H56.1597V6.31958H59.2801V3.15979Z"
          fill="black"
        />
        <path d="M78 3.15979H74.8796V6.31958H78V3.15979Z" fill="black" />
        <path d="M3.12042 6.31958H0V9.47937H3.12042V6.31958Z" fill="black" />
        <path
          d="M9.35995 6.31958H6.23953V9.47937H9.35995V6.31958Z"
          fill="black"
        />
        <path
          d="M12.4804 6.31958H9.35995V9.47937H12.4804V6.31958Z"
          fill="black"
        />
        <path
          d="M15.6008 6.31958H12.4804V9.47937H15.6008V6.31958Z"
          fill="black"
        />
        <path
          d="M21.8403 6.31958H18.7199V9.47937H21.8403V6.31958Z"
          fill="black"
        />
        <path
          d="M31.2003 6.31958H28.0798V9.47937H31.2003V6.31958Z"
          fill="black"
        />
        <path
          d="M37.4398 6.31958H34.3194V9.47937H37.4398V6.31958Z"
          fill="black"
        />
        <path
          d="M43.6806 6.31958H40.5602V9.47937H43.6806V6.31958Z"
          fill="black"
        />
        <path
          d="M49.9202 6.31958H46.7997V9.47937H49.9202V6.31958Z"
          fill="black"
        />
        <path
          d="M53.0406 6.31958H49.9202V9.47937H53.0406V6.31958Z"
          fill="black"
        />
        <path
          d="M59.2801 6.31958H56.1597V9.47937H59.2801V6.31958Z"
          fill="black"
        />
        <path
          d="M65.5196 6.31958H62.3992V9.47937H65.5196V6.31958Z"
          fill="black"
        />
        <path
          d="M68.6401 6.31958H65.5196V9.47937H68.6401V6.31958Z"
          fill="black"
        />
        <path
          d="M71.7605 6.31958H68.6401V9.47937H71.7605V6.31958Z"
          fill="black"
        />
        <path d="M78 6.31958H74.8796V9.47937H78V6.31958Z" fill="black" />
        <path d="M3.12042 9.47938H0V12.6392H3.12042V9.47938Z" fill="black" />
        <path
          d="M9.35995 9.47938H6.23953V12.6392H9.35995V9.47938Z"
          fill="black"
        />
        <path
          d="M12.4804 9.47938H9.35995V12.6392H12.4804V9.47938Z"
          fill="black"
        />
        <path
          d="M15.6008 9.47938H12.4804V12.6392H15.6008V9.47938Z"
          fill="black"
        />
        <path
          d="M21.8403 9.47938H18.7199V12.6392H21.8403V9.47938Z"
          fill="black"
        />
        <path
          d="M34.3207 9.47938H31.2003V12.6392H34.3207V9.47938Z"
          fill="black"
        />
        <path
          d="M37.4398 9.47938H34.3194V12.6392H37.4398V9.47938Z"
          fill="black"
        />
        <path
          d="M43.6806 9.47938H40.5602V12.6392H43.6806V9.47938Z"
          fill="black"
        />
        <path
          d="M49.9202 9.47938H46.7997V12.6392H49.9202V9.47938Z"
          fill="black"
        />
        <path
          d="M53.0406 9.47938H49.9202V12.6392H53.0406V9.47938Z"
          fill="black"
        />
        <path
          d="M59.2801 9.47938H56.1597V12.6392H59.2801V9.47938Z"
          fill="black"
        />
        <path
          d="M65.5196 9.47938H62.3992V12.6392H65.5196V9.47938Z"
          fill="black"
        />
        <path
          d="M68.6401 9.47938H65.5196V12.6392H68.6401V9.47938Z"
          fill="black"
        />
        <path
          d="M71.7605 9.47938H68.6401V12.6392H71.7605V9.47938Z"
          fill="black"
        />
        <path d="M78 9.47938H74.8796V12.6392H78V9.47938Z" fill="black" />
        <path d="M3.12042 12.6405H0V15.8003H3.12042V12.6405Z" fill="black" />
        <path
          d="M9.35995 12.6405H6.23953V15.8003H9.35995V12.6405Z"
          fill="black"
        />
        <path
          d="M12.4804 12.6405H9.35995V15.8003H12.4804V12.6405Z"
          fill="black"
        />
        <path
          d="M15.6008 12.6405H12.4804V15.8003H15.6008V12.6405Z"
          fill="black"
        />
        <path
          d="M21.8403 12.6405H18.7199V15.8003H21.8403V12.6405Z"
          fill="black"
        />
        <path
          d="M34.3207 12.6405H31.2003V15.8003H34.3207V12.6405Z"
          fill="black"
        />
        <path
          d="M37.4398 12.6405H34.3194V15.8003H37.4398V12.6405Z"
          fill="black"
        />
        <path
          d="M40.5602 12.6405H37.4398V15.8003H40.5602V12.6405Z"
          fill="black"
        />
        <path
          d="M46.7997 12.6405H43.6793V15.8003H46.7997V12.6405Z"
          fill="black"
        />
        <path
          d="M53.0406 12.6405H49.9202V15.8003H53.0406V12.6405Z"
          fill="black"
        />
        <path
          d="M59.2801 12.6405H56.1597V15.8003H59.2801V12.6405Z"
          fill="black"
        />
        <path
          d="M65.5196 12.6405H62.3992V15.8003H65.5196V12.6405Z"
          fill="black"
        />
        <path
          d="M68.6401 12.6405H65.5196V15.8003H68.6401V12.6405Z"
          fill="black"
        />
        <path
          d="M71.7605 12.6405H68.6401V15.8003H71.7605V12.6405Z"
          fill="black"
        />
        <path d="M78 12.6405H74.8796V15.8003H78V12.6405Z" fill="black" />
        <path d="M3.12042 15.8003H0V18.9601H3.12042V15.8003Z" fill="black" />
        <path
          d="M21.8403 15.8003H18.7199V18.9601H21.8403V15.8003Z"
          fill="black"
        />
        <path
          d="M31.2003 15.8003H28.0798V18.9601H31.2003V15.8003Z"
          fill="black"
        />
        <path
          d="M37.4398 15.8003H34.3194V18.9601H37.4398V15.8003Z"
          fill="black"
        />
        <path
          d="M46.7997 15.8003H43.6793V18.9601H46.7997V15.8003Z"
          fill="black"
        />
        <path
          d="M53.0406 15.8003H49.9202V18.9601H53.0406V15.8003Z"
          fill="black"
        />
        <path
          d="M59.2801 15.8003H56.1597V18.9601H59.2801V15.8003Z"
          fill="black"
        />
        <path d="M78 15.8003H74.8796V18.9601H78V15.8003Z" fill="black" />
        <path d="M3.12042 18.9601H0V22.1198H3.12042V18.9601Z" fill="black" />
        <path
          d="M6.24083 18.9601H3.12042V22.1198H6.24083V18.9601Z"
          fill="black"
        />
        <path
          d="M9.35995 18.9601H6.23953V22.1198H9.35995V18.9601Z"
          fill="black"
        />
        <path
          d="M12.4804 18.9601H9.35995V22.1198H12.4804V18.9601Z"
          fill="black"
        />
        <path
          d="M15.6008 18.9601H12.4804V22.1198H15.6008V18.9601Z"
          fill="black"
        />
        <path
          d="M18.7199 18.9601H15.5995V22.1198H18.7199V18.9601Z"
          fill="black"
        />
        <path
          d="M21.8403 18.9601H18.7199V22.1198H21.8403V18.9601Z"
          fill="black"
        />
        <path
          d="M28.0798 18.9601H24.9594V22.1198H28.0798V18.9601Z"
          fill="black"
        />
        <path
          d="M34.3207 18.9601H31.2003V22.1198H34.3207V18.9601Z"
          fill="black"
        />
        <path
          d="M40.5602 18.9601H37.4398V22.1198H40.5602V18.9601Z"
          fill="black"
        />
        <path
          d="M46.7997 18.9601H43.6793V22.1198H46.7997V18.9601Z"
          fill="black"
        />
        <path
          d="M53.0406 18.9601H49.9202V22.1198H53.0406V18.9601Z"
          fill="black"
        />
        <path
          d="M59.2801 18.9601H56.1597V22.1198H59.2801V18.9601Z"
          fill="black"
        />
        <path
          d="M62.4005 18.9601H59.2801V22.1198H62.4005V18.9601Z"
          fill="black"
        />
        <path
          d="M65.5196 18.9601H62.3992V22.1198H65.5196V18.9601Z"
          fill="black"
        />
        <path
          d="M68.6401 18.9601H65.5196V22.1198H68.6401V18.9601Z"
          fill="black"
        />
        <path
          d="M71.7605 18.9601H68.6401V22.1198H71.7605V18.9601Z"
          fill="black"
        />
        <path
          d="M74.8796 18.9601H71.7592V22.1198H74.8796V18.9601Z"
          fill="black"
        />
        <path d="M78 18.9601H74.8796V22.1198H78V18.9601Z" fill="black" />
        <path
          d="M28.0798 22.1198H24.9594V25.2796H28.0798V22.1198Z"
          fill="black"
        />
        <path
          d="M31.2003 22.1198H28.0798V25.2796H31.2003V22.1198Z"
          fill="black"
        />
        <path
          d="M40.5602 22.1198H37.4398V25.2796H40.5602V22.1198Z"
          fill="black"
        />
        <path
          d="M43.6806 22.1198H40.5602V25.2796H43.6806V22.1198Z"
          fill="black"
        />
        <path d="M3.12042 25.2796H0V28.4394H3.12042V25.2796Z" fill="black" />
        <path
          d="M6.24083 25.2796H3.12042V28.4394H6.24083V25.2796Z"
          fill="black"
        />
        <path
          d="M12.4804 25.2796H9.35995V28.4394H12.4804V25.2796Z"
          fill="black"
        />
        <path
          d="M15.6008 25.2796H12.4804V28.4394H15.6008V25.2796Z"
          fill="black"
        />
        <path
          d="M21.8403 25.2796H18.7199V28.4394H21.8403V25.2796Z"
          fill="black"
        />
        <path
          d="M31.2003 25.2796H28.0798V28.4394H31.2003V25.2796Z"
          fill="black"
        />
        <path
          d="M40.5602 25.2796H37.4398V28.4394H40.5602V25.2796Z"
          fill="black"
        />
        <path
          d="M46.7997 25.2796H43.6793V28.4394H46.7997V25.2796Z"
          fill="black"
        />
        <path
          d="M49.9202 25.2796H46.7997V28.4394H49.9202V25.2796Z"
          fill="black"
        />
        <path
          d="M59.2801 25.2796H56.1597V28.4394H59.2801V25.2796Z"
          fill="black"
        />
        <path d="M78 25.2796H74.8796V28.4394H78V25.2796Z" fill="black" />
        <path d="M3.12042 28.4394H0V31.5992H3.12042V28.4394Z" fill="black" />
        <path
          d="M6.24083 28.4394H3.12042V31.5992H6.24083V28.4394Z"
          fill="black"
        />
        <path
          d="M9.35995 28.4394H6.23953V31.5992H9.35995V28.4394Z"
          fill="black"
        />
        <path
          d="M15.6008 28.4394H12.4804V31.5992H15.6008V28.4394Z"
          fill="black"
        />
        <path
          d="M18.7199 28.4394H15.5995V31.5992H18.7199V28.4394Z"
          fill="black"
        />
        <path
          d="M24.9607 28.4394H21.8403V31.5992H24.9607V28.4394Z"
          fill="black"
        />
        <path
          d="M34.3207 28.4394H31.2003V31.5992H34.3207V28.4394Z"
          fill="black"
        />
        <path
          d="M43.6806 28.4394H40.5602V31.5992H43.6806V28.4394Z"
          fill="black"
        />
        <path
          d="M46.7997 28.4394H43.6793V31.5992H46.7997V28.4394Z"
          fill="black"
        />
        <path
          d="M49.9202 28.4394H46.7997V31.5992H49.9202V28.4394Z"
          fill="black"
        />
        <path
          d="M56.1597 28.4394H53.0393V31.5992H56.1597V28.4394Z"
          fill="black"
        />
        <path
          d="M62.4005 28.4394H59.2801V31.5992H62.4005V28.4394Z"
          fill="black"
        />
        <path
          d="M65.5196 28.4394H62.3992V31.5992H65.5196V28.4394Z"
          fill="black"
        />
        <path
          d="M68.6401 28.4394H65.5196V31.5992H68.6401V28.4394Z"
          fill="black"
        />
        <path
          d="M71.7605 28.4394H68.6401V31.5992H71.7605V28.4394Z"
          fill="black"
        />
        <path
          d="M74.8796 28.4394H71.7592V31.5992H74.8796V28.4394Z"
          fill="black"
        />
        <path d="M3.12042 31.5992H0V34.759H3.12042V31.5992Z" fill="black" />
        <path
          d="M9.35995 31.5992H6.23953V34.759H9.35995V31.5992Z"
          fill="black"
        />
        <path
          d="M15.6008 31.5992H12.4804V34.759H15.6008V31.5992Z"
          fill="black"
        />
        <path
          d="M21.8403 31.5992H18.7199V34.759H21.8403V31.5992Z"
          fill="black"
        />
        <path
          d="M24.9607 31.5992H21.8403V34.759H24.9607V31.5992Z"
          fill="black"
        />
        <path
          d="M28.0798 31.5992H24.9594V34.759H28.0798V31.5992Z"
          fill="black"
        />
        <path
          d="M31.2003 31.5992H28.0798V34.759H31.2003V31.5992Z"
          fill="black"
        />
        <path
          d="M40.5602 31.5992H37.4398V34.759H40.5602V31.5992Z"
          fill="black"
        />
        <path
          d="M49.9202 31.5992H46.7997V34.759H49.9202V31.5992Z"
          fill="black"
        />
        <path
          d="M53.0406 31.5992H49.9202V34.759H53.0406V31.5992Z"
          fill="black"
        />
        <path
          d="M59.2801 31.5992H56.1597V34.759H59.2801V31.5992Z"
          fill="black"
        />
        <path
          d="M62.4005 31.5992H59.2801V34.759H62.4005V31.5992Z"
          fill="black"
        />
        <path
          d="M68.6401 31.5992H65.5196V34.759H68.6401V31.5992Z"
          fill="black"
        />
        <path d="M78 31.5992H74.8796V34.759H78V31.5992Z" fill="black" />
        <path d="M3.12042 34.7603H0V37.9201H3.12042V34.7603Z" fill="black" />
        <path
          d="M6.24083 34.7603H3.12042V37.9201H6.24083V34.7603Z"
          fill="black"
        />
        <path
          d="M24.9607 34.7603H21.8403V37.9201H24.9607V34.7603Z"
          fill="black"
        />
        <path
          d="M28.0798 34.7603H24.9594V37.9201H28.0798V34.7603Z"
          fill="black"
        />
        <path
          d="M49.9202 34.7603H46.7997V37.9201H49.9202V34.7603Z"
          fill="black"
        />
        <path
          d="M62.4005 34.7603H59.2801V37.9201H62.4005V34.7603Z"
          fill="black"
        />
        <path
          d="M68.6401 34.7603H65.5196V37.9201H68.6401V34.7603Z"
          fill="black"
        />
        <path
          d="M71.7605 34.7603H68.6401V37.9201H71.7605V34.7603Z"
          fill="black"
        />
        <path
          d="M74.8796 34.7603H71.7592V37.9201H74.8796V34.7603Z"
          fill="black"
        />
        <path d="M78 34.7603H74.8796V37.9201H78V34.7603Z" fill="black" />
        <path
          d="M9.35995 37.9201H6.23953V41.0799H9.35995V37.9201Z"
          fill="black"
        />
        <path
          d="M12.4804 37.9201H9.35995V41.0799H12.4804V37.9201Z"
          fill="black"
        />
        <path
          d="M21.8403 37.9201H18.7199V41.0799H21.8403V37.9201Z"
          fill="black"
        />
        <path
          d="M28.0798 37.9201H24.9594V41.0799H28.0798V37.9201Z"
          fill="black"
        />
        <path
          d="M31.2003 37.9201H28.0798V41.0799H31.2003V37.9201Z"
          fill="black"
        />
        <path
          d="M34.3207 37.9201H31.2003V41.0799H34.3207V37.9201Z"
          fill="black"
        />
        <path
          d="M46.7997 37.9201H43.6793V41.0799H46.7997V37.9201Z"
          fill="black"
        />
        <path
          d="M49.9202 37.9201H46.7997V41.0799H49.9202V37.9201Z"
          fill="black"
        />
        <path
          d="M59.2801 37.9201H56.1597V41.0799H59.2801V37.9201Z"
          fill="black"
        />
        <path d="M78 37.9201H74.8796V41.0799H78V37.9201Z" fill="black" />
        <path d="M3.12042 41.0799H0V44.2397H3.12042V41.0799Z" fill="black" />
        <path
          d="M9.35995 41.0799H6.23953V44.2397H9.35995V41.0799Z"
          fill="black"
        />
        <path
          d="M12.4804 41.0799H9.35995V44.2397H12.4804V41.0799Z"
          fill="black"
        />
        <path
          d="M18.7199 41.0799H15.5995V44.2397H18.7199V41.0799Z"
          fill="black"
        />
        <path
          d="M24.9607 41.0799H21.8403V44.2397H24.9607V41.0799Z"
          fill="black"
        />
        <path
          d="M34.3207 41.0799H31.2003V44.2397H34.3207V41.0799Z"
          fill="black"
        />
        <path
          d="M40.5602 41.0799H37.4398V44.2397H40.5602V41.0799Z"
          fill="black"
        />
        <path
          d="M46.7997 41.0799H43.6793V44.2397H46.7997V41.0799Z"
          fill="black"
        />
        <path
          d="M49.9202 41.0799H46.7997V44.2397H49.9202V41.0799Z"
          fill="black"
        />
        <path
          d="M53.0406 41.0799H49.9202V44.2397H53.0406V41.0799Z"
          fill="black"
        />
        <path
          d="M56.1597 41.0799H53.0393V44.2397H56.1597V41.0799Z"
          fill="black"
        />
        <path
          d="M65.5196 41.0799H62.3992V44.2397H65.5196V41.0799Z"
          fill="black"
        />
        <path
          d="M74.8796 41.0799H71.7592V44.2397H74.8796V41.0799Z"
          fill="black"
        />
        <path d="M3.12042 44.2397H0V47.3995H3.12042V44.2397Z" fill="black" />
        <path
          d="M6.24083 44.2397H3.12042V47.3995H6.24083V44.2397Z"
          fill="black"
        />
        <path
          d="M12.4804 44.2397H9.35995V47.3995H12.4804V44.2397Z"
          fill="black"
        />
        <path
          d="M15.6008 44.2397H12.4804V47.3995H15.6008V44.2397Z"
          fill="black"
        />
        <path
          d="M18.7199 44.2397H15.5995V47.3995H18.7199V44.2397Z"
          fill="black"
        />
        <path
          d="M21.8403 44.2397H18.7199V47.3995H21.8403V44.2397Z"
          fill="black"
        />
        <path
          d="M24.9607 44.2397H21.8403V47.3995H24.9607V44.2397Z"
          fill="black"
        />
        <path
          d="M31.2003 44.2397H28.0798V47.3995H31.2003V44.2397Z"
          fill="black"
        />
        <path
          d="M46.7997 44.2397H43.6793V47.3995H46.7997V44.2397Z"
          fill="black"
        />
        <path
          d="M49.9202 44.2397H46.7997V47.3995H49.9202V44.2397Z"
          fill="black"
        />
        <path
          d="M56.1597 44.2397H53.0393V47.3995H56.1597V44.2397Z"
          fill="black"
        />
        <path
          d="M59.2801 44.2397H56.1597V47.3995H59.2801V44.2397Z"
          fill="black"
        />
        <path
          d="M65.5196 44.2397H62.3992V47.3995H65.5196V44.2397Z"
          fill="black"
        />
        <path
          d="M68.6401 44.2397H65.5196V47.3995H68.6401V44.2397Z"
          fill="black"
        />
        <path
          d="M71.7605 44.2397H68.6401V47.3995H71.7605V44.2397Z"
          fill="black"
        />
        <path
          d="M74.8796 44.2397H71.7592V47.3995H74.8796V44.2397Z"
          fill="black"
        />
        <path d="M78 44.2397H74.8796V47.3995H78V44.2397Z" fill="black" />
        <path d="M3.12042 47.3995H0V50.5593H3.12042V47.3995Z" fill="black" />
        <path
          d="M18.7199 47.3995H15.5995V50.5593H18.7199V47.3995Z"
          fill="black"
        />
        <path
          d="M24.9607 47.3995H21.8403V50.5593H24.9607V47.3995Z"
          fill="black"
        />
        <path
          d="M31.2003 47.3995H28.0798V50.5593H31.2003V47.3995Z"
          fill="black"
        />
        <path
          d="M40.5602 47.3995H37.4398V50.5593H40.5602V47.3995Z"
          fill="black"
        />
        <path
          d="M46.7997 47.3995H43.6793V50.5593H46.7997V47.3995Z"
          fill="black"
        />
        <path
          d="M53.0406 47.3995H49.9202V50.5593H53.0406V47.3995Z"
          fill="black"
        />
        <path
          d="M56.1597 47.3995H53.0393V50.5593H56.1597V47.3995Z"
          fill="black"
        />
        <path
          d="M62.4005 47.3995H59.2801V50.5593H62.4005V47.3995Z"
          fill="black"
        />
        <path
          d="M68.6401 47.3995H65.5196V50.5593H68.6401V47.3995Z"
          fill="black"
        />
        <path
          d="M71.7605 47.3995H68.6401V50.5593H71.7605V47.3995Z"
          fill="black"
        />
        <path d="M78 47.3995H74.8796V50.5593H78V47.3995Z" fill="black" />
        <path d="M3.12042 50.5593H0V53.7191H3.12042V50.5593Z" fill="black" />
        <path
          d="M9.35995 50.5593H6.23953V53.7191H9.35995V50.5593Z"
          fill="black"
        />
        <path
          d="M12.4804 50.5593H9.35995V53.7191H12.4804V50.5593Z"
          fill="black"
        />
        <path
          d="M15.6008 50.5593H12.4804V53.7191H15.6008V50.5593Z"
          fill="black"
        />
        <path
          d="M21.8403 50.5593H18.7199V53.7191H21.8403V50.5593Z"
          fill="black"
        />
        <path
          d="M24.9607 50.5593H21.8403V53.7191H24.9607V50.5593Z"
          fill="black"
        />
        <path
          d="M34.3207 50.5593H31.2003V53.7191H34.3207V50.5593Z"
          fill="black"
        />
        <path
          d="M37.4398 50.5593H34.3194V53.7191H37.4398V50.5593Z"
          fill="black"
        />
        <path
          d="M40.5602 50.5593H37.4398V53.7191H40.5602V50.5593Z"
          fill="black"
        />
        <path
          d="M43.6806 50.5593H40.5602V53.7191H43.6806V50.5593Z"
          fill="black"
        />
        <path
          d="M49.9202 50.5593H46.7997V53.7191H49.9202V50.5593Z"
          fill="black"
        />
        <path
          d="M53.0406 50.5593H49.9202V53.7191H53.0406V50.5593Z"
          fill="black"
        />
        <path
          d="M56.1597 50.5593H53.0393V53.7191H56.1597V50.5593Z"
          fill="black"
        />
        <path
          d="M59.2801 50.5593H56.1597V53.7191H59.2801V50.5593Z"
          fill="black"
        />
        <path
          d="M62.4005 50.5593H59.2801V53.7191H62.4005V50.5593Z"
          fill="black"
        />
        <path
          d="M65.5196 50.5593H62.3992V53.7191H65.5196V50.5593Z"
          fill="black"
        />
        <path
          d="M71.7605 50.5593H68.6401V53.7191H71.7605V50.5593Z"
          fill="black"
        />
        <path
          d="M74.8796 50.5593H71.7592V53.7191H74.8796V50.5593Z"
          fill="black"
        />
        <path
          d="M28.0798 53.7191H24.9594V56.8789H28.0798V53.7191Z"
          fill="black"
        />
        <path
          d="M31.2003 53.7191H28.0798V56.8789H31.2003V53.7191Z"
          fill="black"
        />
        <path
          d="M37.4398 53.7191H34.3194V56.8789H37.4398V53.7191Z"
          fill="black"
        />
        <path
          d="M53.0406 53.7191H49.9202V56.8789H53.0406V53.7191Z"
          fill="black"
        />
        <path
          d="M65.5196 53.7191H62.3992V56.8789H65.5196V53.7191Z"
          fill="black"
        />
        <path
          d="M71.7605 53.7191H68.6401V56.8789H71.7605V53.7191Z"
          fill="black"
        />
        <path
          d="M74.8796 53.7191H71.7592V56.8789H74.8796V53.7191Z"
          fill="black"
        />
        <path d="M3.12042 56.8802H0V60.0399H3.12042V56.8802Z" fill="black" />
        <path
          d="M6.24083 56.8802H3.12042V60.0399H6.24083V56.8802Z"
          fill="black"
        />
        <path
          d="M9.35995 56.8802H6.23953V60.0399H9.35995V56.8802Z"
          fill="black"
        />
        <path
          d="M12.4804 56.8802H9.35995V60.0399H12.4804V56.8802Z"
          fill="black"
        />
        <path
          d="M15.6008 56.8802H12.4804V60.0399H15.6008V56.8802Z"
          fill="black"
        />
        <path
          d="M18.7199 56.8802H15.5995V60.0399H18.7199V56.8802Z"
          fill="black"
        />
        <path
          d="M21.8403 56.8802H18.7199V60.0399H21.8403V56.8802Z"
          fill="black"
        />
        <path
          d="M34.3207 56.8802H31.2003V60.0399H34.3207V56.8802Z"
          fill="black"
        />
        <path
          d="M40.5602 56.8802H37.4398V60.0399H40.5602V56.8802Z"
          fill="black"
        />
        <path
          d="M46.7997 56.8802H43.6793V60.0399H46.7997V56.8802Z"
          fill="black"
        />
        <path
          d="M53.0406 56.8802H49.9202V60.0399H53.0406V56.8802Z"
          fill="black"
        />
        <path
          d="M59.2801 56.8802H56.1597V60.0399H59.2801V56.8802Z"
          fill="black"
        />
        <path
          d="M65.5196 56.8802H62.3992V60.0399H65.5196V56.8802Z"
          fill="black"
        />
        <path d="M78 56.8802H74.8796V60.0399H78V56.8802Z" fill="black" />
        <path d="M3.12042 60.0399H0V63.1997H3.12042V60.0399Z" fill="black" />
        <path
          d="M21.8403 60.0399H18.7199V63.1997H21.8403V60.0399Z"
          fill="black"
        />
        <path
          d="M37.4398 60.0399H34.3194V63.1997H37.4398V60.0399Z"
          fill="black"
        />
        <path
          d="M43.6806 60.0399H40.5602V63.1997H43.6806V60.0399Z"
          fill="black"
        />
        <path
          d="M49.9202 60.0399H46.7997V63.1997H49.9202V60.0399Z"
          fill="black"
        />
        <path
          d="M53.0406 60.0399H49.9202V63.1997H53.0406V60.0399Z"
          fill="black"
        />
        <path
          d="M65.5196 60.0399H62.3992V63.1997H65.5196V60.0399Z"
          fill="black"
        />
        <path d="M78 60.0399H74.8796V63.1997H78V60.0399Z" fill="black" />
        <path d="M3.12042 63.1997H0V66.3595H3.12042V63.1997Z" fill="black" />
        <path
          d="M9.35995 63.1997H6.23953V66.3595H9.35995V63.1997Z"
          fill="black"
        />
        <path
          d="M12.4804 63.1997H9.35995V66.3595H12.4804V63.1997Z"
          fill="black"
        />
        <path
          d="M15.6008 63.1997H12.4804V66.3595H15.6008V63.1997Z"
          fill="black"
        />
        <path
          d="M21.8403 63.1997H18.7199V66.3595H21.8403V63.1997Z"
          fill="black"
        />
        <path
          d="M28.0798 63.1997H24.9594V66.3595H28.0798V63.1997Z"
          fill="black"
        />
        <path
          d="M34.3207 63.1997H31.2003V66.3595H34.3207V63.1997Z"
          fill="black"
        />
        <path
          d="M37.4398 63.1997H34.3194V66.3595H37.4398V63.1997Z"
          fill="black"
        />
        <path
          d="M40.5602 63.1997H37.4398V66.3595H40.5602V63.1997Z"
          fill="black"
        />
        <path
          d="M46.7997 63.1997H43.6793V66.3595H46.7997V63.1997Z"
          fill="black"
        />
        <path
          d="M49.9202 63.1997H46.7997V66.3595H49.9202V63.1997Z"
          fill="black"
        />
        <path
          d="M53.0406 63.1997H49.9202V66.3595H53.0406V63.1997Z"
          fill="black"
        />
        <path
          d="M56.1597 63.1997H53.0393V66.3595H56.1597V63.1997Z"
          fill="black"
        />
        <path
          d="M59.2801 63.1997H56.1597V66.3595H59.2801V63.1997Z"
          fill="black"
        />
        <path
          d="M62.4005 63.1997H59.2801V66.3595H62.4005V63.1997Z"
          fill="black"
        />
        <path
          d="M65.5196 63.1997H62.3992V66.3595H65.5196V63.1997Z"
          fill="black"
        />
        <path d="M3.12042 66.3595H0V69.5193H3.12042V66.3595Z" fill="black" />
        <path
          d="M9.35995 66.3595H6.23953V69.5193H9.35995V66.3595Z"
          fill="black"
        />
        <path
          d="M12.4804 66.3595H9.35995V69.5193H12.4804V66.3595Z"
          fill="black"
        />
        <path
          d="M15.6008 66.3595H12.4804V69.5193H15.6008V66.3595Z"
          fill="black"
        />
        <path
          d="M21.8403 66.3595H18.7199V69.5193H21.8403V66.3595Z"
          fill="black"
        />
        <path
          d="M28.0798 66.3595H24.9594V69.5193H28.0798V66.3595Z"
          fill="black"
        />
        <path
          d="M31.2003 66.3595H28.0798V69.5193H31.2003V66.3595Z"
          fill="black"
        />
        <path
          d="M40.5602 66.3595H37.4398V69.5193H40.5602V66.3595Z"
          fill="black"
        />
        <path
          d="M43.6806 66.3595H40.5602V69.5193H43.6806V66.3595Z"
          fill="black"
        />
        <path
          d="M46.7997 66.3595H43.6793V69.5193H46.7997V66.3595Z"
          fill="black"
        />
        <path
          d="M59.2801 66.3595H56.1597V69.5193H59.2801V66.3595Z"
          fill="black"
        />
        <path
          d="M74.8796 66.3595H71.7592V69.5193H74.8796V66.3595Z"
          fill="black"
        />
        <path d="M78 66.3595H74.8796V69.5193H78V66.3595Z" fill="black" />
        <path d="M3.12042 69.5193H0V72.6791H3.12042V69.5193Z" fill="black" />
        <path
          d="M9.35995 69.5193H6.23953V72.6791H9.35995V69.5193Z"
          fill="black"
        />
        <path
          d="M12.4804 69.5193H9.35995V72.6791H12.4804V69.5193Z"
          fill="black"
        />
        <path
          d="M15.6008 69.5193H12.4804V72.6791H15.6008V69.5193Z"
          fill="black"
        />
        <path
          d="M21.8403 69.5193H18.7199V72.6791H21.8403V69.5193Z"
          fill="black"
        />
        <path
          d="M31.2003 69.5193H28.0798V72.6791H31.2003V69.5193Z"
          fill="black"
        />
        <path
          d="M37.4398 69.5193H34.3194V72.6791H37.4398V69.5193Z"
          fill="black"
        />
        <path
          d="M43.6806 69.5193H40.5602V72.6791H43.6806V69.5193Z"
          fill="black"
        />
        <path
          d="M49.9202 69.5193H46.7997V72.6791H49.9202V69.5193Z"
          fill="black"
        />
        <path
          d="M56.1597 69.5193H53.0393V72.6791H56.1597V69.5193Z"
          fill="black"
        />
        <path
          d="M65.5196 69.5193H62.3992V72.6791H65.5196V69.5193Z"
          fill="black"
        />
        <path
          d="M68.6401 69.5193H65.5196V72.6791H68.6401V69.5193Z"
          fill="black"
        />
        <path
          d="M71.7605 69.5193H68.6401V72.6791H71.7605V69.5193Z"
          fill="black"
        />
        <path
          d="M74.8796 69.5193H71.7592V72.6791H74.8796V69.5193Z"
          fill="black"
        />
        <path d="M78 69.5193H74.8796V72.6791H78V69.5193Z" fill="black" />
        <path d="M3.12042 72.6791H0V75.8389H3.12042V72.6791Z" fill="black" />
        <path
          d="M21.8403 72.6791H18.7199V75.8389H21.8403V72.6791Z"
          fill="black"
        />
        <path
          d="M28.0798 72.6791H24.9594V75.8389H28.0798V72.6791Z"
          fill="black"
        />
        <path
          d="M34.3207 72.6791H31.2003V75.8389H34.3207V72.6791Z"
          fill="black"
        />
        <path
          d="M37.4398 72.6791H34.3194V75.8389H37.4398V72.6791Z"
          fill="black"
        />
        <path
          d="M46.7997 72.6791H43.6793V75.8389H46.7997V72.6791Z"
          fill="black"
        />
        <path
          d="M49.9202 72.6791H46.7997V75.8389H49.9202V72.6791Z"
          fill="black"
        />
        <path
          d="M62.4005 72.6791H59.2801V75.8389H62.4005V72.6791Z"
          fill="black"
        />
        <path
          d="M65.5196 72.6791H62.3992V75.8389H65.5196V72.6791Z"
          fill="black"
        />
        <path
          d="M71.7605 72.6791H68.6401V75.8389H71.7605V72.6791Z"
          fill="black"
        />
        <path
          d="M74.8796 72.6791H71.7592V75.8389H74.8796V72.6791Z"
          fill="black"
        />
        <path d="M78 72.6791H74.8796V75.8389H78V72.6791Z" fill="black" />
        <path d="M3.12042 75.8389H0V78.9987H3.12042V75.8389Z" fill="black" />
        <path
          d="M6.24083 75.8389H3.12042V78.9987H6.24083V75.8389Z"
          fill="black"
        />
        <path
          d="M9.35995 75.8389H6.23953V78.9987H9.35995V75.8389Z"
          fill="black"
        />
        <path
          d="M12.4804 75.8389H9.35995V78.9987H12.4804V75.8389Z"
          fill="black"
        />
        <path
          d="M15.6008 75.8389H12.4804V78.9987H15.6008V75.8389Z"
          fill="black"
        />
        <path
          d="M18.7199 75.8389H15.5995V78.9987H18.7199V75.8389Z"
          fill="black"
        />
        <path
          d="M21.8403 75.8389H18.7199V78.9987H21.8403V75.8389Z"
          fill="black"
        />
        <path
          d="M28.0798 75.8389H24.9594V78.9987H28.0798V75.8389Z"
          fill="black"
        />
        <path
          d="M31.2003 75.8389H28.0798V78.9987H31.2003V75.8389Z"
          fill="black"
        />
        <path
          d="M34.3207 75.8389H31.2003V78.9987H34.3207V75.8389Z"
          fill="black"
        />
        <path
          d="M40.5602 75.8389H37.4398V78.9987H40.5602V75.8389Z"
          fill="black"
        />
        <path
          d="M53.0406 75.8389H49.9202V78.9987H53.0406V75.8389Z"
          fill="black"
        />
        <path
          d="M56.1597 75.8389H53.0393V78.9987H56.1597V75.8389Z"
          fill="black"
        />
        <path
          d="M68.6401 75.8389H65.5196V78.9987H68.6401V75.8389Z"
          fill="black"
        />
        <path d="M78 75.8389H74.8796V78.9987H78V75.8389Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_10_6">
          <rect width="78" height="79" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CorporateVideoPlayIcon = () => {
  return (
    <svg
      width="55"
      height="55"
      viewBox="0 0 55 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 54C23.9221 54 20.4517 53.2995 17.1853 51.9179C14.0298 50.5832 11.1957 48.6724 8.76167 46.2383C6.32763 43.8043 4.41675 40.9702 3.08209 37.8147C1.70052 34.5483 1 31.0779 1 27.5C1 23.9221 1.70052 20.4517 3.08209 17.1853C4.41675 14.0298 6.32763 11.1957 8.76167 8.76167C11.1957 6.32763 14.0298 4.41675 17.1853 3.08209C20.4517 1.70052 23.9221 1 27.5 1C31.0779 1 34.5483 1.70052 37.8147 3.08209C40.9702 4.41675 43.8043 6.32763 46.2383 8.76167C48.6724 11.1957 50.5832 14.0298 51.9179 17.1853C53.2995 20.4517 54 23.9221 54 27.5C54 31.0779 53.2995 34.5483 51.9179 37.8147C50.5832 40.9702 48.6724 43.8043 46.2383 46.2383C43.8043 48.6724 40.9702 50.5832 37.8147 51.9179C34.5483 53.2995 31.0779 54 27.5 54Z"
        fill="#05091A"
        fill-opacity="0.07"
      />
      <path
        d="M27.5 2C24.0566 2 20.7173 2.67394 17.5749 4.0031C14.5386 5.28733 11.8113 7.12626 9.46878 9.46878C7.12626 11.8113 5.28733 14.5386 4.0031 17.5749C2.67394 20.7173 2 24.0566 2 27.5C2 30.9434 2.67394 34.2827 4.0031 37.4251C5.28733 40.4614 7.12626 43.1887 9.46878 45.5312C11.8113 47.8737 14.5386 49.7127 17.5749 50.9969C20.7173 52.3261 24.0566 53 27.5 53C30.9434 53 34.2827 52.3261 37.4251 50.9969C40.4614 49.7127 43.1887 47.8737 45.5312 45.5312C47.8737 43.1887 49.7127 40.4614 50.9969 37.4251C52.3261 34.2827 53 30.9434 53 27.5C53 24.0566 52.3261 20.7173 50.9969 17.5749C49.7127 14.5386 47.8737 11.8113 45.5312 9.46878C43.1887 7.12626 40.4614 5.28733 37.4251 4.0031C34.2827 2.67394 30.9434 2 27.5 2ZM27.5 0C42.6878 0 55 12.3122 55 27.5C55 42.6878 42.6878 55 27.5 55C12.3122 55 0 42.6878 0 27.5C0 12.3122 12.3122 0 27.5 0Z"
        fill="white"
      />
      <path
        d="M32.923 26.5868L25.157 21.9938C24.9965 21.8962 24.8127 21.8433 24.6248 21.8407C24.4369 21.838 24.2517 21.8857 24.0885 21.9788C23.9252 22.0718 23.7899 22.2068 23.6964 22.3699C23.603 22.5329 23.5548 22.7179 23.557 22.9058V32.0888C23.5566 32.276 23.6059 32.46 23.6998 32.6219C23.7937 32.7839 23.9288 32.918 24.0915 33.0106C24.2542 33.1033 24.4385 33.1511 24.6257 33.1492C24.8129 33.1473 24.9962 33.0957 25.157 32.9998L32.923 28.4098C33.0816 28.3164 33.2131 28.1831 33.3045 28.0233C33.3958 27.8634 33.4439 27.6825 33.4439 27.4983C33.4439 27.3142 33.3958 27.1333 33.3045 26.9734C33.2131 26.8136 33.0816 26.6803 32.923 26.5868V26.5868Z"
        fill="white"
      />
    </svg>
  );
};

export const OnlineIndicatorWithBorder = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 39 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 38.001C30.2696 38.001 39 29.4944 39 19.001C39 8.50757 30.2696 0.000976562 19.5 0.000976562C8.73045 0.000976562 0 8.50757 0 19.001C0 29.4944 8.73045 38.001 19.5 38.001Z"
        fill="#D4F3D6"
      />
      <path
        d="M19.5 25.001C22.5376 25.001 25 22.5385 25 19.501C25 16.4634 22.5376 14.001 19.5 14.001C16.4624 14.001 14 16.4634 14 19.501C14 22.5385 16.4624 25.001 19.5 25.001Z"
        fill="#2CCC32"
      />
    </svg>
  );
};

export const QuotesStart = () => {
  return (
    <svg
      width="55"
      viewBox="0 0 63 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15_5)">
        <path
          d="M39.2732 47.001C45.5171 46.9827 51.4999 44.5009 55.915 40.0978C60.3301 35.6946 62.8186 29.7279 62.837 23.501V0H39.2732V23.5H54.9827C54.9899 25.5594 54.5885 27.6 53.8016 29.504C53.0147 31.4081 51.8578 33.1381 50.3976 34.5943C48.9374 36.0506 47.2028 37.2043 45.2935 37.9891C43.3843 38.7739 41.3382 39.1742 39.2732 39.167V47.001ZM0 47.001C6.24401 46.9827 12.227 44.5008 16.6421 40.0974C21.0572 35.6941 23.5456 29.7271 23.5637 23.5V0H0V23.5H15.7095C15.7167 25.5594 15.3153 27.6 14.5284 29.504C13.7415 31.4081 12.5846 33.1381 11.1244 34.5943C9.66421 36.0506 7.92953 37.2043 6.02031 37.9891C4.11108 38.7739 2.06503 39.1742 0 39.167L0 47.001Z"
          fill="#208CE1"
        />
      </g>
      <defs>
        <clipPath id="clip0_15_5">
          <rect width="62.837" height="47" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const QuotesEnd = () => {
  return (
    <svg
      width="55"
      viewBox="0 0 63 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15_2)">
        <path
          d="M23.4374 0C17.227 0.0183262 11.2762 2.5001 6.88484 6.90323C2.49343 11.3064 0.0182774 17.273 0 23.5L0 47H23.4374V23.5H7.81213C7.80494 21.4406 8.20418 19.4 8.98688 17.496C9.76957 15.5919 10.9202 13.8619 12.3726 12.4057C13.825 10.9494 15.5504 9.79568 17.4494 9.01089C19.3483 8.2261 21.3834 7.82579 23.4374 7.833V0ZM62.5 0C56.2896 0.0183262 50.3389 2.5001 45.9475 6.90323C41.5561 11.3064 39.0809 17.273 39.0626 23.5V47H62.5V23.5H46.8757C46.8686 21.4406 47.2678 19.4002 48.0504 17.4962C48.833 15.5922 49.9836 13.8623 51.4359 12.406C52.8881 10.9498 54.6134 9.79602 56.5123 9.01118C58.4112 8.22633 60.4461 7.82592 62.5 7.833V0Z"
          fill="#208CE1"
        />
      </g>
      <defs>
        <clipPath id="clip0_15_2">
          <rect width="62.5" height="47" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PlusGrid = () => {
  return (
    <svg
      width="109"
      height="98"
      viewBox="0 0 109 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M3.40698 0V6.81201"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M6.81299 3.40698L0.000976562 3.40698"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M22.407 0V6.81201"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M25.813 3.40698L19.001 3.40698"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M41.407 0V6.81201"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M44.813 3.40698L38.001 3.40698"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M60.407 0V6.81201"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M63.813 3.40698L57.001 3.40698"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M79.407 0V6.81201"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M82.813 3.40698L76.001 3.40698"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M98.407 0V6.81201"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M101.813 3.40698L95.001 3.40698"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M3.40698 21V27.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M6.81299 24.407H0.000976562"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M22.407 21V27.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M25.813 24.407H19.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M41.407 21V27.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M44.813 24.407H38.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M60.407 21V27.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M63.813 24.407H57.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M79.407 21V27.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M82.813 24.407H76.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M98.407 21V27.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M101.813 24.407H95.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M3.40698 42V48.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M6.81299 45.407H0.000976562"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M22.407 42V48.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M25.813 45.407H19.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M41.407 42V48.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M44.813 45.407H38.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M60.407 42V48.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M63.813 45.407H57.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M79.407 42V48.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M82.813 45.407H76.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M98.407 42V48.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M101.813 45.407H95.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M3.40698 63V69.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M6.81299 66.407H0.000976562"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M22.407 63V69.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M25.813 66.407H19.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M41.407 63V69.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M44.813 66.407H38.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M60.407 63V69.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M63.813 66.407H57.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M79.407 63V69.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M82.813 66.407H76.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M98.407 63V69.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M101.813 66.407H95.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M3.40698 84V90.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M6.81299 87.407H0.000976562"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M22.407 84V90.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M25.813 87.407H19.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M41.407 84V90.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M44.813 87.407H38.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M60.407 84V90.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M63.813 87.407H57.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M79.407 84V90.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M82.813 87.407H76.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M98.407 84V90.812"
          stroke="#001675"
          strokeWidth="1.5"
        />
        <path
          opacity="0.3"
          d="M101.813 87.407H95.001"
          stroke="#001675"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export const StarVectorUserComment = () => {
  return (
    <svg
      width="113"
      height="112"
      viewBox="0 0 113 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_19_16)">
        <path
          d="M56.5 82C73.3447 82 87 68.5685 87 52C87 35.4315 73.3447 22 56.5 22C39.6553 22 26 35.4315 26 52C26 68.5685 39.6553 82 56.5 82Z"
          fill="#00D585"
        />
        <path
          d="M55.138 40.692L52.038 46.977L45.102 47.988C44.8216 48.0293 44.5584 48.1481 44.342 48.331C44.1256 48.5139 43.9646 48.7537 43.8773 49.0232C43.7899 49.2928 43.7796 49.5814 43.8476 49.8565C43.9156 50.1316 44.0591 50.3822 44.262 50.58L49.28 55.47L48.093 62.377C48.0455 62.6558 48.0768 62.9424 48.1835 63.2043C48.2901 63.4663 48.4678 63.6932 48.6966 63.8596C48.9253 64.0259 49.196 64.1251 49.478 64.1458C49.7601 64.1666 50.0424 64.1081 50.293 63.977L56.493 60.716L62.693 63.977C62.9436 64.1077 63.2258 64.1659 63.5077 64.1449C63.7896 64.124 64.06 64.0248 64.2886 63.8586C64.5172 63.6923 64.6949 63.4656 64.8017 63.2038C64.9085 62.9421 64.9401 62.6558 64.893 62.377L63.706 55.47L68.724 50.58C68.9268 50.3822 69.0704 50.1316 69.1383 49.8565C69.2063 49.5814 69.1961 49.2928 69.1087 49.0232C69.0213 48.7537 68.8604 48.5139 68.644 48.331C68.4276 48.1481 68.1643 48.0293 67.884 47.988L60.96 46.977L57.86 40.692C57.7343 40.438 57.5402 40.2241 57.2994 40.0746C57.0587 39.9251 56.7809 39.8458 56.4975 39.8458C56.2141 39.8458 55.9363 39.9251 55.6955 40.0746C55.4548 40.2241 55.2606 40.438 55.135 40.692H55.138Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_19_16"
          x="0"
          y="0"
          width="113"
          height="112"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="13" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.835294 0 0 0 0 0.521569 0 0 0 0.38 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19_16"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19_16"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const HeartVectorUserComment = () => {
  return (
    <svg
      width="156"
      height="156"
      viewBox="0 0 156 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_20_2)">
        <path
          d="M95.764 30H60C54.4772 30 50 34.4772 50 40V75.764C50 81.2868 54.4772 85.764 60 85.764H95.764C101.287 85.764 105.764 81.2868 105.764 75.764V40C105.764 34.4772 101.287 30 95.764 30Z"
          fill="#FF7171"
        />
      </g>
      <path
        d="M88.266 47.613C86.8062 46.4325 84.9519 45.8519 83.0796 45.9889C81.2073 46.126 79.4573 46.9705 78.185 48.351L77.12 49.451L76.055 48.351C74.7827 46.9692 73.0319 46.1238 71.1585 45.9867C69.2852 45.8496 67.4299 46.4311 65.97 47.613C65.174 48.3007 64.5261 49.1431 64.0658 50.089C63.6055 51.0349 63.3423 52.0645 63.2922 53.1152C63.2422 54.166 63.4064 55.2159 63.7747 56.2013C64.1431 57.1866 64.7079 58.0868 65.435 58.847L75.891 69.647C76.0491 69.8123 76.2391 69.9438 76.4495 70.0337C76.6599 70.1236 76.8862 70.1699 77.115 70.1699C77.3438 70.1699 77.5701 70.1236 77.7805 70.0337C77.9909 69.9438 78.1809 69.8123 78.339 69.647L88.795 58.847C89.523 58.0874 90.0887 57.1877 90.4579 56.2025C90.8271 55.2173 90.992 54.1673 90.9425 53.1164C90.893 52.0655 90.6302 51.0357 90.1701 50.0895C89.7099 49.1434 89.0621 48.3008 88.266 47.613V47.613Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_20_2"
          x="0"
          y="0"
          width="155.764"
          height="155.764"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="20" />
          <feGaussianBlur stdDeviation="25" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.54902 0 0 0 0 0.882353 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_20_2"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_20_2"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const LikeVectorUserComment = () => {
  return (
    <svg
      width="122"
      height="120"
      viewBox="0 0 122 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_19_26)">
        <path
          d="M61 90C80.33 90 96 74.7777 96 56C96 37.2223 80.33 22 61 22C41.67 22 26 37.2223 26 56C26 74.7777 41.67 90 61 90Z"
          fill="#208CE1"
        />
        <path
          d="M72.5365 60.3831C72.6375 59.9264 72.5741 59.4487 72.3573 59.0342C72.1405 58.6198 71.7844 58.2951 71.3516 58.1176C72.3896 57.9789 73.0507 57.6796 73.2857 56.6783C73.3893 56.1336 73.2834 55.57 72.9892 55.1C72.6951 54.63 72.2344 54.2884 71.6992 54.1435C72.3095 54.0669 72.8671 53.7588 73.2568 53.283C73.6466 52.8072 73.8389 52.1999 73.7939 51.5865C73.749 50.9731 73.4702 50.4003 73.0153 49.9864C72.5603 49.5725 71.9638 49.349 71.3488 49.3621C68.6195 49.4085 65.8902 49.4549 63.1608 49.5013C63.7994 47.3385 63.8532 45.0451 63.3169 42.8547C63.0576 41.5428 62.3147 40.6821 61.386 40.7149C61.0071 40.7351 60.6475 40.8885 60.3706 41.1479C60.0938 41.4074 59.9174 41.7563 59.8727 42.1331C59.7873 43.0947 59.6499 44.0511 59.4612 44.9979C58.9177 47.6259 55.8325 51.1343 53.865 52.3741L54.0824 65.1621C55.42 65.9085 56.9451 66.2515 58.4734 66.1498C60.9406 66.0588 67.9903 65.982 69.2672 65.9513C69.7653 65.9477 70.2491 65.7841 70.6473 65.4846C71.0454 65.1852 71.3368 64.7658 71.4785 64.2882C71.6311 63.8434 71.6163 63.3581 71.4367 62.9235C71.2571 62.4888 70.9252 62.1346 70.5031 61.9271C70.9681 61.9434 71.4243 61.7986 71.7948 61.5172C72.1653 61.2359 72.4273 60.8353 72.5365 60.3831V60.3831ZM52.1005 50.3755L47.5085 50.4536C47.277 50.4649 47.0593 50.5674 46.9033 50.7388C46.7472 50.9102 46.6654 51.1364 46.6758 51.368L46.9217 65.832C46.9192 66.0638 47.0086 66.2871 47.1704 66.4531C47.3322 66.6191 47.5532 66.7142 47.785 66.7176L52.377 66.6395C52.6085 66.6283 52.8262 66.5257 52.9822 66.3543C53.1383 66.1829 53.2201 65.9567 53.2097 65.7251L52.9638 51.2611C52.9663 51.0293 52.8769 50.806 52.7151 50.64C52.5533 50.474 52.3323 50.3789 52.1005 50.3755Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_19_26"
          x="0"
          y="0"
          width="122"
          height="120"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="13" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.54902 0 0 0 0 0.882353 0 0 0 0.46 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19_26"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_19_26"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const FbFooterLogo = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.05"
        d="M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z"
        fill="#0C1E4E"
      />
      <path
        d="M19.429 11.673C19.0671 11.5659 18.6923 11.5091 18.315 11.504C17.863 11.504 16.888 11.792 16.888 12.351V13.688H19.202V15.941H16.888V22.157H14.556V15.941H13.408V13.688H14.556V12.553C14.556 10.843 15.357 9.41999 17.288 9.41999C18.1252 9.39438 18.9621 9.47979 19.777 9.67399L19.429 11.673Z"
        fill="#0C1E4E"
      />
    </svg>
  );
};

export const TwitterFooterLogo = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.05"
        d="M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z"
        fill="#0C1E4E"
      />
      <path
        d="M21.4029 11.545C21.1429 11.2564 20.8252 11.0256 20.4703 10.8675C20.1155 10.7093 19.7314 10.6274 19.3429 10.627C18.5827 10.6386 17.8582 10.9517 17.3288 11.4974C16.7994 12.0431 16.5085 12.7768 16.5199 13.537C16.5194 13.76 16.5439 13.9824 16.5929 14.2C15.4627 14.1373 14.359 13.8334 13.356 13.3087C12.353 12.784 11.474 12.0507 10.7779 11.158C10.5258 11.6064 10.3942 12.1125 10.3959 12.627C10.3939 13.1015 10.5071 13.5694 10.7257 13.9905C10.9443 14.4117 11.2618 14.7735 11.6509 15.045C11.2014 15.0301 10.7623 14.9054 10.3719 14.682V14.717C10.3645 15.3804 10.5856 16.0262 10.998 16.5459C11.4105 17.0656 11.9892 17.4276 12.6369 17.571C12.3949 17.6391 12.1444 17.6728 11.8929 17.671C11.7149 17.6736 11.5371 17.6589 11.3619 17.627C11.5331 18.1981 11.88 18.7007 12.3532 19.0634C12.8264 19.426 13.402 19.6302 13.9979 19.647C13.0089 20.4518 11.7731 20.8918 10.4979 20.893C10.2713 20.892 10.0449 20.8773 9.81995 20.849C11.1021 21.7003 12.6069 22.1546 14.1459 22.155C15.2187 22.1447 16.2787 21.9216 17.2646 21.4987C18.2505 21.0758 19.1427 20.4616 19.8896 19.6914C20.6364 18.9213 21.2231 18.0107 21.6155 17.0123C22.008 16.0139 22.1985 14.9475 22.1759 13.875C22.1759 13.748 22.1759 13.622 22.1689 13.498C22.724 13.0839 23.2005 12.5739 23.5759 11.992C23.0626 12.2269 22.5162 12.3814 21.9559 12.45C22.5499 12.0805 22.9903 11.5087 23.1959 10.84C22.6441 11.1781 22.0373 11.4167 21.4029 11.545V11.545Z"
        fill="#0C1E4E"
      />
    </svg>
  );
};

export const LinkedinFooterLogo = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_21_10)">
        <path
          d="M16.5 -3.66825e-07C20.3174 -0.000121547 24.0167 1.32338 26.9676 3.74501C29.9186 6.16663 31.9385 9.53654 32.6834 13.2805C33.4282 17.0245 32.8518 20.911 31.0524 24.2776C29.253 27.6443 26.342 30.2829 22.8152 31.7438C19.2885 33.2048 15.3642 33.3977 11.7112 32.2896C8.0582 31.1816 4.90239 28.8412 2.78149 25.6672C0.660597 22.4933 -0.29415 18.6821 0.079928 14.8831C0.454006 11.0841 2.13376 7.53235 4.83299 4.833C6.35628 3.28896 8.1735 2.06578 10.1773 1.23569C12.1812 0.405608 14.3311 -0.0145602 16.5 -3.66825e-07V-3.66825e-07Z"
          fill="#F2F3F6"
        />
        <path
          d="M12.635 22.155H10.086V12.645H12.635V22.155ZM9.93697 10.184C9.93146 10.0093 9.9626 9.83543 10.0284 9.67353C10.0942 9.51163 10.1932 9.36531 10.319 9.244C10.4597 9.1167 10.6242 9.01855 10.803 8.95522C10.9819 8.89188 11.1715 8.86462 11.361 8.875C11.7419 8.85583 12.1148 8.98853 12.398 9.244C12.525 9.3646 12.6252 9.51068 12.6919 9.67267C12.7586 9.83465 12.7903 10.0089 12.785 10.184C12.7909 10.3609 12.7591 10.537 12.6916 10.7006C12.6242 10.8642 12.5228 11.0116 12.394 11.133C12.1116 11.3872 11.7405 11.5198 11.361 11.502C10.9815 11.5198 10.6103 11.3872 10.328 11.133C10.1992 11.0116 10.0977 10.8642 10.0303 10.7006C9.96289 10.537 9.93107 10.3609 9.93697 10.184V10.184ZM17.245 12.645L17.324 13.745C17.6466 13.332 18.0625 13.0013 18.5375 12.7798C19.0125 12.5584 19.5332 12.4526 20.057 12.471C20.4748 12.4384 20.8946 12.5014 21.2845 12.6553C21.6743 12.8091 22.024 13.0498 22.307 13.359C22.8549 14.1312 23.1217 15.0679 23.063 16.013V22.155H20.523V16.073C20.5607 15.6513 20.4346 15.2313 20.171 14.9C20.0104 14.7641 19.8242 14.6618 19.6234 14.5991C19.4226 14.5365 19.2113 14.5146 19.002 14.535C18.6753 14.5216 18.3514 14.6002 18.0671 14.7617C17.7828 14.9233 17.5496 15.1614 17.394 15.449V22.155H14.854V12.645H17.245Z"
          fill="#0C1E4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_21_10">
          <rect width="33" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowRightWhite = () => {
  return (
    <svg
      width="19"
      viewBox="0 0 21 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.81091H19.132"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.182 12.621L19.132 6.811L12.182 1"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HamburgerIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_201_2)">
        <path
          d="M64 128C51.342 128 38.9683 124.246 28.4435 117.214C17.9188 110.182 9.71575 100.186 4.87174 88.4918C0.02773 76.7973 -1.23968 63.929 1.22977 51.5143C3.69922 39.0995 9.79463 27.6958 18.7452 18.7452C27.6958 9.79463 39.0995 3.69922 51.5143 1.22977C63.929 -1.23968 76.7973 0.02773 88.4918 4.87174C100.186 9.71575 110.182 17.9188 117.214 28.4435C124.246 38.9683 128 51.342 128 64C127.982 80.9682 121.233 97.2361 109.234 109.234C97.2361 121.233 80.9682 127.982 64 128V128ZM64 4.00003C52.1332 4.00003 40.5328 7.51897 30.6658 14.1119C20.7989 20.7047 13.1085 30.0755 8.56726 41.039C4.026 52.0026 2.8378 64.0666 5.15291 75.7055C7.46802 87.3443 13.1825 98.0353 21.5736 106.426C29.9648 114.818 40.6558 120.532 52.2946 122.847C63.9335 125.162 75.9975 123.974 86.961 119.433C97.9246 114.892 107.295 107.201 113.888 97.3342C120.481 87.4673 124 75.8669 124 64C123.982 48.0927 117.654 32.8423 106.406 21.5941C95.1578 10.3459 79.9073 4.01855 64 4.00003V4.00003Z"
          fill="#3994F1"
        />
        <path
          d="M95 44H33C32.4696 44 31.9609 43.7893 31.5858 43.4142C31.2107 43.0391 31 42.5304 31 42C31 41.4696 31.2107 40.9609 31.5858 40.5858C31.9609 40.2107 32.4696 40 33 40H95C95.5304 40 96.0391 40.2107 96.4142 40.5858C96.7893 40.9609 97 41.4696 97 42C97 42.5304 96.7893 43.0391 96.4142 43.4142C96.0391 43.7893 95.5304 44 95 44ZM95 66H33C32.4696 66 31.9609 65.7893 31.5858 65.4142C31.2107 65.0391 31 64.5304 31 64C31 63.4696 31.2107 62.9609 31.5858 62.5858C31.9609 62.2107 32.4696 62 33 62H95C95.5304 62 96.0391 62.2107 96.4142 62.5858C96.7893 62.9609 97 63.4696 97 64C97 64.5304 96.7893 65.0391 96.4142 65.4142C96.0391 65.7893 95.5304 66 95 66ZM95 88H33C32.4696 88 31.9609 87.7893 31.5858 87.4142C31.2107 87.0391 31 86.5304 31 86C31 85.4696 31.2107 84.9609 31.5858 84.5858C31.9609 84.2107 32.4696 84 33 84H95C95.5304 84 96.0391 84.2107 96.4142 84.5858C96.7893 84.9609 97 85.4696 97 86C97 86.5304 96.7893 87.0391 96.4142 87.4142C96.0391 87.7893 95.5304 88 95 88Z"
          fill="#3994F1"
        />
      </g>
      <defs>
        <clipPath id="clip0_201_2">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClearFilterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DoctorIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="34"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#00bfb6"
        d="M256,507.1c92.6,0,173.5-50.1,217-124.7c-43.2-75-124.2-125.5-217-125.5S82.2,307.3,39,382.4
		C82.5,457,163.4,507.1,256,507.1z"
      />
      <path
        fill="#ebdee5"
        d="M256,256.8c-27.8,0-54.4,4.5-79.4,12.9c6.2,38.3,39.4,67.6,79.4,67.6s73.2-29.3,79.4-67.6
		C310.4,261.3,283.7,256.8,256,256.8z"
      />
      <path
        fill="#fff"
        d="M176.6,269.7c5.2,32.4,29.8,58.3,61.5,65.6c11.6-4.4,19.9-15.6,19.9-28.7v-46.9
		c0-0.9-0.1-1.9-0.2-2.8c-0.6,0-1.2,0-1.8,0C228.3,256.8,201.5,261.3,176.6,269.7z"
      />
      <path
        fill="#3dcac3"
        d="M78.5,330.7c-15.3,15.4-28.6,32.7-39.5,51.7c10.9,18.7,24.2,35.9,39.5,51.2V330.7z"
      />
      <path
        fill="#017068"
        d="M382,290.6v136c0,16.7-14,30.4-30.7,30.4h-246c42,31,94.2,50.2,150.7,50.2
		c92.6,0,173.7-50.2,217.3-124.8C451.3,344.4,419,312.6,382,290.6z"
      />
      <path
        fill="#f29f18"
        d="M256,297.2L256,297.2c-15.7,0-28.4-12.7-28.4-28.4v-39.9h56.9v39.9
		C284.4,284.5,271.7,297.2,256,297.2z"
      />
      <path
        fill="#595959"
        d="M126,293.5V336h9v-48.2C132,289.6,129,291.5,126,293.5z"
      />
      <path
        fill="#fff"
        d="M170.8,418.8h-20.9V409h16v-32.3c0-19.5-15.9-35.4-35.4-35.4S95,357.2,95,376.7V409h16v9.8
				H90.1c-2.7,0-4.9-2.2-4.9-4.9v-37.2c0-24.9,20.3-45.2,45.2-45.2s45.2,20.3,45.2,45.2v37.2C175.7,416.6,173.5,418.8,170.8,418.8z"
      />
      <path
        fill="#f29f18"
        d="M324.6 155.1h24.5c13.5 0 24.5-11 24.5-24.5v0c0-13.5-11-24.5-24.5-24.5h-24.5V155.1zM187.3 155.1h-24.5c-13.5 0-24.5-11-24.5-24.5v0c0-13.5 11-24.5 24.5-24.5h24.5V155.1z"
      />
      <path
        fill="#f4bc62"
        d="M256,238.8L256,238.8c-44.4,0-80.4-36-80.4-80.4v-55.9c0-44.4,36-80.4,80.4-80.4h0
		c44.4,0,80.4,36,80.4,80.4v55.9C336.4,202.8,300.4,238.8,256,238.8z"
      />
      <path
        fill="#f29f18"
        d="M255.8,22h0.1c-4.2,0-8.2,0.4-12.2,1c38.6,5.9,68.3,39.3,68.3,79.5v55.9
		c0,40.3-29.6,73.7-68.2,79.6c4,0.6,8.1,1,12.2,1h-0.2c44.4,0,80.2-36.2,80.2-80.6v-55.9C336,58.1,300.2,22,255.8,22z"
      />
      <rect width="9.8" height="9.8" x="344.3" y="125.7" fill="#734b0b" />
      <rect width="9.8" height="9.8" x="157.9" y="125.7" fill="#734b0b" />
      <path
        fill="#595959"
        d="M193.2 16.7L193.2 16.7l0 71c0 10.2-8.3 18.5-18.5 18.5h-12.4V47.5C162.4 30.5 176.2 16.7 193.2 16.7zM318.4 16.7L318.4 16.7l0 71c0 10.2 8.3 18.5 18.5 18.5h12.4V47.5C349.2 30.5 335.4 16.7 318.4 16.7z"
      />
      <path
        fill="#017068"
        d="M201.4,4.9h108.8c21.5,0,39,17.5,39,39v44.9H162.4V43.9C162.4,22.4,179.9,4.9,201.4,4.9z"
      />
      <rect width="25" height="10" x="211" y="115" fill="#595959" />
      <rect width="10" height="19" x="231" y="135" fill="#595959" />
      <rect width="25" height="10" x="276" y="115" fill="#595959" />
      <rect width="10" height="19" x="271" y="135" fill="#595959" />
      <path
        fill="#ebdee5"
        d="M222.3 178.9l-7.9 5.8-27-36.9-30.1-41.1c1.8-.4 3.7-.7 5.6-.7h6.1l18.4 25.2L222.3 178.9zM354.8 106.7l-30.1 41.1-27 36.9-7.9-5.8 34.9-47.7 18.4-25.2h6.1C351.1 106 353 106.3 354.8 106.7z"
      />
      <path
        fill="#00bfb6"
        d="M176.7,171.6c6.3,38.1,39.4,67.2,79.3,67.2l0,0c39.9,0,73-29.1,79.3-67.2H176.7z"
      />
      <path
        fill="#595959"
        d="M376.6,287.8v101.6h9.8v-95.9C383.2,291.5,379.9,289.6,376.6,287.8z"
      />
      <circle cx="381.5" cy="407.5" r="26" fill="#fff" />
      <rect width="9.8" height="26" x="106.2" y="400.9" fill="#ebdee5" />
      <rect width="9.8" height="26" x="144.9" y="400.9" fill="#ebdee5" />
      <path
        fill="#ebdee5"
        d="M389.6,382.8c0.8,2.5,1.3,5.2,1.3,8.1c0,14.4-11.6,26-26,26c-2.8,0-5.5-0.5-8.1-1.3
		c3.4,10.4,13.2,18,24.7,18c14.4,0,26-11.6,26-26C407.5,396,400,386.2,389.6,382.8z"
      />
      <rect width="9.8" height="9.8" x="376.6" y="402.6" fill="#c6bec3" />
      <path
        fill="#00bfb6"
        d="M200.7,4.9h77c21.1,0,38.3,17.1,38.3,38.3v0c0,16.9-13.7,30.7-30.7,30.7H162.4V43.2
		C162.4,22,179.5,4.9,200.7,4.9z"
      />
      <path
        fill="#3dcac3"
        d="M250.6,37.2h-49.4c-6.5,0-11.7-5.2-11.7-11.7v0c0-6.5,5.2-11.7,11.7-11.7h49.4
		c6.5,0,11.7,5.2,11.7,11.7v0C262.2,32,257,37.2,250.6,37.2z"
      />
      <path
        fill="#017068"
        d="M256,171.6l5.3,5.3c1.7,1.7,1.7,4.5,0,6.2l-3.8,3.8c-0.8,0.8-2,1.3-3.1,1.3H228
		c-2.4,0-4.4,2-4.4,4.4v1c0,2.4,2,4.4,4.4,4.4h55.9c2.4,0,4.4,2,4.4,4.4v0c0,2.4-2,4.4-4.4,4.4h-28h-28c-2.4,0-4.4,2-4.4,4.4v1
		c0,2.4,2,4.4,4.4,4.4h36c1.2,0,2.3,0.5,3.1,1.3l0.4,0.4c1.7,1.7,1.7,4.5,0,6.2L257.3,235c-0.8,0.8-1.3,1.9-1.3,3.1v0.7
		c39.9,0,73-29.1,79.3-67.2H256z"
      />
      <rect width="10" height="27" x="251" y="33" fill="#f22e24" />
      <rect width="27" height="10" x="242" y="42" fill="#f22e24" />
    </svg>
  );
};

export const PatientIcon = () => {
  return (
    <svg
      height="34"
      viewBox="0 0 117 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.5 107.859C85.7604 107.859 107.859 85.7604 107.859 58.5C107.859 31.2396 85.7604 9.14062 58.5 9.14062C31.2396 9.14062 9.14062 31.2396 9.14062 58.5C9.14062 85.7604 31.2396 107.859 58.5 107.859Z"
        fill="#E6E7E8"
      />
      <path
        d="M73.8563 105.41C64.388 108.506 54.2045 108.664 44.6444 105.865C35.0843 103.065 26.5949 97.4386 20.2922 89.7244C23.2137 87.0843 27.0125 85.6247 30.9502 85.6294H56.0869C59.4947 85.6268 62.813 86.7202 65.5518 88.748C68.2906 90.7757 70.3048 93.6305 71.2969 96.8906L73.8563 105.41Z"
        fill="#2A292A"
      />
      <path
        d="M50.4928 78.6094V88.1522C50.4941 88.4598 50.4091 88.7616 50.2475 89.0233C50.086 89.2851 49.8543 89.4963 49.5787 89.633L44.2406 92.2289C44.0109 92.3446 43.7574 92.4049 43.5002 92.4049C43.243 92.4049 42.9895 92.3446 42.7598 92.2289L37.44 89.5781C37.1644 89.4414 36.9327 89.2302 36.7711 88.9685C36.6096 88.7067 36.5246 88.4049 36.5259 88.0973V78.6094C36.5259 78.173 36.6992 77.7545 37.0078 77.446C37.3164 77.1374 37.7348 76.9641 38.1712 76.9641H48.8292C49.0468 76.9616 49.2627 77.0024 49.4644 77.084C49.6662 77.1656 49.8497 77.2864 50.0044 77.4395C50.1591 77.5925 50.282 77.7747 50.3658 77.9755C50.4496 78.1763 50.4928 78.3918 50.4928 78.6094Z"
        fill="#FFD2B4"
      />
      <path
        opacity="0.1"
        d="M50.4928 85.6294V88.0973C50.4907 88.4018 50.4041 88.6997 50.2427 88.9579C50.0813 89.2162 49.8515 89.4245 49.5787 89.5598L44.2406 92.2472C44.0137 92.3613 43.7633 92.4208 43.5093 92.4208C43.2554 92.4208 43.0049 92.3613 42.7781 92.2472L37.44 89.5781C37.1672 89.4428 36.9373 89.2344 36.7759 88.9762C36.6146 88.718 36.528 88.4201 36.5259 88.1156V85.6294H33.0525V88.0973C33.0467 89.051 33.3093 89.987 33.8104 90.7985C34.3115 91.6099 35.0308 92.264 35.8861 92.6859L41.2059 95.355C41.9216 95.7109 42.71 95.8961 43.5093 95.8961C44.3086 95.8961 45.0971 95.7109 45.8128 95.355L51.1875 92.6859C52.0427 92.264 52.762 91.6099 53.2631 90.7985C53.7642 89.987 54.0268 89.051 54.0211 88.0973V85.6294H50.4928Z"
        fill="white"
      />
      <path
        d="M43.5093 35.4291C63.4725 35.4291 61.7906 54.2405 61.7906 54.2405C64.7156 53.9297 67.019 55.0997 67.019 59.2313C67.019 63.3628 65.1909 64.2038 62.924 64.4414C62.7994 64.446 62.6811 64.4975 62.593 64.5857C62.5048 64.6738 62.4533 64.7921 62.4487 64.9167C61.7723 71.3517 57.2203 76.0683 52.7231 79.2127C50.0292 81.1113 46.8142 82.1304 43.5185 82.1304C40.2228 82.1304 37.0077 81.1113 34.3139 79.2127C29.835 76.05 25.2647 71.3335 24.5883 64.9167C24.5837 64.7921 24.5322 64.6738 24.444 64.5857C24.3558 64.4975 24.2376 64.446 24.1129 64.4414C21.8278 64.2038 20.0179 63.3446 20.0179 59.2313C20.0179 55.118 22.23 53.9297 25.155 54.2405C25.155 54.2405 23.5279 35.4291 43.5093 35.4291Z"
        fill="#FFD2B4"
      />
      <path
        opacity="0.1"
        d="M50.4928 80.5472V83.1614C48.3195 84.2173 45.9347 84.7659 43.5185 84.7659C41.1022 84.7659 38.7175 84.2173 36.5442 83.1614V80.5472C38.7175 81.6031 41.1022 82.1517 43.5185 82.1517C45.9347 82.1517 48.3195 81.6031 50.4928 80.5472Z"
        fill="#262234"
      />
      <path
        d="M36.6173 60.9497C38.253 60.9497 39.5789 59.6237 39.5789 57.9881C39.5789 56.3525 38.253 55.0266 36.6173 55.0266C34.9817 55.0266 33.6558 56.3525 33.6558 57.9881C33.6558 59.6237 34.9817 60.9497 36.6173 60.9497Z"
        fill="#262234"
      />
      <path
        d="M50.4197 60.9497C52.0553 60.9497 53.3813 59.6237 53.3813 57.9881C53.3813 56.3525 52.0553 55.0266 50.4197 55.0266C48.7841 55.0266 47.4581 56.3525 47.4581 57.9881C47.4581 59.6237 48.7841 60.9497 50.4197 60.9497Z"
        fill="#262234"
      />
      <path
        d="M63.5639 44.1309C63.4775 42.6857 63.2197 41.2558 62.796 39.8714C63.3516 37.5238 63.4571 35.0921 63.1068 32.7051C63.0684 32.5228 62.9912 32.3509 62.8805 32.2011C62.7697 32.0513 62.628 31.927 62.465 31.8368C62.302 31.7467 62.1214 31.6926 61.9357 31.6784C61.7499 31.6642 61.5632 31.6902 61.3884 31.7545C60.9679 31.9191 60.5292 32.047 60.0721 32.1933C60.1519 31.5376 60.1519 30.8746 60.0721 30.2189C60.0429 30.0181 59.9683 29.8267 59.854 29.6591C59.7397 29.4915 59.5886 29.3522 59.4124 29.2517C59.2361 29.1513 59.0393 29.0923 58.8368 29.0793C58.6344 29.0664 58.4316 29.0997 58.244 29.1769C53.7177 30.6125 49.0213 31.4423 44.2771 31.6448H43.5093C32.8879 31.6448 24.2592 32.175 23.4 44.1309C23.2274 47.3468 23.3498 50.5716 23.7656 53.7651C23.8464 55.3657 24.0296 56.9594 24.314 58.5366C24.6248 59.798 27.9703 59.7431 28.1165 58.5366C28.2628 57.33 27.5315 51.2241 30.5114 45.7397C34.6926 47.2519 39.1192 47.9711 43.5642 47.8603C47.9869 47.9494 52.3878 47.218 56.5439 45.7031C59.5237 51.3155 58.7742 57.6042 58.9387 58.5C59.1032 59.3958 62.4487 59.67 62.7412 58.5C62.9968 57.0922 63.1617 55.6694 63.2348 54.2405C63.6627 50.8885 63.7729 47.5036 63.5639 44.1309Z"
        fill="#2A292A"
      />
      <path
        d="M50.2552 65.6297C50.5166 65.6432 50.7721 65.7127 51.0043 65.8334C51.2366 65.9542 51.4402 66.1234 51.6014 66.3297C51.7626 66.5359 51.8776 66.7744 51.9387 67.029C51.9997 67.2835 52.0054 67.5482 51.9553 67.8052C51.4739 69.6794 50.3827 71.3402 48.8536 72.5261C47.3245 73.7121 45.4444 74.3557 43.5094 74.3557C41.5743 74.3557 39.6942 73.7121 38.1651 72.5261C36.6361 71.3402 35.5449 69.6794 35.0634 67.8052C35.0134 67.5482 35.019 67.2835 35.0801 67.029C35.1412 66.7744 35.2562 66.5359 35.4174 66.3297C35.5786 66.1234 35.7822 65.9542 36.0144 65.8334C36.2467 65.7127 36.5022 65.6432 36.7636 65.6297H50.2552Z"
        fill="#691C24"
      />
      <path
        d="M47.7323 73.253C46.4382 73.9635 44.9857 74.3359 43.5093 74.3359C42.033 74.3359 40.5805 73.9635 39.2864 73.253C39.6337 71.1141 41.3887 70.5108 43.5093 70.5108C45.63 70.5108 47.385 71.1141 47.7323 73.253Z"
        fill="#BE1E2D"
      />
      <path
        d="M48.5184 65.6297V67.2933C48.5185 67.4599 48.4536 67.6199 48.3375 67.7394C48.2214 67.8589 48.0633 67.9284 47.8968 67.9331H39.1401C38.9736 67.9284 38.8155 67.8589 38.6995 67.7394C38.5834 67.6199 38.5185 67.4599 38.5186 67.2933V65.6297H48.5184Z"
        fill="white"
      />
      <path
        d="M105.446 40.5661H77.8964C76.3512 40.5709 74.8707 41.1869 73.7781 42.2795C72.6855 43.3721 72.0695 44.8526 72.0647 46.3978V63.3994C72.0726 64.9012 72.6579 66.3425 73.6993 67.4247C74.7406 68.5069 76.1583 69.1471 77.6588 69.2128L76.1049 76.1597C76.0306 76.5231 76.0687 76.9005 76.2139 77.2418C76.3592 77.583 76.6049 77.872 76.9183 78.0704C77.2317 78.2687 77.598 78.3671 77.9687 78.3523C78.3393 78.3376 78.6966 78.2105 78.9933 77.9878L90.3642 69.2311H105.465C107.01 69.2263 108.49 68.6103 109.583 67.5177C110.675 66.4251 111.291 64.9446 111.296 63.3994V46.3978C111.291 44.8495 110.673 43.3662 109.576 42.2731C108.48 41.1799 106.995 40.5661 105.446 40.5661Z"
        fill="#39B54A"
      />
      <path
        d="M89.5781 62.5401C89.2407 62.5537 88.9041 62.4974 88.5895 62.3747C88.2749 62.252 87.9891 62.0656 87.75 61.8272L81.772 55.8492C81.309 55.3862 81.0488 54.7582 81.0488 54.1033C81.0488 53.4485 81.309 52.8205 81.772 52.3575C82.235 51.8945 82.863 51.6343 83.5178 51.6343C84.1727 51.6343 84.8007 51.8945 85.2637 52.3575L89.5781 56.5805L98.152 48.0065C98.3813 47.7773 98.6534 47.5954 98.953 47.4713C99.2526 47.3472 99.5736 47.2834 99.8978 47.2834C100.222 47.2834 100.543 47.3472 100.843 47.4713C101.142 47.5954 101.414 47.7773 101.644 48.0065C101.873 48.2358 102.055 48.508 102.179 48.8076C102.303 49.1071 102.367 49.4282 102.367 49.7524C102.367 50.0766 102.303 50.3977 102.179 50.6973C102.055 50.9968 101.873 51.269 101.644 51.4983L91.3148 61.8272C90.8524 62.2843 90.2283 62.5405 89.5781 62.5401Z"
        fill="white"
      />
    </svg>
  );
};

export const ReadMoreButtonIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.567 3.22775C11.7184 3.31784 11.8434 3.44634 11.9292 3.60025C12.015 3.75416 12.0586 3.928 12.0556 4.10419C12.0526 4.28037 12.0031 4.45263 11.9121 4.60353C11.8211 4.75444 11.6919 4.87862 11.5375 4.9635L7.51835 7.17251C7.36471 7.25776 7.19133 7.30103 7.01565 7.29796C6.83997 7.29488 6.6682 7.24558 6.51764 7.155C6.36708 7.06443 6.24305 6.93578 6.15802 6.78202C6.073 6.62826 6.02999 6.45481 6.03332 6.27914L6.11073 1.72579C6.11337 1.55011 6.16225 1.37822 6.25245 1.22744C6.34265 1.07666 6.47099 0.952301 6.62454 0.866896C6.77809 0.781491 6.95144 0.738052 7.12712 0.740952C7.3028 0.743852 7.47461 0.792989 7.62526 0.883416L11.567 3.22775Z"
        fill="#208CE1"
      />
    </svg>
  );
};

export const Eye = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 1792 1792"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1664 960C1562.67 802.667 1435.67 685 1283 607C1323.67 676.333 1344 751.333 1344 832C1344 955.333 1300.17 1060.83 1212.5 1148.5C1124.83 1236.17 1019.33 1280 896 1280C772.667 1280 667.167 1236.17 579.5 1148.5C491.833 1060.83 448 955.333 448 832C448 751.333 468.333 676.333 509 607C356.333 685 229.333 802.667 128 960C216.667 1096.67 327.833 1205.5 461.5 1286.5C595.167 1367.5 740 1408 896 1408C1052 1408 1196.83 1367.5 1330.5 1286.5C1464.17 1205.5 1575.33 1096.67 1664 960ZM944 576C944 562.667 939.333 551.333 930 542C920.667 532.667 909.333 528 896 528C812.667 528 741.167 557.833 681.5 617.5C621.833 677.167 592 748.667 592 832C592 845.333 596.667 856.667 606 866C615.333 875.333 626.667 880 640 880C653.333 880 664.667 875.333 674 866C683.333 856.667 688 845.333 688 832C688 774.667 708.333 725.667 749 685C789.667 644.333 838.667 624 896 624C909.333 624 920.667 619.333 930 610C939.333 600.667 944 589.333 944 576ZM1792 960C1792 982.667 1785.33 1005.67 1772 1029C1678.67 1182.33 1553.17 1305.17 1395.5 1397.5C1237.83 1489.83 1071.33 1536 896 1536C720.667 1536 554.167 1489.67 396.5 1397C238.833 1304.33 113.333 1181.67 20 1029C6.66667 1005.67 0 982.667 0 960C0 937.333 6.66667 914.333 20 891C113.333 738.333 238.833 615.667 396.5 523C554.167 430.333 720.667 384 896 384C1071.33 384 1237.83 430.333 1395.5 523C1553.17 615.667 1678.67 738.333 1772 891C1785.33 914.333 1792 937.333 1792 960Z"
        fill="black"
      />
    </svg>
  );
};
export const EyeClosed = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 1792 1792"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M555 1335L633 1194C575 1152 529.667 1099 497 1035C464.333 971 448 903.333 448 832C448 751.333 468.333 676.333 509 607C356.333 685 229.333 802.667 128 960C239.333 1132 381.667 1257 555 1335ZM944 576C944 562.667 939.333 551.333 930 542C920.667 532.667 909.333 528 896 528C812.667 528 741.167 557.833 681.5 617.5C621.833 677.167 592 748.667 592 832C592 845.333 596.667 856.667 606 866C615.333 875.333 626.667 880 640 880C653.333 880 664.667 875.333 674 866C683.333 856.667 688 845.333 688 832C688 774.667 708.333 725.667 749 685C789.667 644.333 838.667 624 896 624C909.333 624 920.667 619.333 930 610C939.333 600.667 944 589.333 944 576ZM1307 385C1307 389.667 1306.67 392.667 1306 394C1236 519.333 1131 708 991 960C851 1212 745.667 1401 675 1527L626 1616C619.333 1626.67 610 1632 598 1632C590 1632 545.333 1608.67 464 1562C453.333 1555.33 448 1546 448 1534C448 1526 462.667 1497 492 1447C396.667 1403.67 308.833 1346 228.5 1274C148.167 1202 78.6667 1120.33 20 1029C6.66667 1008.33 0 985.333 0 960C0 934.667 6.66667 911.667 20 891C122 734.333 248.667 610.667 400 520C551.333 429.333 716.667 384 896 384C955.333 384 1015.33 389.667 1076 401L1130 304C1136.67 293.333 1146 288 1158 288C1161.33 288 1167.33 290 1176 294C1184.67 298 1195 303.167 1207 309.5C1219 315.833 1230 322 1240 328C1250 334 1260.5 340.167 1271.5 346.5C1282.5 352.833 1289 356.667 1291 358C1301.67 364.667 1307 373.667 1307 385ZM1344 832C1344 924.667 1317.67 1009.17 1265 1085.5C1212.33 1161.83 1142.67 1216.67 1056 1250L1336 748C1341.33 778 1344 806 1344 832ZM1792 960C1792 983.333 1785.33 1006.33 1772 1029C1746 1071.67 1709.67 1120 1663 1174C1563 1288.67 1447.17 1377.67 1315.5 1441C1183.83 1504.33 1044 1536 896 1536L970 1404C1111.33 1392 1242.17 1346.33 1362.5 1267C1482.83 1187.67 1583.33 1085.33 1664 960C1587.33 840.667 1493.33 742.667 1382 666L1445 554C1508.33 596.667 1569.17 647.667 1627.5 707C1685.83 766.333 1734 827.667 1772 891C1785.33 913.667 1792 936.667 1792 960Z"
        fill="black"
      />
    </svg>
  );
};
export const HeaderTriangle = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 31 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_101_3)">
        <path d="M3.875 23.25H27.125L15.5 5.8125L3.875 23.25Z" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_d_101_3"
          x="0.875"
          y="0.8125"
          width="29.25"
          height="23.4375"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_101_3"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_101_3"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const RpmStatusTriangle = ({ variant, size, direction }) => {
  // console.log("variant :",variant)
  let params = {
    color:
      variant === "normal" || variant === "Normal"
        ? "#4AD395"
        : variant === "Abnormal" || variant === "abnormal"
        ? "#F1BC2C"
        : variant === "Critical" || variant === "critical"
        ? "#CB2027"
        : "#949494",
    size: size ? size : "15",
    direction:
      direction === "right"
        ? "90deg"
        : direction === "down"
        ? "180deg"
        : direction === "left"
        ? "270deg"
        : direction === "up"
        ? "0deg"
        : "0deg",
  };

  return (
    <svg
      width={params.size}
      viewBox="0 0 31.955 31.955"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={params.color}
        d="M27.25,4.655C20.996-1.571,10.88-1.546,4.656,4.706C-1.571,10.96-1.548,21.076,4.705,27.3
		c6.256,6.226,16.374,6.203,22.597-0.051C33.526,20.995,33.505,10.878,27.25,4.655z"
      />
      <path
        fill={params.color}
        d="M13.288,23.896l-1.768,5.207c2.567,0.829,5.331,0.886,7.926,0.17l-0.665-5.416
		C17.01,24.487,15.067,24.5,13.288,23.896z M8.12,13.122l-5.645-0.859c-0.741,2.666-0.666,5.514,0.225,8.143l5.491-1.375
		C7.452,17.138,7.426,15.029,8.12,13.122z M28.763,11.333l-4.965,1.675c0.798,2.106,0.716,4.468-0.247,6.522l5.351,0.672
		C29.827,17.319,29.78,14.193,28.763,11.333z M11.394,2.883l1.018,5.528c2.027-0.954,4.356-1.05,6.442-0.288l1.583-5.137
		C17.523,1.94,14.328,1.906,11.394,2.883z"
      />
      <circle fill={params.color} cx="15.979" cy="15.977" r="6.117" />
    </svg>
  );
};

export const CheckGreen = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2L8 14L2 8.00027"
        stroke="#128311"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseRed = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.84166 8.5L15.8792 2.4625C16.2625 2.07916 16.2625 1.50417 15.8792 1.12083C15.4958 0.737499 14.9208 0.737499 14.5375 1.12083L8.49999 7.15833L2.46249 1.12083C2.07916 0.737499 1.50416 0.737499 1.12083 1.12083C0.737495 1.50417 0.737495 2.07916 1.12083 2.4625L7.15833 8.5L1.12083 14.5375C0.929162 14.7292 0.833328 14.9208 0.833328 15.2083C0.833328 15.7833 1.21666 16.1667 1.79166 16.1667C2.07916 16.1667 2.27083 16.0708 2.46249 15.8792L8.49999 9.84166L14.5375 15.8792C14.7292 16.0708 14.9208 16.1667 15.2083 16.1667C15.4958 16.1667 15.6875 16.0708 15.8792 15.8792C16.2625 15.4958 16.2625 14.9208 15.8792 14.5375L9.84166 8.5Z"
        fill="#CD574B"
      />
    </svg>
  );
};
export const AddUserIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 6H20V5C20 4.73479 19.8946 4.48043 19.7071 4.2929C19.5196 4.10536 19.2652 4 19 4C18.7348 4 18.4804 4.10536 18.2929 4.2929C18.1054 4.48043 18 4.73479 18 5V6H17C16.7348 6 16.4804 6.10536 16.2929 6.2929C16.1054 6.48043 16 6.73479 16 7C16 7.26522 16.1054 7.51957 16.2929 7.70711C16.4804 7.89464 16.7348 8 17 8H18V9C18 9.26522 18.1054 9.51957 18.2929 9.70711C18.4804 9.89464 18.7348 10 19 10C19.2652 10 19.5196 9.89464 19.7071 9.70711C19.8946 9.51957 20 9.26522 20 9V8H21C21.2652 8 21.5196 7.89464 21.7071 7.70711C21.8946 7.51957 22 7.26522 22 7C22 6.73479 21.8946 6.48043 21.7071 6.2929C21.5196 6.10536 21.2652 6 21 6ZM10 11C10.7911 11 11.5645 10.7654 12.2223 10.3259C12.8801 9.88635 13.3928 9.26164 13.6955 8.53074C13.9983 7.79983 14.0775 6.99556 13.9231 6.21964C13.7688 5.44372 13.3878 4.73098 12.8284 4.17157C12.269 3.61216 11.5563 3.2312 10.7804 3.07686C10.0044 2.92252 9.20017 3.00173 8.46927 3.30448C7.73836 3.60723 7.11365 4.11992 6.67412 4.77772C6.2346 5.43552 6 6.20888 6 7C6 8.06087 6.42143 9.07828 7.17157 9.82843C7.92172 10.5786 8.93913 11 10 11ZM16 21C16.2652 21 16.5196 20.8946 16.7071 20.7071C16.8946 20.5196 17 20.2652 17 20C17 18.1435 16.2625 16.363 14.9497 15.0503C13.637 13.7375 11.8565 13 10 13C8.14348 13 6.36301 13.7375 5.05025 15.0503C3.7375 16.363 3 18.1435 3 20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21"
        fill="black"
      />
    </svg>
  );
};
export const GenderMale = ({ isActive }) => {
  const getColor = () => (isActive ? "#FFFFFF" : "#ACACAC");

  return (
    <svg
      width="17"
      height="28"
      viewBox="0 0 17 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5498 0.666672C4.1378 0.666672 0.549805 4.25467 0.549805 8.66667C0.549805 12.6227 3.43914 15.9093 7.21647 16.5467V20.6667H3.21647V23.3333H7.21647V27.3173H9.88314V23.3333H13.8831V20.6667H9.88314V16.5467C13.6605 15.908 16.5498 12.6227 16.5498 8.66667C16.5498 4.25467 12.9618 0.666672 8.5498 0.666672ZM8.5498 14C5.60847 14 3.21647 11.608 3.21647 8.66667C3.21647 5.72534 5.60847 3.33334 8.5498 3.33334C11.4911 3.33334 13.8831 5.72534 13.8831 8.66667C13.8831 11.608 11.4911 14 8.5498 14Z"
        fill={getColor()}
      />
    </svg>
  );
};
export const GenderFeMale = ({ isActive }) => {
  const getColor = () => (isActive ? "#FFFFFF" : "#ACACAC");

  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2163 9.66666V0.333328H14.883L18.607 4.05733L12.8443 9.81999C11.4948 8.85328 9.87638 8.33341 8.21631 8.33333C3.80431 8.33333 0.216309 11.9213 0.216309 16.3333C0.216309 20.7453 3.80431 24.3333 8.21631 24.3333C12.6283 24.3333 16.2163 20.7453 16.2163 16.3333C16.2163 14.608 15.6616 13.0133 14.7296 11.7053L20.4923 5.94266L24.2163 9.66666ZM8.21631 21.6667C5.27498 21.6667 2.88298 19.2747 2.88298 16.3333C2.88298 13.392 5.27498 11 8.21631 11C11.1576 11 13.5496 13.392 13.5496 16.3333C13.5496 19.2747 11.1576 21.6667 8.21631 21.6667Z"
        fill={getColor()}
      />
    </svg>
  );
};
export const GenderOther = ({ isActive }) => {
  const getColor = () => (isActive ? "#FFFFFF" : "#ACACAC");

  return (
    <svg
      width="27"
      height="17"
      viewBox="0 0 27 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2165 8.66667H8.21647M12.2165 8.66667C12.2165 10.4348 12.9189 12.1305 14.1691 13.3807C15.4193 14.631 17.115 15.3333 18.8831 15.3333C20.6512 15.3333 22.3469 14.631 23.5972 13.3807C24.8474 12.1305 25.5498 10.4348 25.5498 8.66667C25.5498 6.89856 24.8474 5.20286 23.5972 3.95262C22.3469 2.70238 20.6512 2 18.8831 2C17.115 2 15.4193 2.70238 14.1691 3.95262C12.9189 5.20286 12.2165 6.89856 12.2165 8.66667V8.66667ZM8.21647 8.66667L1.5498 3.33333V14L8.21647 8.66667Z"
        stroke={getColor()}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BlackAdd = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 10H2"
        stroke="#18191F"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M10 2L10 18"
        stroke="#18191F"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const BlueAdd = ({ isSelected, white, scale }) => {
  let getColor = white ? "#fff" : isSelected ? "#699BF7" : "#699BF7";
  let size = scale ? 15 * scale : 15;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 10H1.5"
        stroke={getColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M9.5 2V18"
        stroke={getColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ClockSmall = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_301_5)">
        <path
          d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9966 8.81846 22.7312 5.76821 20.4815 3.51852C18.2318 1.26883 15.1815 0.00344108 12 0ZM12 22C10.0222 22 8.08879 21.4135 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92893C6.32746 3.53041 8.10929 2.578 10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.7612C17.6541 3.51808 19.2159 4.79981 20.3147 6.4443C21.4135 8.08879 22 10.0222 22 12C21.9971 14.6513 20.9426 17.1931 19.0679 19.0679C17.1931 20.9426 14.6513 21.9971 12 22Z"
          fill="#699BF7"
        />
        <path
          d="M17.515 14.143L13 11.434V6C13 5.73478 12.8946 5.48043 12.7071 5.29289C12.5196 5.10536 12.2652 5 12 5C11.7348 5 11.4804 5.10536 11.2929 5.29289C11.1054 5.48043 11 5.73478 11 6V12C11.0067 12.1712 11.0542 12.3382 11.1386 12.4873C11.223 12.6364 11.3417 12.7631 11.485 12.857L16.485 15.857C16.5976 15.9275 16.7231 15.9748 16.8542 15.9962C16.9853 16.0176 17.1194 16.0127 17.2486 15.9818C17.3778 15.9508 17.4995 15.8944 17.6066 15.8159C17.7138 15.7373 17.8042 15.6382 17.8726 15.5244C17.941 15.4105 17.9861 15.2842 18.0051 15.1527C18.0242 15.0212 18.0169 14.8873 17.9836 14.7587C17.9503 14.6301 17.8917 14.5094 17.8112 14.4037C17.7308 14.298 17.6301 14.2094 17.515 14.143Z"
          fill="#699BF7"
        />
      </g>
      <defs>
        <clipPath id="clip0_301_5">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ResetIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.578 6.48708C4.55072 4.80829 6.1004 3.54022 7.93848 2.91898C9.77657 2.29773 11.7778 2.36566 13.5695 3.11011C15.3613 3.85456 16.8214 5.22479 17.678 6.96568C18.5347 8.70656 18.7294 10.6994 18.2261 12.5732C17.7227 14.447 16.5556 16.0741 14.9419 17.1514C13.3282 18.2286 11.378 18.6828 9.45441 18.4292C7.53082 18.1756 5.76494 17.2316 4.48557 15.7729C3.20621 14.3142 2.50055 12.4403 2.5 10.5001"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 6.5H3.5V2.5"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
